export default {
  10000000: 'Pet Care/Food',
  10000002: 'Fruit – Unprepared/Unprocessed (Frozen)',
  10000003: 'Fruit – Unprepared/Unprocessed (Shelf Stable)',
  10000005: 'Vegetables – Unprepared/Unprocessed (Frozen)',
  10000006: 'Vegetables – Unprepared/Unprocessed (Shelf Stable)',
  10000007: 'Nuts/Seeds – Unprepared/Unprocessed (Perishable)',
  10000008: 'Nuts/Seeds – Unprepared/Unprocessed (Shelf Stable)',
  10000016: 'Fish – Prepared/Processed (Perishable)',
  10000017: 'Fish – Prepared/Processed (Frozen)',
  10000018: 'Fish – Prepared/Processed (Shelf Stable)',
  10000019: 'Shellfish – Unprepared/Unprocessed (Perishable)',
  10000020: 'Shellfish – Unprepared/Unprocessed (Frozen)',
  10000021: 'Shellfish – Unprepared/Unprocessed (Shelf Stable)',
  10000025: 'Milk (Perishable)',
  10000026: 'Milk (Shelf Stable)',
  10000027: 'Milk (Frozen)',
  10000028: 'Cheese (Perishable)',
  10000029: 'Cheese (Shelf Stable)',
  10000030: 'Cheese (Frozen)',
  10000040: 'Oils Edible – Vegetable or Plant (Shelf Stable)',
  10000041: 'Fats Edible – Animal (Perishable)',
  10000042: 'Fats Edible – Vegetable/Plant (Shelf Stable)',
  10000043: 'Sugar/Sugar Substitutes (Shelf Stable)',
  10000044: 'Syrup/Treacle/Molasses (Shelf Stable)',
  10000045: 'Chocolate and Chocolate/Sugar Candy Combinations – Confectionery',
  10000047: 'Sugar Candy/Sugar Candy Substitutes Confectionery',
  10000048: 'Herbs/Spices (Perishable)',
  10000049: 'Herbs/Spices (Shelf Stable)',
  10000050: 'Extracts/Salt/Meat Tenderisers (Shelf Stable)',
  10000051: 'Vinegars',
  10000052: 'Cooking Wines',
  10000054:
    'Other Sauces Dipping/Condiments/Savoury Toppings/Savoury Spreads/Marinades (Perishable)',
  10000055: 'Sauces – Cooking (Perishable)',
  10000056: 'Sauces – Cooking (Frozen)',
  10000057: 'Sauces – Cooking (Shelf Stable)',
  10000064: 'Pate (Perishable)',
  10000068: 'Baking/Cooking Mixes (Perishable)',
  10000069: 'Baking/Cooking Supplies (Perishable)',
  10000104: 'Baby/Infant – Specialised Foods (Shelf Stable)',
  10000105: 'Baby/Infant – Specialised Beverages (Shelf Stable)',
  10000111: 'Coffee – Beans/Ground',
  10000114: 'Coffee – Ready to Drink',
  10000115: 'Coffee – Instant',
  10000116: 'Tea – Bags/Loose',
  10000117: 'Tea – Instant',
  10000118: 'Tea – Ready to Drink',
  10000119: 'Fruit Herbal Infusions – Bags/Loose',
  10000134: 'Tobacco – Chewing/Snuff',
  10000137: 'Aquatic Plants Unprepared/Unprocessed (Perishable)',
  10000138: 'Aquatic Plants Unprepared/Unprocessed (Frozen)',
  10000139: 'Aquatic Plants Unprepared/Unprocessed (Shelf Stable)',
  10000142: 'Alcohol Making Kits',
  10000143: 'Alcohol Making Supplies',
  10000144: 'Alcoholic Pre-mixed Drinks',
  10000145: 'Aquatic Invertebrates – Prepared/Processed (Frozen)',
  10000146: 'Aquatic Invertebrates – Prepared/Processed (Perishable)',
  10000147: 'Aquatic Invertebrates – Prepared/Processed (Shelf Stable)',
  10000148: 'Aquatic Invertebrates – Unprepared/Unprocessed (Frozen)',
  10000149: 'Aquatic Invertebrates – Unprepared/Unprocessed (Perishable)',
  10000150: 'Aquatic Invertebrates – Unprepared/Unprocessed (Shelf Stable)',
  10000151: 'Aquatic Plants Prepared/Processed (Frozen)',
  10000152: 'Aquatic Plants Prepared/Processed (Perishable)',
  10000153: 'Aquatic Plants Prepared/Processed (Shelf Stable)',
  10000155: 'Baking/Cooking Mixes (Frozen)',
  10000156: 'Baking/Cooking Mixes (Shelf Stable)',
  10000157: 'Baking/Cooking Supplies (Frozen)',
  10000158: 'Baking/Cooking Supplies (Shelf Stable)',
  10000159: 'Beer',
  10000160: 'Biscuits/Cookies (Perishable)',
  10000161: 'Biscuits/Cookies (Shelf Stable)',
  10000163: 'Bread (Frozen)',
  10000164: 'Bread (Perishable)',
  10000165: 'Bread (Shelf Stable)',
  10000166: 'Dried Breads (Shelf Stable)',
  10000167: 'Butter (Frozen)',
  10000168: 'Butter (Perishable)',
  10000169: 'Butter (Shelf Stable)',
  10000170: 'Cakes – Sweet (Frozen)',
  10000171: 'Cakes – Sweet (Perishable)',
  10000172: 'Cakes – Sweet (Shelf Stable)',
  10000177: 'Chips/Crisps/Snack Mixes – Natural/Extruded (Shelf Stable)',
  10000178: 'Chocolate/Cocoa/Malt – Not Ready to Drink',
  10000179: 'Chocolate/Cocoa/Malt – Ready to Drink',
  10000180: 'Chutneys/Relishes (Shelf Stable)',
  10000181: 'Apple/Pear Alcoholic Beverage – Sparkling',
  10000185: 'Cigarettes',
  10000186: 'Cigars',
  10000187: 'Confectionery Based Spreads (Shelf Stable)',
  10000188: 'Cream (Frozen)',
  10000189: 'Cream (Perishable)',
  10000190: 'Cream (Shelf Stable)',
  10000191: 'Dairy Based Drinks – Ready to Drink (Perishable)',
  10000192: 'Dairy Based Drinks – Ready to Drink (Shelf Stable)',
  10000193: 'Dessert Sauces/Toppings/Fillings (Frozen)',
  10000194: 'Dessert Sauces/Toppings/Fillings (Perishable)',
  10000195: 'Dessert Sauces/Toppings/Fillings (Shelf Stable)',
  10000196: 'Desserts (Frozen)',
  10000197: 'Desserts (Perishable)',
  10000199: 'Dressings/Dips (Perishable)',
  10000200: 'Dressings/Dips (Shelf Stable)',
  10000201: 'Drinks Flavoured – Ready to Drink',
  10000202: 'Drinks Flavoured – Not Ready to Drink',
  10000203: 'Flour – Cereal/Pulse (Shelf Stable)',
  10000204: 'Fruit – Prepared/Processed (Frozen)',
  10000205: 'Fruit – Prepared/Processed (Perishable)',
  10000206: 'Fruit – Prepared/Processed (Shelf Stable)',
  10000207: 'Fruit/Nuts/Seeds Mixes – Prepared/Processed (Shelf Stable)',
  10000210: 'Fruit Herbal Infusions – Instant',
  10000211: 'Grains/Cereal – Not Ready to Eat – (Shelf Stable)',
  10000212: 'Herbs/Spices (Frozen)',
  10000213: 'Honey (Shelf Stable)',
  10000214: 'Ice',
  10000215: 'Ice Cream/Ice Novelties (Frozen)',
  10000216: 'Ice Cream/Ice Novelties (Shelf Stable)',
  10000217: 'Jams/Marmalades (Shelf Stable)',
  10000219: 'Fruit Juice – Ready to Drink (Perishable)',
  10000220: 'Fruit Juice – Ready to Drink (Shelf Stable)',
  10000222: 'Fruit Juice Drinks – Ready to Drink (Perishable)',
  10000223: 'Fruit Juice Drinks – Ready to Drink (Shelf Stable)',
  10000227: 'Liqueurs',
  10000232: 'Packaged Water',
  10000235: 'Nuts/Seeds – Prepared/Processed (Perishable)',
  10000236: 'Nuts/Seeds – Prepared/Processed (Shelf Stable)',
  10000238: 'Olives (Perishable)',
  10000239: 'Olives (Shelf Stable)',
  10000240: 'Pasta/Noodles – Ready to Eat (Perishable)',
  10000241: 'Pasta/Noodles – Ready to Eat (Shelf Stable)',
  10000242: 'Pasta/Noodles – Not Ready to Eat (Shelf Stable)',
  10000244: 'Pickled Vegetables',
  10000245: 'Pies/Pastries – Sweet (Frozen)',
  10000246: 'Pies/Pastries – Sweet (Perishable)',
  10000247: 'Pies/Pastries – Sweet (Shelf Stable)',
  10000248: 'Pies/Pastries/Pizzas/Quiches – Savoury (Frozen)',
  10000249: 'Pies/Pastries/Pizzas/Quiches – Savoury (Perishable)',
  10000250: 'Pies/Pastries/Pizzas/Quiches – Savoury (Shelf Stable)',
  10000252: 'Popcorn (Shelf Stable)',
  10000254: 'Sandwiches/Filled Rolls/Wraps (Frozen)',
  10000255: 'Sandwiches/Filled Rolls/Wraps (Perishable)',
  10000256: 'Shellfish Prepared/Processed (Frozen)',
  10000257: 'Shellfish Prepared/Processed (Perishable)',
  10000258: 'Shellfish Prepared/Processed (Shelf Stable)',
  10000260: 'Soups – Prepared (Frozen)',
  10000261: 'Soups – Prepared (Perishable)',
  10000262: 'Soups – Prepared (Shelf Stable)',
  10000263: 'Spirits',
  10000264: 'Sports Drinks – Rehydration (Not Ready to Drink)',
  10000265: 'Sports Drinks – Rehydration (Ready To Drink)',
  10000266: 'Stimulants/Energy Drinks – Ready to Drink',
  10000267: 'Tobacco – Loose',
  10000268: 'Tobacco – Solid',
  10000270: 'Vegetables – Prepared/Processed (Frozen)',
  10000271: 'Vegetables – Prepared/Processed (Perishable)',
  10000272: 'Vegetables – Prepared/Processed (Shelf Stable)',
  10000273: 'Wine – Fortified',
  10000275: 'Wine – Sparkling',
  10000276: 'Wine – Still',
  10000277: 'Yogurt (Frozen)',
  10000278: 'Yogurt (Perishable)',
  10000279: 'Yogurt (Shelf Stable)',
  10000280:
    'Other Sauces Dipping/Condiments/Savoury Toppings/Savoury Spreads/Marinades (Shelf Stable)',
  10000281: 'Fish – Unprepared/Unprocessed (Frozen)',
  10000282: 'Fish – Unprepared/Unprocessed (Perishable)',
  10000283: 'Fish – Unprepared/Unprocessed (Shelf Stable)',
  10000284: 'Cereals Products – Ready to Eat (Shelf Stable)',
  10000285: 'Cereals Products – Not Ready to Eat (Shelf Stable)',
  10000286: 'Cereal Products – Ready to Eat (Perishable)',
  10000287: 'Cereal/Muesli Bars',
  10000288: 'Vegetable Based Products / Meals – Ready to Eat (Shelf Stable)',
  10000289: 'Vegetable Based Products / Meals – Ready to Eat (Perishable)',
  10000290: 'Vegetable Based Products / Meals – Not Ready to Eat (Perishable)',
  10000291: 'Vegetable Based Products / Meals – Not Ready to Eat (Frozen)',
  10000292:
    'Vegetable Based Products / Meals – Not Ready to Eat (Shelf Stable)',
  10000293:
    'Grain Based Products / Meals – Ready to Eat – Savoury (Perishable)',
  10000294:
    'Grain Based Products / Meals – Ready to Eat – Savoury (Shelf Stable)',
  10000295:
    'Grain Based Products / Meals – Not Ready to Eat – Savoury (Perishable)',
  10000296:
    'Grain Based Products / Meals – Not Ready to Eat – Savoury (Frozen)',
  10000297:
    'Grain Based Products / Meals – Not Ready to Eat – Savoury (Shelf Stable)',
  10000298:
    'Dough Based Products / Meals – Ready to Eat – Savoury (Perishable)',
  10000299:
    'Dough Based Products / Meals – Ready to Eat – Savoury (Shelf Stable)',
  10000300:
    'Dough Based Products / Meals – Not Ready to Eat – Savoury (Perishable)',
  10000301:
    'Dough Based Products / Meals – Not Ready to Eat – Savoury (Frozen)',
  10000302:
    'Dough Based Products / Meals – Not Ready to Eat – Savoury (Shelf Stable)',
  10000303: 'Smoking Accessories',
  10000304: 'Biscuits/Cookies (Frozen)',
  10000305: 'Dried Breads (Frozen)',
  10000306: 'Pate (Shelf Stable)',
  10000307: 'Fruit Juice – Not Ready to Drink (Frozen)',
  10000308: 'Fruit Juice – Not Ready to Drink (Shelf Stable)',
  10000309: 'Fruit Juice Drinks – Not Ready to Drink (Shelf Stable)',
  10000310: 'Dairy Based Drinks – Not Ready to Drink (Shelf Stable)',
  10000311: 'Stimulants/Energy Drinks – Not Ready to Drink',
  10000312: 'Desserts (Shelf Stable)',
  10000313: 'Fruit Herbal Infusions – Ready to Drink',
  10000314: 'Grains/Cereal – Not Ready to Eat – (Frozen)',
  10000315: 'Grains/Cereal – Not Ready to Eat – (Perishable)',
  10000316: 'Grains/Cereal – Ready to Eat – (Perishable)',
  10000317: 'Pasta/Noodles – Not Ready to Eat (Perishable)',
  10000318: 'Pasta/Noodles – Not Ready to Eat (Frozen)',
  10000319: 'Grains/Cereal – Ready to Eat – (Shelf Stable)',
  10000320: 'Feminine Hygiene – Tampons',
  10000321: 'Adult Incontinence – Supplies',
  10000324: 'After Shave Care',
  10000327: 'Anti-spot Aids (Non Powered)',
  10000328: 'Bath Additives',
  10000329: 'Bleaching/Lightening Products',
  10000330: 'Cleansing/Washing/Soap – Body',
  10000332: 'Cleansers/Cosmetics Removers (Non Powered)',
  10000333: 'Nails – Cleansers/Cosmetic Removers',
  10000334: 'Cleansing/Washing Accessories – Personal',
  10000335: 'Cotton Wool Products',
  10000336: 'Denture/Orthodontic – Care',
  10000337: 'Denture/Orthodontic – Cleansing',
  10000338: 'Antiperspirants/Deodorants',
  10000340: 'Depilation/Epilation (Non Powered)',
  10000341: 'Ear/Nasal Care',
  10000342: 'Exfoliants/Masks',
  10000343: 'Hair – False',
  10000344: 'Feminine Hygiene – Accessories',
  10000345: 'Hair – Colour',
  10000346: 'Hair – Conditioner/Treatment',
  10000348: 'Hair – Perming',
  10000349: 'Hair Removal/Shaving – Accessories',
  10000350: 'Hair Removal – Care',
  10000355: 'Sunless Tanning – Topical (Non Powered)',
  10000356: 'Skin Care/Moisturising Products',
  10000358: 'Nails – Aids (Non Powered)',
  10000359: 'Nails – False',
  10000360: 'Cosmetics – Nails',
  10000361: 'Nails – Treatments',
  10000362: 'Nursing Hygiene Accessories',
  10000363: 'Oral Care – Accessories',
  10000365: 'Fragrances',
  10000368: 'Hair – Shampoo',
  10000369: 'Shaving – Blades',
  10000370: 'Shaving – Razors – Disposable (Non Powered)',
  10000373: 'Sun Protection Products',
  10000374: 'Skin Drying Powder',
  10000375: 'Toilet Paper',
  10000376: 'Feminine Hygiene – Towels/Pads',
  10000377: 'Cosmetic Aids/Accessories',
  10000379: 'Hair – Accessories',
  10000381: 'Hair – Styling (Non Powered)',
  10000383: 'Dental Cleansing',
  10000384: 'Oral Care – Aids (Non Powered)',
  10000385: 'Nails – Accessories (Non Powered)',
  10000388: 'Sun Tan Accelerator Products',
  10000397: 'Cleaning Aids',
  10000398: 'Cleaning Accessories',
  10000400: 'Shoe Cleaning/Care Preparations',
  10000402: 'Air Fresheners/Deodorisers (Non Powered)',
  10000405: 'Surface Cleaners',
  10000406: 'Dish Cleaning/Care – Automatic',
  10000411: 'Insect/Pest Control – Barriers/Traps',
  10000423: 'Drain Treatments/Pipe Unblockers',
  10000424: 'Laundry Detergents',
  10000426: 'Toilet Cleaning Products',
  10000427: 'Laundry Colour Care',
  10000432: 'Shoe Colour/Dyes',
  10000433: 'Footwear – Replacement Parts/Accessories',
  10000434: 'Surface Care/Protection',
  10000435: 'Insecticides/Pesticides/Rodenticides',
  10000436: 'Non Personal Repellents',
  10000440: 'Mould/Mildew Removers',
  10000441: 'Disinfectants',
  10000442: 'Descalers',
  10000443: 'Stain Removers',
  10000444: 'Laundry Dry Cleaning',
  10000445: 'Dish Care/Protection',
  10000446: 'Water Softeners',
  10000447: 'Paper Towels',
  10000448: 'First Aid – Dressings/Bandages/Plaster',
  10000449: 'First Aid – Accessories',
  10000450: 'First Aid – Sling/Support',
  10000451: 'Ice/Heated Pack',
  10000452: 'Thermometers',
  10000453: 'Home Diagnostic Tests',
  10000454: 'Home Diagnostic Products – Accessories',
  10000455: 'Home Diagnostic Monitors',
  10000456: 'Drug Administration',
  10000457: 'Drug Administration – Accessories',
  10000458: 'Disability Aids',
  10000459: 'Habit Treatment',
  10000460: 'Condoms',
  10000461: 'Diaphragms/Cervical Caps',
  10000462: 'Spermicides',
  10000463: 'Hormonal Contraception',
  10000464: 'Intra-uterine Contraception',
  10000465: 'Dietary Aid – Appetite/Fat Control',
  10000466: 'Dietary Aid – Meal Replacement',
  10000467: 'Vitamins/Minerals',
  10000468: 'Nutritional Supplements',
  10000474: 'Therapeutic Hosiery',
  10000481: 'Adult Incontinence – Pads',
  10000482: 'Feminine Hygiene – Cups',
  10000483: 'Feminine Hygiene – Panty Liners',
  10000484: 'Toners/Astringents',
  10000485: 'Facial Tissue/Handkerchiefs (Disposable)',
  10000486: 'Skin Lightening',
  10000487: 'Hearing Aids',
  10000488: 'Medicated/Orthopaedic Footwear',
  10000489: 'Foot Care/Hygiene Aids',
  10000490: 'Baby Feeding – Tableware',
  10000491: 'Baby Feeding – Bottles',
  10000492: 'Baby Feeding Accessories',
  10000493: 'Baby Feeding Aids (Non Powered)',
  10000494: 'Baby Diapers (Disposable)',
  10000495: 'Baby Inserts/Pads',
  10000496: 'Baby Diapers Accessories',
  10000498: 'Baby Bath Safety Products',
  10000500: 'Baby Treatments',
  10000501: 'Baby Changing Table',
  10000502: 'Baby Carrier',
  10000503: 'Baby Safety Protection (Non Powered)',
  10000504: 'Pacifiers/Teething Rings',
  10000505: 'Baby Hygiene Products',
  10000506: 'Pet Drinks (Frozen)',
  10000507: 'Pet Food (Frozen)',
  10000508: 'Pet Grooming Aids',
  10000510: 'Pet Hygiene/Sanitary Protection',
  10000513: 'Pet Nutritional Supplements',
  10000514: 'Veterinary Pharmaceuticals',
  10000515: 'Pet Parasite Treatment',
  10000516: 'Aquarium Aids/Accessories',
  10000521: 'Pet Food (Perishable)',
  10000522: 'Pet Food (Shelf Stable)',
  10000523: 'Pet Drinks (Perishable)',
  10000524: 'Pet Drinks (Shelf Stable)',
  10000525: 'Ear Preparations',
  10000526: 'Eye Preparations',
  10000527: 'Optic Appliances Care – Contact Lenses',
  10000528: 'Optic Appliances – Spectacles – Ready To Wear',
  10000529: 'Optic Appliances – Contact Lenses',
  10000531: 'Bleach',
  10000532: 'Cosmetics – Complexion',
  10000533: 'Cosmetics – Eyes',
  10000534: 'Cosmetics – Lips',
  10000535: 'Shaving Preparations',
  10000536: 'Breath Fresheners/Mouth Rinses',
  10000541: 'String/Ties',
  10000542: 'Kitchen Scissors',
  10000543: 'Firelighting Tools/Matches',
  10000546: 'Batteries',
  10000547: 'Converters/Inverters/Regulators/Transformers',
  10000548: 'Chargers',
  10000549: 'Fuses',
  10000551: 'Plugs',
  10000552: 'Light Bulbs/Tubes/Light-Emitting Diodes',
  10000554: 'Cookware (Disposable)',
  10000555: 'Candles',
  10000556: 'Scratch Remover Kit/Repairs',
  10000559: 'Paper Filters',
  10000564: 'Hair – Aids (Non Powered)',
  10000566: 'Personal Warming/Massaging (Non Powered)',
  10000567: 'Body Toning/Firming Products (Powered)',
  10000570: 'Personal Repellents',
  10000572: 'Pet Bedding',
  10000573: 'Wipes – Personal',
  10000574: 'Fats Edible – Animal (Shelf Stable)',
  10000575: 'Baby/Infant – Formula (Shelf Stable)',
  10000576: 'Pate (Frozen)',
  10000577:
    'Other Sauces Dipping/Condiments/Savoury Toppings/Savoury Spreads/Marinades (Frozen)',
  10000578: 'Stock/Bones (Shelf Stable)',
  10000579: 'Stock/Bones (Perishable)',
  10000580: 'Stock/Bones (Frozen)',
  10000581: 'Food Glazes (Shelf Stable)',
  10000583: 'Dressing/Dips (Frozen)',
  10000584: 'Herbal Cigarettes – Non Tobacco',
  10000585: 'Fats Edible – Vegetable/Plant (Perishable)',
  10000586: 'Chutneys/Relishes (Frozen)',
  10000587: 'Chutneys/Relishes (Perishable)',
  10000588: 'Non Grape Fermented Alcoholic Beverages – Still',
  10000589: 'Alcoholic Syrups and Bitters',
  10000590: 'Food/Beverage/Tobacco Variety Packs',
  10000591: 'Alcoholic Beverages Variety Packs',
  10000592: 'Coffee/Tea/Substitutes Variety Packs',
  10000593: 'Non Alcoholic Beverages Variety Packs – Not Ready to Drink',
  10000594: 'Non Alcoholic Beverages Variety Packs – Ready to Drink',
  10000595: 'Baking/Cooking Mixes/Supplies Variety Packs',
  10000596: 'Biscuits/Cookies Variety Packs',
  10000597: 'Sweet Bakery Products Variety Packs',
  10000598: 'Bread/Bakery Products Variety Packs',
  10000599: 'Grains/Flour Variety Packs',
  10000600: 'Processed Cereal Products Variety Packs',
  10000601: 'Cereal/Grain/Pulse Products Variety Packs',
  10000602: 'Confectionery Products Variety Packs',
  10000603: 'Sugars/Sugar Substitute Products Variety Packs',
  10000604: 'Fruit/Nuts/Seeds Combination Variety Packs',
  10000605: 'Fruits/Vegetables/Nuts/Seeds Variety Packs',
  10000607: 'Milk/Butter/Cream/Yogurts/Cheese/Eggs/Substitutes Variety Packs',
  10000608: 'Fats Edible Variety Packs',
  10000609: 'Oils/Fats Edible Variety Packs',
  10000610: 'Baby/Infant – Foods/Beverages Variety Packs',
  10000611: 'Desserts/Dessert Toppings Variety Packs',
  10000612: 'Snacks Variety Packs',
  10000613: 'Prepared/Preserved Foods Variety Packs',
  10000614: 'Seafood Variety Packs',
  10000615: 'Herbs/Spices/Extracts Variety Packs',
  10000616: 'Pickles/Relishes/Chutneys/Olives Variety Packs',
  10000617: 'Sauces/Spreads/Dips/Condiments Variety Packs',
  10000618: 'Vinegars/Cooking Wines Variety Packs',
  10000619: 'Seasonings/Preservatives/Extracts Variety Packs',
  10000620: 'Tobacco Products/Smoking Accessories Variety Packs',
  10000621: 'Sweet Spreads Variety Packs',
  10000622: 'Confectionery/Sugar Sweetening Products Variety Packs',
  10000623: 'Beverages Variety Packs',
  10000624: 'Cross Segment Variety Packs',
  10000626:
    'Aquatic Invertebrates/Fish/Shellfish/Seafood Mixes – Prepared/Processed (Frozen)',
  10000627:
    'Aquatic Invertebrates/Fish/Shellfish/Seafood Mixes – Prepared/Processed (Perishable)',
  10000628:
    'Aquatic Invertebrates/Fish/Shellfish/Seafood Mixes – Prepared/Processed (Shelf Stable)',
  10000629:
    'Aquatic Invertebrates/Fish/Shellfish/Seafood Mixes – Unprepared/Unprocessed (Frozen)',
  10000630:
    'Aquatic Invertebrates/Fish/Shellfish/Seafood Mixes – Unprepared/Unprocessed (Perishable)',
  10000631:
    'Aquatic Invertebrates/Fish/Shellfish/Seafood Mixes – Unprepared/Unprocessed (Shelf Stable)',
  10000634: 'Baby Safety Monitoring (Non Powered)',
  10000635: 'Dinnerware (Disposable)',
  10000636: 'Dish Cleaning/Care – Hand',
  10000637: 'Optic Appliances – Sunglasses – Ready To Wear',
  10000638: 'Optic Appliances – Spectacle Lenses',
  10000639: 'Optic Appliances – Spectacle Frames',
  10000640: 'Pet Training/Control Aids/Accessories (Non Powered)',
  10000641: 'Pet Toys (Non Powered)',
  10000643: 'Pet Attire',
  10000647: 'Home Diagnostics Variety Packs',
  10000648: 'Diagnostic Tests Variety Packs',
  10000649: 'Health Enhancement Variety Packs',
  10000650: 'Dietary Aids Variety Packs',
  10000651: 'Vitamins/Minerals/Nutritional Supplements Variety Packs',
  10000652: 'Pet Training/Control Aids/Accessories (Powered)',
  10000653: 'Pet Care Variety Packs',
  10000654: 'Pet Care/Food Variety Packs',
  10000657: 'Pet Welfare/Hygiene Variety Packs',
  10000658: 'Pet Nutritional Supplements Variety Packs',
  10000659: 'Pet Accessory Variety Packs',
  10000660: 'Pet Food/Drink Dispenser',
  10000661: 'Pet Toys (Powered)',
  10000662: 'Pet Housing',
  10000663: 'Pet Food/Drinks Variety Packs',
  10000664: 'Insect/Pest/Allergen Control Variety Packs',
  10000666: 'Beauty/Personal Care/Hygiene Variety Packs',
  10000668: 'Body Massage/Toning Variety Packs',
  10000669: 'Cosmetic Products Variety Packs',
  10000671: 'Nail Cosmetic/Care Products Variety Packs',
  10000672: 'Cosmetics/Fragrances Variety Packs',
  10000673: 'Healthcare Variety Packs',
  10000674: 'Barrier Contraception Variety Packs',
  10000675: 'Family Planning Variety Packs',
  10000676: 'Hair Products Variety Packs',
  10000677: 'Hair Care Products Variety Packs',
  10000678: 'Hair – Styling (Powered)',
  10000679: 'Mirrors – Personal Care',
  10000680: 'Hair Removal/Masking Products Variety Packs',
  10000681: 'Drug Administration Variety Packs',
  10000682: 'Anti-smoking Aids',
  10000683: 'Health Treatments/Aids Variety Packs',
  10000684: 'First Aid Variety Packs',
  10000685: 'Foot/Leg Care/Treatments Variety Packs',
  10000686: 'Personal Aids Variety Packs',
  10000687: 'Sensory Organs Care/Treatments Variety Packs',
  10000688: 'Optic Appliances Care – Spectacles',
  10000689: 'Spectacle Care Accessories',
  10000690: 'Habit Treatment Variety Packs',
  10000692: 'Disposable Food Bags',
  10000693: 'Disposable Food Wrap',
  10000694: 'Cleaning/Hygiene Products Variety Packs',
  10000696: 'Air Fresheners/Deodorisers (Powered)',
  10000697: 'Fresheners/Deodorisers Variety Packs',
  10000698: 'Cleaners Variety Packs',
  10000699: 'Laundry Variety Packs',
  10000700: 'Footwear Accessories Variety Packs',
  10000701: 'Surface Care Variety Packs',
  10000702: 'Cleaning Variety Packs',
  10000703: 'Fuels/Ignition Aids Variety Packs',
  10000704: 'Batteries/Chargers Variety Packs',
  10000709: 'Adult Incontinence – Underwear (Disposable)',
  10000710: 'Adult Incontinence – Underwear (Non Disposable)',
  10000712: 'Personal Hygiene Products Variety Packs',
  10000713: 'Adult Incontinence Variety Packs',
  10000714: 'Feminine/Nursing Hygiene Variety Packs',
  10000715: 'General Personal Hygiene Variety Packs',
  10000716: 'Oral Hygiene Variety Packs',
  10000717: 'Skin Products Variety Packs',
  10000719: 'Cooling Face/Body Misters',
  10000721: 'Skin Care Variety Packs',
  10000722: 'Body Washing Variety Packs',
  10000723: 'Skin Tanning Products Variety Packs',
  10000724: 'Baby Feeding – Teats',
  10000728: 'Baby Diapers (Non Disposable)',
  10000730: 'Shaving – Razors – Non Disposable (Non Powered)',
  10000731: 'Sunless Tanning – Oral (Non Powered)',
  10000732: 'Feeding/Eating Bibs',
  10000736: 'Pet Accessories Other',
  10000737: 'Pet Nutritional Supplements Other',
  10000738: 'Pet Welfare/Hygiene Other',
  10000740: 'Fresheners – Fabric',
  10000741: 'Fabric Protectors',
  10000742: 'Fabric Finishers/Starch',
  10000743: 'Detergent Boosters/Laundry Bleaches',
  10000744: 'Fabric Softeners/Conditioners',
  10000745: 'Fresheners/Deodorisers Other',
  10000746: 'Cleaners Other',
  10000747: 'Laundry Other',
  10000749: 'Surface Care Other',
  10000754: 'Insect/Pest/Allergen Control Other',
  10000758: 'Body Massage/Toning – Replacement Parts',
  10000759: 'Personal Warming/Massaging (Powered)',
  10000760: 'Body Massage/Toning Other',
  10000761: 'Cosmetic Paints/Shimmers/Glitters',
  10000762: 'Breast/Hip Enhancer Pads',
  10000763: 'Tattoos/Stencils/Stick-on Jewellery – Temporary',
  10000764: 'Eyelashes – False',
  10000767: 'Nails – Accessories (Powered)',
  10000768: 'Nail Cosmetic/Care Products – Replacement Parts',
  10000769: 'Oil Diffusers (Non Powered)',
  10000770: 'Oil Diffusers (Powered)',
  10000771: 'Essential Oils',
  10000772: 'Aromatherapy Cushions',
  10000773: 'Base/Carrier Oils',
  10000774: 'Aromatherapy Variety Packs',
  10000775: 'Cosmetic Products Other',
  10000778: 'Nail Cosmetic/Care Products Other',
  10000779: 'Aromatherapy Other',
  10000780: 'Nails – Aids (Powered)',
  10000781: 'Oral Care – Aids (Powered)',
  10000782: 'Oral Hygiene – Replacement Parts',
  10000783: 'Oral Hygiene Other',
  10000784: 'Adult Incontinence Other',
  10000785: 'Feminine/Nursing Hygiene Other',
  10000786: 'General Personal Hygiene Other',
  10000787: 'Baby High Chair',
  10000788: 'Baby Play Pens/Dens',
  10000789: 'Baby Cots/Cot Beds/Bassinet',
  10000790: 'Baby Cot Mattress',
  10000791: 'Baby Safety Monitoring (Powered)',
  10000792: 'Baby Car/Booster Seats',
  10000793: 'Prams/Pushchairs/Strollers',
  10000794: 'Baby Cot/Basket – Travel',
  10000795: 'Baby Carry Cots/Baskets/Cradles',
  10000796: 'Baby Harnesses/Reins',
  10000797: 'Pram/Pushchair/Stroller Accessories',
  10000800: 'Baby Bouncing Cradles/Rocker Seats (Non Powered)',
  10000801: 'Baby Bouncing Cradles/Rocker Seats (Powered)',
  10000802: 'Baby Door Bouncers',
  10000803: 'Baby Swings',
  10000804: 'Baby Walkers',
  10000805: 'Baby Exercisers/Transportation Other',
  10000806: 'Anti-spot Aids (Powered)',
  10000807: 'Bath Massage/Toning',
  10000808: 'Cleansers/Cosmetics Removers (Powered)',
  10000809: 'Sunless Tanning (Powered)',
  10000810: 'Skin Care – Replacement Parts',
  10000811: 'Skin Tanning Products – Replacement Parts',
  10000812: 'Skin Care Other',
  10000813: 'Body Washing Other',
  10000814: 'Skin Tanning Products Other',
  10000820: 'Baby Feeding Aids (Powered)',
  10000821: 'Baby Potties/Training Seats',
  10000822: 'Baby Changing Mats',
  10000823: 'Baby Feeding – Replacement Parts',
  10000825: 'Baby/Infant Feeding Other',
  10000827: 'Baby Baths/Bath Chairs/Bath Cradles',
  10000828: 'Hair – Aids (Powered)',
  10000829: 'Hair Curlers/Rollers',
  10000830: 'Depilation/Epilation (Powered)',
  10000831: 'Shaving – Razors (Powered)',
  10000832: 'Hair Removal/Masking Products – Replacement Parts',
  10000833: 'Hair Care Products – Replacement Parts',
  10000834: 'Hair Care Products Other',
  10000835: 'Hair Removal/Masking Products Other',
  10000838: 'Barrier Contraception Other',
  10000841: 'Dietary Aids Other',
  10000843: 'Diagnostic Monitors Other',
  10000844: 'Diagnostic Tests Other',
  10000846: 'Genital Irritation',
  10000847: 'Cystitis Products',
  10000848: 'Rectal Medication',
  10000849: 'Bladder/Genital/Rectal Products Other',
  10000850: 'Diuretic Remedies',
  10000851: 'Enemas/Douches',
  10000852: 'Bladder/Genital/Rectal Products Variety Packs',
  10000853: 'Pain Relief (Powered)',
  10000854: 'Pain Relief Products Other',
  10000855: 'Arthritic/Rheumatic/Muscular Pain Relief',
  10000856: 'General/Multi-use Pain Relief',
  10000857: 'Headache/Migraine Pain Relief',
  10000858: 'Pain Relief Products Variety Packs',
  10000859: 'Homoeopathic/Homeopathic Remedies – Individual Ingredients',
  10000860: 'Homoeopathic/Homeopathic Remedies – Combination Ingredients',
  10000861: 'Flower Remedies',
  10000862: 'Flower/Homoeopathic/Homeopathic Remedies Variety Packs',
  10000863: 'Antacids/Indigestion/Flatulence Remedies',
  10000864: 'Diarrhoea Remedies',
  10000865: 'Gastrointestinal Remedy Products Other',
  10000866: 'Laxatives',
  10000867: 'Worming Preparations',
  10000868: 'Nausea Remedies',
  10000869: 'Oral Rehydration/Electrolyte Maintenance',
  10000870: 'General/Multi-use Gastrointestinal Remedies',
  10000871: 'Gastrointestinal Remedy Products Variety Packs',
  10000872: 'Sleeping Aids',
  10000873: 'Stress Relief/Calmatives',
  10000874: 'Sleeping/Stress Relieving Products Variety Packs',
  10000875: 'Chest Rubs',
  10000876: 'Cold/Cough Remedies',
  10000877: 'Inhalers/Nebulisers/Respirators (Non Powered)',
  10000878: 'Inhalers/Nebulisers/Respirators (Powered)',
  10000879: 'Nasal Strips/Sprays',
  10000880: 'Throat Remedies',
  10000881: 'Allergy Prevention/Relief/Antihistamines',
  10000882: 'Decongestants Other',
  10000883: 'Humidifiers/Vaporisers (Non Powered)',
  10000884: 'Respiratory/Allergy Products Variety Packs',
  10000885: 'Hand Sanitizers / Antiseptics',
  10000886: 'Parasite Infestation Treatments',
  10000887: 'Psoriasis/Eczema/Dry Skin/Scalp Treatments',
  10000888: 'Hair Loss Treatments',
  10000889: 'Insect Bite Relief',
  10000890: 'Anti-fungal Products',
  10000891: 'General/Multi Purpose Skin/Scalp Treatments',
  10000892: 'Parasite Infestation Equipment (Non Powered)',
  10000893: 'Parasite Infestation Equipment (Powered)',
  10000894: 'Travel Sickness Preventatives – Medicinal',
  10000895: 'Travel Sickness Preventatives – Non Medicinal',
  10000896: 'Travel Sickness Products Variety Packs',
  10000897: 'Travel Sickness Products Other',
  10000898: 'Enteral Feeding Gastrostomy Kits',
  10000899: 'Enteral Feeding Pumps/Feeding Sets',
  10000900: 'Enteral Feeding Nutrition Bags/Containers',
  10000901: 'Enteral Feeding Tubes',
  10000902: 'Enteral Feeding Equipment Other',
  10000903: 'Acne/Rosacea Treatments',
  10000904: 'Wart/Verruca/Corn/Callus Treatments',
  10000905: 'Skin/Scalp Treatment Products Variety Packs',
  10000906: 'Skin/Scalp Treatment Products Other',
  10000907: 'Foot/Leg Care/Treatments Other',
  10000908: 'First Aid Other',
  10000909: 'Poison Removal/Treatment Products',
  10000910: 'Sterilisers/Surgical Spirits',
  10000911: 'Sensory Organs Care/Treatments Other',
  10000912: 'Drug Administration – Replacement Parts',
  10000914: 'Flower/Homoeopathic/Homeopathic Remedies Other',
  10000915: 'Personal Aids Other',
  10000916: 'Humidifiers/Vaporisers (Powered)',
  10000917: 'Energy/Stimulant Products',
  10000918: 'Energy/Stimulant Products Other',
  10000919: 'Sleeping/Stress Relieving Products Other',
  10000920: 'Respiratory/Allergy Products Other',
  10000921: 'Enteral Feeding Equipment Variety Packs',
  10000922: 'Drug Administration Other',
  10000923: 'Intimate Lubrication',
  10000925: 'Digital eBook Content',
  10000926: 'Printed Books/Compositions',
  10000927: 'Digital Periodical Content',
  10000928: 'Printed Periodicals',
  10000933: 'Brasswind Musical Instruments (Non Powered)',
  10000934: 'Keyboards/Pianos (Non Powered)',
  10000935: 'Percussion Musical Instruments (Non Powered)',
  10000936: 'String Musical Instruments (Non Powered)',
  10000937: 'Woodwind Musical Instruments (Non Powered)',
  10000938: 'Brasswind Musical Instruments (Powered)',
  10000939: 'Musical Instrument Aids (Powered)',
  10000940: 'Keyboards/Pianos (Powered)',
  10000941: 'Percussion Musical Instruments (Powered)',
  10000942: 'String Musical Instruments (Powered)',
  10000943: 'Woodwind Musical Instruments (Powered)',
  10001070: 'Athletic Footwear – General Purpose',
  10001071: 'Athletic Footwear – Specialist',
  10001074: 'Footwear Inserts',
  10001076: 'Boots – General Purpose',
  10001077: 'Shoes – General Purpose',
  10001078: 'Indoor Footwear – Fully Enclosed Uppers',
  10001079: 'Indoor Footwear – Partially Enclosed Uppers',
  10001080: 'Safety/Protective/Occupational Boots',
  10001081: 'Safety/Protective Occupational Overshoes',
  10001082: 'Safety/Protective Occupational Shoes',
  10001083: 'Anklets',
  10001084: 'Bracelets',
  10001085: 'Brooches',
  10001086: 'Cuff-links',
  10001087: 'Earrings/Body-piercing Jewellery',
  10001088: 'Jewellery Boxes/Pouches',
  10001089: 'Jewellery Replacement Parts',
  10001090: 'Necklaces/Necklets',
  10001091: 'Pendants',
  10001092: 'Rings',
  10001093: 'Tiaras',
  10001094: 'Body Bags/Waist Bags',
  10001095: 'Briefcases',
  10001096: 'Handbags/Shoulder Bags',
  10001097: 'Luggage/Personal Bags/Umbrellas Accessories',
  10001099: 'Luggage/Suitcases/Garment Carriers',
  10001100: 'Rucksacks/Backpacks/Holdalls',
  10001101: 'Shopping Trolley Bags',
  10001102: 'Umbrellas – Personal',
  10001103: 'Wallets/Purses/Travel Document Holders',
  10001104: 'Watch Accessories/Replacement Parts',
  10001105: 'Watches',
  10001107: 'Computer/Video Game Cases/Carriers',
  10001108: 'Computer/Video Game Cleaning Products',
  10001109: 'Computer Docking Ports/Cradles',
  10001110: 'Filters/Covers (Electronic Equipment)',
  10001111: 'Computer/Video Game Security Products',
  10001112: 'Computer Tools/Tool Kits',
  10001113: 'Mats/Rests – Computing',
  10001114: 'Personal Data Assistant/Organiser Stylus',
  10001115: 'Card Readers',
  10001116: 'Computer Casing/Housing Accessories',
  10001117: 'Computer Casing/Housing',
  10001118: 'Computer Components – Replacement Parts/Accessories',
  10001119: 'Computer Components Other',
  10001120: 'Computer Components Variety Packs',
  10001121: 'Computer Cooling',
  10001122: 'Computer Memory',
  10001123: 'Computer Motherboards',
  10001124: 'Computer Power Supplies',
  10001125: 'Computer Processors',
  10001126: 'Expansion Boards/Cards',
  10001127: 'Optical Drives – Reading/Writing',
  10001128: 'Optical Drives – Reading Only',
  10001129: 'Computer Drives – Replacement Parts/Accessories',
  10001130: 'Computer Drives Other',
  10001131: 'Computer Drives Variety Packs',
  10001132: 'Floppy Disc Drives',
  10001133: 'Hard Disc Drives',
  10001134: 'Swap Drives',
  10001135: 'Tape Drives/Streamers',
  10001136: 'Zip/Jaz Disk Drives',
  10001137: 'Computer/Video Game Gaming Software',
  10001138: 'Computer Software (Non Games)',
  10001139: 'Computer/Video Game Software Other',
  10001140: 'Computer/Video Game Software Variety Packs',
  10001141: 'Computers – Replacement Parts/Accessories',
  10001142: 'Computers Other',
  10001143: 'Electronic Organisers',
  10001144: 'Personal Computers – Desktop/Internet Terminal',
  10001145: 'Personal Computers – Portable',
  10001146: 'Personal Digital Assistants',
  10001147: 'Servers',
  10001148: 'Computer/Video Game Control Devices',
  10001149: 'Computer Graphics Tablets',
  10001150: 'Computer Keyboards',
  10001151: 'Computer Pointing Devices',
  10001152:
    'Computer/Video Game Control/Input Devices – Replacement Parts/Accessories',
  10001153: 'Computer/Video Game Monitors',
  10001154: 'Computer Speakers/Mini Speakers',
  10001155: 'Computer/Video Game Peripherals – Replacement Parts/Accessories',
  10001156: 'Printer Consumables',
  10001158: 'Printers',
  10001159: 'Projection Systems',
  10001160: 'Scanners',
  10001161: 'Web-cameras',
  10001162: 'Firewalls',
  10001163: 'Gateways',
  10001164: 'Modems',
  10001165: 'Network Access Points',
  10001166: 'Network/USB Hubs',
  10001167: 'Network Interface Cards',
  10001168: 'Network Routers',
  10001169: 'Network Switches',
  10001170: 'Computer Networking Equipment Other',
  10001171: 'Computer Networking Equipment Variety Packs',
  10001172: 'Computer Networking Equipment – Replacement Parts/Accessories',
  10001173: 'Repeaters',
  10001174: 'Caller ID Displays',
  10001177: 'Phone Holders',
  10001178: 'Mobile Phone Cases',
  10001181: 'Communications Hands Free Kits/Headphones',
  10001182: 'Mobile Phone Fascias',
  10001183: 'Mobile Phone Radiation Guards',
  10001184: 'Answering Machines',
  10001185: 'Conferencing Systems',
  10001186: 'Fax Machines',
  10001188: 'Fixed Communication Pre-pay Vouchers/Calling Cards',
  10001189: 'Intercoms',
  10001190: 'Telephone Switchboards',
  10001191: 'Telephones',
  10001192: 'Communication Radio Sets',
  10001193: 'GPS Equipment – Mobile Communications',
  10001194: 'GPS Software – Mobile Communications',
  10001195: 'Mobile Phone Pre-pay Vouchers/Cards',
  10001196: 'Mobile Phone SIM Cards/SIM Card Adapters',
  10001197: 'Mobile Phone Software',
  10001198: 'Mobile Phones/Smartphones',
  10001199: 'Pagers',
  10001200: 'Two-way Radios',
  10001201: 'Gift Wrap',
  10001202: 'Gift Wrap/Accessories Other',
  10001203: 'Gift Wrap Accessories',
  10001204: 'Gift Wrap/Accessories Variety Packs',
  10001205: 'Greeting Cards/Gift Wrap/Occasion Supplies Variety Packs',
  10001206: 'Greeting Card Display Holders',
  10001207: 'Greeting Cards/Invitations Other',
  10001208: 'Greeting Cards/Invitations Variety Packs',
  10001209: 'Greeting Cards/Invitations',
  10001212: 'Invitation Pads/Notelets',
  10001213: 'Postcards',
  10001214: 'Balloons',
  10001215: 'Confetti',
  10001216: 'Fireworks',
  10001217: 'Occasion Supplies Other',
  10001218: 'Occasion Supplies Variety Packs',
  10001220: 'Party Crackers',
  10001221: 'Party Hats',
  10001222: 'Party Poppers',
  10001223: 'Pinatas',
  10001224: 'Streamers/Paper Chains',
  10001225: 'Ink',
  10001226: 'Correction Aids',
  10001228: 'Writing/Design Implements/Aids Other',
  10001229: 'Writing Implements – Replacement Parts',
  10001230: 'Writing/Design Implements/Aids Variety Packs',
  10001231: 'Measuring/Geometrical Equipment',
  10001232: 'Pencil Sharpeners (Non Powered)',
  10001233: 'Pencil Sharpeners (Powered)',
  10001234: 'Pencils',
  10001235: 'Pens',
  10001236: 'Stencils',
  10001241: 'Stamping Equipment (Non Powered)',
  10001242: 'Calculators/Currency Converters (Powered)',
  10001243: 'Cash/Money Registers (Powered)',
  10001245: 'Postal Labelling Machines',
  10001246: 'Laminating Machine Consumables',
  10001247: 'Laminating Machines (Powered)',
  10001248: 'Office Machinery Other',
  10001250: 'Office Machinery Variety Packs',
  10001251: 'Photocopier Consumables',
  10001252: 'Photocopiers',
  10001253: 'Typewriters (Non Powered)',
  10001254: 'Typewriters (Powered)',
  10001255: 'Calendars/Planners',
  10001256: 'Contact Information Books/Pads',
  10001257: 'Organizational Planning Stationery Other',
  10001258:
    'Organizational Planning Stationery – Replacement Parts/Accessories',
  10001259: 'Organizational Planning Stationery Variety Packs',
  10001260: 'Personal Organizers/Diaries (Non Powered)',
  10001261: 'Envelopes/Mailers',
  10001262: 'Franking Machines',
  10001263: 'Letter Folders/Inserters/Sealers',
  10001264: 'Letter Openers (Non Powered)',
  10001265: 'Letter Openers (Powered)',
  10001266: 'Postal Tubes/Boxes',
  10001267: 'Postal Weighing Scales (Non Powered)',
  10001268: 'Postal Weighing Scales (Powered)',
  10001269: 'Postal/Packaging Accessories',
  10001270: 'Postal/Packaging Equipment/Aids/Accessories Other',
  10001272: 'Postal/Packaging Equipment/Aids/Accessories Variety Packs',
  10001273: 'Postal Packaging/Wrap',
  10001275: 'Flip-chart Stands',
  10001276: 'Pointers (Non Powered)',
  10001277: 'Pointers (Powered)',
  10001278: 'Presentation Boards (Non Powered)',
  10001280: 'Presentation Equipment Other',
  10001281: 'Presentation Equipment Accessories',
  10001283: 'Presentation Equipment Variety Packs',
  10001286: 'Binding Accessories',
  10001287: 'Binding Machines (Non Powered)',
  10001288: 'Binding Machines (Powered)',
  10001289: 'Stationery Fasteners',
  10001292: 'Stationery Glues',
  10001295: 'Stationery Adhesives/Binders/Fasteners Other',
  10001297: 'Stationery Adhesives/Binders/Fasteners Variety Packs',
  10001298: 'Stationery Staple Removers',
  10001299: 'Stationery Staplers (Non Powered)',
  10001300: 'Stationery Staplers (Powered)',
  10001302: 'Paper Guillotines/Trimmers',
  10001304: 'Paper/Card – Unprinted',
  10001305: 'Business Forms/Paper – Pre-printed',
  10001306: 'Stationery Cutters/Trimmers Other',
  10001308: 'Stationery Cutters/Trimmers Variety Packs',
  10001309: 'Paper Shredders (Non Powered)',
  10001311: 'Hole Paper Punches (Non Powered)',
  10001312: 'Hole Paper Punches (Powered)',
  10001313: 'Labels/Coupons/Tickets',
  10001314: 'Transparencies/Acetates',
  10001316: 'Cash/Money Boxes',
  10001318: 'Stationery Files/Folders/Wallets',
  10001320: 'Stationery Item Storage/Desk Accessories',
  10001321: 'Stationery Storage/Filing Other',
  10001322: 'Stationery Storage/Filing – Replacement Parts/Accessories',
  10001323: 'Stationery Storage/Filing Variety Packs',
  10001325: 'Stationery/Office Machinery Variety Packs',
  10001326: 'Belts/Braces/Cummerbunds',
  10001327: 'Handkerchiefs',
  10001328: 'Handwear',
  10001329: 'Headwear',
  10001330: 'Neckwear',
  10001331: 'Clothing Adornment/Floral Accessories/Badges/Buckles',
  10001332: 'Overalls/Bodysuits',
  10001333: 'Dresses',
  10001334: 'Skirts',
  10001335: 'Trousers/Shorts',
  10001338: 'Dressing Gowns',
  10001339: 'Night Dresses/Shirts',
  10001340: 'Sleep Headwear',
  10001341: 'Sleep Trousers/Shorts',
  10001342: 'Sportswear – Full Body Wear',
  10001343: 'Sportswear – Lower Body Wear',
  10001344: 'Sportswear – Upper Body Wear',
  10001345: 'Bras/Basques/Corsets',
  10001346: 'Full Body Underwear',
  10001347: 'Pants/Briefs/Undershorts',
  10001348: 'Socks',
  10001349: 'Undershirts/Chemises/Camisoles',
  10001350: 'Jackets/Blazers/Cardigans/Waistcoats',
  10001351: 'Sweaters/Pullovers',
  10001352: 'Shirts/Blouses/Polo Shirts/T-shirts',
  10001354: 'Clothing Accessories Variety Packs',
  10001355: 'Full Body Wear Variety Packs',
  10001356: 'Lower Body Wear/Bottoms Variety Packs',
  10001358: 'Sleepwear Variety Packs',
  10001359: 'Sportswear Variety Packs',
  10001360: 'Underwear Variety Packs',
  10001361: 'Upper Body Wear/Tops Variety Packs',
  10001362: 'Computer/Video Game Accessories Other',
  10001363: 'Computer/Video Game Accessories Variety Packs',
  10001364: 'Computer/Video Game Control/Input Devices Other',
  10001365: 'Computer/Video Game Control/Input Devices Variety Packs',
  10001366: 'Computer/Video Game Peripherals Other',
  10001367: 'Computer/Video Game Peripherals Variety Packs',
  10001370: 'Computers/Video Games Variety Packs',
  10001375: 'Musical Instruments Other (Non Powered)',
  10001377: 'Musical Instruments Other (Powered)',
  10001379: 'Communication Accessories Other',
  10001380: 'Communication Accessories Variety Packs',
  10001382: 'Communication Variety Packs',
  10001383: 'Fixed Communication Devices Other',
  10001384: 'Fixed Communication Devices Variety Packs',
  10001385: 'Mobile Communication Devices/Services Other',
  10001386: 'Mobile Communication Devices/Services Variety Packs',
  10001387: 'Jewellery Other',
  10001388: 'Jewellery Variety Packs',
  10001389: 'Personal Accessories Variety Packs',
  10001390: 'Personal Bags/Luggage/Umbrellas Other',
  10001391: 'Personal Bags/Luggage/Umbrellas Variety Packs',
  10001392: 'Watches Other',
  10001394: 'Protective Full Body Wear',
  10001395: 'Protective Handwear',
  10001397: 'Protective Lower Body Wear',
  10001398: 'Protective Upper Body Wear',
  10001400: 'Televisions',
  10001401: 'Television Combinations',
  10001402: 'Televisions – Hand-held',
  10001403: 'Televisions Variety Packs',
  10001404: 'Televisions – Replacement Parts/Accessories',
  10001405: 'Televisions Other',
  10001406: 'Camcorders',
  10001407: 'DVD Players/Recorders',
  10001408: 'Combination Players/Recorders',
  10001409: 'Set-top Boxes',
  10001410: 'Video Hard Disc Recorders',
  10001411: 'Aerials',
  10001412: 'Video Cassette Players/Recorders',
  10001413: 'Video Recording/Playback Variety Packs',
  10001414: 'Video Recording/Playback – Replacement Parts/Accessories',
  10001416: 'Portable CD Players',
  10001417: 'Portable MD Players',
  10001418: 'Portable MP3 Players',
  10001419: 'Portable Audio Cassette Players',
  10001420: 'Portable DVD Players',
  10001421: 'Portable Digital Video Players',
  10001422: 'Portable Radios',
  10001423: 'Portable Radio-recorders',
  10001424: 'Clock Radios',
  10001425: 'Dictation Machines',
  10001426: 'Portable Audio/Video Variety Packs',
  10001427: 'Portable Audio/Video – Replacement Parts/Accessories',
  10001428: 'Portable Audio/Video Other',
  10001429: 'Home Audio Amplifiers/Preamplifiers',
  10001430: 'Home Stereo Systems',
  10001431: 'Home Theatre Systems',
  10001432: 'Home Audio Cassette Decks',
  10001433: 'Home Audio CD Decks',
  10001434: 'Home Audio MD Decks',
  10001435: 'Home Audio Speakers – Individual',
  10001436: 'Home Audio Speaker Systems',
  10001437: 'Home Audio Receivers/Tuners/Radios',
  10001439: 'Turntables – Vinyl',
  10001440: 'Home Audio Jukeboxes',
  10001441: 'Home Audio Karaoke Systems',
  10001442: 'Home Audio/Visual Mixers',
  10001443: 'Home Audio Effects Equipment',
  10001444: 'Turntables – CD',
  10001446: 'Home Audio Equipment Variety Packs',
  10001447: 'Home Audio Equipment – Replacement Parts/Accessories',
  10001448: 'Home Audio Equipment Other',
  10001449: 'Audio Cassettes – Recordable',
  10001450: 'CD/MD – Recordable',
  10001451: 'DVD – Recordable',
  10001452: 'Memory Cards',
  10001455: 'Video Cassettes – Recordable',
  10001456: 'Floppy Discs',
  10001457: 'Recordable Media Variety Packs',
  10001458: 'Recordable Media Other',
  10001459: 'CD/MD – Pre-recorded',
  10001460: 'DVD – Pre-recorded',
  10001462: 'Vinyl – Pre-recorded',
  10001463: 'Video Cassettes – Pre-recorded',
  10001464: 'Audio Cassettes – Pre-recorded',
  10001465: 'Pre-recorded Media Variety Packs',
  10001466: 'Pre-recorded Media Other',
  10001467: 'Audio Headsets',
  10001468: 'Signal Boosters',
  10001469: 'Wireless Television Links',
  10001470: 'Universal Remote Controls',
  10001472: 'Switch-boxes',
  10001475: 'Converter Cassettes',
  10001476: 'Microphones',
  10001477: 'Audio Visual Stands/Brackets',
  10001478: 'Audio Visual Bags/Boxes/Cases/Wallets',
  10001479: 'Television Internet Packs',
  10001480: 'Audio Visual Cleaning Products',
  10001482: 'Audio Visual Accessories Variety Packs',
  10001483: 'Audio Visual Accessories – Replacement Parts',
  10001484: 'Audio Visual Accessories Other',
  10001485: 'Audio Visual Equipment Variety Packs',
  10001486: 'Analogue Cameras',
  10001487: 'Digital Cameras',
  10001489: 'Camera Flashes',
  10001490: 'Photographic Film',
  10001491: 'Interchangeable Lenses',
  10001492: 'Photographic Slide Projectors',
  10001493: 'Photographic Slides',
  10001494: 'Photography – Replacement Parts/Accessories',
  10001495: 'Photograph Albums/Cubes',
  10001496: 'Photography Variety Packs',
  10001498: 'Photography Other',
  10001499: 'Binoculars',
  10001501: 'Monoculars/Telescopes',
  10001502: 'Microscopes',
  10001504: 'Optics Variety Packs',
  10001505: 'Optics – Replacement Parts/Accessories',
  10001506: 'Optics Other',
  10001507: 'Photograph Developing Chemicals',
  10001508: 'Photograph Enlargers',
  10001510: 'Photographic Paper',
  10001511: 'Photography Drying Equipment',
  10001512: 'Photography Dark Room Safelights',
  10001513: 'Photography Dark Room Tanks/Trays/Reels',
  10001514: 'Photography Printing/Dark Room Equipment Variety Packs',
  10001515:
    'Photography Printing/Dark Room Equipment – Replacement Parts/Accessories',
  10001516: 'Photography Printing/Dark Room Equipment Other',
  10001517: 'Car Navigation Equipment',
  10001518: 'Car Video Monitors',
  10001519: 'Car DVD Players',
  10001520: 'Car Video Cassette Players',
  10001521: 'Car Video Receiving Equipment',
  10001522: 'Car Video/Navigation Variety Packs',
  10001523: 'Car Video/Navigation – Replacement Parts/Accessories',
  10001524: 'Car Video/Navigation Other',
  10001525: 'Car Audio Head Units',
  10001526: 'Car Audio Tuners/Receivers',
  10001527: 'Car Audio CD Players/Changers',
  10001528: 'Car Audio MD Players/Changers',
  10001529: 'Car Audio Speakers',
  10001530: 'Car Audio Amplifiers',
  10001531: 'Car Audio Aerials',
  10001532: 'Car Audio Variety Packs',
  10001533: 'Car Audio – Replacement Parts/Accessories',
  10001534: 'Car Audio Other',
  10001674: 'Artists Brushes/Applicators',
  10001676: 'Artists Paints/Dyes',
  10001677: 'Artists Pastels/Charcoal/Crayons',
  10001678: 'Artists Painting Surface Agents',
  10001679: 'Artists Canvas/Pre-primed Boards',
  10001680: 'Artists Palettes',
  10001681: 'Artists Easels',
  10001682: 'Artists Accessories',
  10001683: 'Sand Art Supplies',
  10001684: 'Artists Painting/Drawing Supplies Variety Packs',
  10001685: 'Artists Painting/Drawing Supplies Other',
  10001686: 'Airbrushes (Powered)',
  10001688: 'Airbrushing Equipment – Replacement Parts/Accessories',
  10001689: 'Airbrushing Supplies Variety Packs',
  10001690: 'Airbrushing Supplies Other',
  10001691: 'Sculptors/Pottery Craft Materials',
  10001692: 'Sculptors Tools (Non Powered)',
  10001693: 'Sculptors Tools (Powered)',
  10001694: 'Kilns (Powered)',
  10001695: 'Pottery Wheels (Powered)',
  10001696: 'Pottery Wheels (Non Powered)',
  10001697: 'Sculptors/Pottery Craft Supplies Variety Packs',
  10001698: 'Sculptors/Pottery Craft Supplies Other',
  10001699: 'Needlework Fabrics/Textiles',
  10001700: 'Lace/Ribbons/Cords/Braids',
  10001701: 'Needlework Threads',
  10001702: 'Needlework Hand/Machine Tools',
  10001705: 'Needlework Marking Equipment',
  10001706: 'Sewing/Knitting Machinery (Non Powered)',
  10001707: 'Sewing/Knitting Machinery (Powered)',
  10001710: 'Needlework Fasteners',
  10001711: 'Toy Making Accessories',
  10001712: 'Needlework Storage',
  10001713: 'Needlework Templates',
  10001714: 'Needlework Accessories',
  10001715: 'Needlework/Toy Making Craft Supplies Variety Packs',
  10001716: 'Needlework/Toy Making Craft Supplies Other',
  10001717: 'Jewellery Craft Materials',
  10001718: 'Jewellery Craft Accessories',
  10001719: 'Jewellery Craft Supplies Variety Packs',
  10001720: 'Jewellery Craft Supplies Other',
  10001721: 'Basketry Craft Materials',
  10001722: 'Basketry Craft Tools (Non Powered)',
  10001723: 'Basketry Craft Accessories',
  10001724: 'Basketry Craft Supplies Variety Packs',
  10001725: 'Basketry Craft Supplies Other',
  10001726: 'Paper Craft Tools (Non Powered)',
  10001727: 'Paper/Card Making Craft Accessories',
  10001729: 'Paper Craft/Card Making Supplies Variety Packs',
  10001730: 'Paper Craft/Card Making Supplies Other',
  10001731: 'Glasswork/Enamelling/Marquetry Craft Materials',
  10001732: 'Glasswork Craft Tools (Powered)',
  10001734: 'Glasswork/Enamelling/Marquetry Craft Supplies Variety Packs',
  10001735: 'Glasswork/Enamelling/Marquetry Craft Supplies Other',
  10001736: 'Candle/Soap Craft Materials',
  10001737: 'Candle/Soap Craft Moulds',
  10001738: 'Candle/Soap Craft Tools (Non Powered)',
  10001739: 'Candle/Soap Craft Tools (Powered)',
  10001740: 'Candle/Soap Craft Supplies Variety Packs',
  10001741: 'Candle/Soap Craft Supplies Other',
  10001742: 'Wood Burning/Engraving Craft Tools (Powered)',
  10001743: 'Wood Burning/Engraving Craft Tools (Non Powered)',
  10001744: 'Wood Burning/Engraving Craft – Replacement Parts/Accessories',
  10001746: 'Wood Burning/Engraving Craft Supplies Other',
  10001748: 'Printing Craft Tools',
  10001749: 'Printing Press (Powered)',
  10001750: 'Printing Press (Non Powered)',
  10001752: 'Printing Craft Supplies Variety Packs',
  10001753: 'Printing Craft Supplies Other',
  10001754: 'Spinning/Weaving Machines (Powered)',
  10001755: 'Spinning/Weaving Machines (Non Powered)',
  10001756: 'Spinning/Weaving Fibres/Yarns',
  10001757: 'Spinning/Weaving Craft – Replacement Parts/Accessories',
  10001758: 'Spinning/Weaving Craft Supplies Other',
  10001759: 'Spinning/Weaving Craft Supplies Variety Packs',
  10001760: 'Arts/Crafts Variety Packs',
  10001761: 'Refuse Bags',
  10001762: 'Throwing Sports Equipment',
  10001763: 'Running Sports Equipment',
  10001764: 'Jumping Sports Equipment',
  10001766: 'Track/Field Sports Equipment Variety Packs',
  10001767: 'Track/Field Sports Equipment Other',
  10001768: 'Sports Balls',
  10001769: 'Pucks',
  10001770: 'Shuttlecocks',
  10001771: 'Frisbees',
  10001772: 'Boomerangs',
  10001774: 'Sports Balls/Pucks/Shuttlecocks/Frisbees/Boomerangs Variety Packs',
  10001775: 'Sports Balls/Pucks/Shuttlecocks/Frisbees/Boomerangs Other',
  10001776: 'Racquets',
  10001778: 'Racquet Sports – Replacement Parts/Accessories',
  10001779: 'Racquet Sports Equipment Variety Packs',
  10001780: 'Sports Bats/Sticks/Clubs',
  10001787: 'Sports Bats/Sticks/Clubs Other',
  10001790: 'Sleds',
  10001792: 'Skis/Ski Boards/Snow Boards',
  10001794: 'Curling Stones',
  10001795: 'Snow/Ice Sports Equipment – Replacement Parts/Accessories',
  10001796: 'Snow/Ice Sports Equipment Variety Packs',
  10001797: 'Snow/Ice Sports Equipment Other',
  10001798: 'Trekking/Mountaineering Sports Equipment',
  10001805: 'Trekking/Mountaineering Sports Equipment Other',
  10001806: 'Punching/Kicking Training Aids',
  10001807: 'Martial Arts Sports Equipment',
  10001809: 'Combat Sports Equipment Variety Packs',
  10001810: 'Cycles (Non Powered)',
  10001811: 'Cycles – Replacement Parts',
  10001812: 'Cycle Sports Equipment Variety Packs',
  10001813: 'Cycle Sports Equipment Other',
  10001814: 'Exercise Machines (Powered)',
  10001815: 'Exercise Machines (Non Powered)',
  10001816: 'Free Weights/Dumb-bells',
  10001819: 'Gym Accessories',
  10001822: 'Sports Exercise Monitors',
  10001823: 'Personal Fitness Sports Equipment – Replacement Parts/Accessories',
  10001824: 'Personal Fitness Sports Equipment Variety Packs',
  10001825: 'Personal Fitness Sports Equipment Other',
  10001826: 'Rhythm Gymnastics Equipment',
  10001827: 'Gymnastics Apparatus',
  10001829: 'Gymnastics Sports Equipment Variety Packs',
  10001830: 'Gymnastics Sports Equipment Other',
  10001831: 'Kites',
  10001832: 'Parachutes',
  10001834: 'Kiting/Parachuting Boards/Buggies (Non Powered)',
  10001835:
    'Kiting/Parachuting Sports Equipment – Replacement Parts/Accessories',
  10001837: 'Kiting/Parachuting Sports Equipment Variety Packs',
  10001838: 'Kiting/Parachuting Sports Equipment Other',
  10001840: 'Skateboards (Non Powered)',
  10001841: 'Skateboarding Sports Equipment – Replacement Parts/Accessories',
  10001842: 'Scooter/Skateboard Sports Equipment Variety Packs',
  10001843: 'Scooter/Skateboard Sports Equipment Other',
  10001844: 'Boards/Skis (Water Sports)',
  10001845: 'Boards/Skis (Water Sports) – Replacement Parts/Accessories',
  10001847: 'Swimming Training Aids',
  10001848: 'Diving Equipment',
  10001852:
    'Swimming/Surfing/Diving Sports Equipment – Replacement Parts/Accessories',
  10001853: 'Swimming/Surfing/Diving Sports Equipment Variety Packs',
  10001854: 'Swimming/Surfing/Diving Sports Equipment Other',
  10001855: 'Sports Tables',
  10001859: 'Sports Tables Other',
  10001860: 'Darts',
  10001862: 'Bows',
  10001863: 'Arrows',
  10001865: 'Targets (Powered)',
  10001866: 'Targets (Non Powered)',
  10001867: 'Target Sports Equipment – Replacement Parts/Accessories',
  10001868: 'Target Sports Equipment Variety Packs',
  10001869: 'Target Sports Equipment Other',
  10001870: 'Handguns/Pistols',
  10001871: 'Rifles',
  10001872: 'Shotguns',
  10001873: 'Airguns',
  10001874: 'Firearms Ammunition',
  10001877: 'Sporting Firearms – Replacement Parts/Accessories',
  10001878: 'Sporting Firearms Equipment Variety Packs',
  10001879: 'Sporting Firearms Equipment Other',
  10001880: 'Game Lures/Decoys/Callers',
  10001883: 'Hunting Field Dressing Equipment',
  10001885: 'Hunting Sports Aids Variety Packs',
  10001886: 'Hunting Sports Aids Other',
  10001887: 'Watercraft',
  10001889: 'Watercraft – Replacement Parts/Accessories',
  10001890: 'Watercraft Sports Equipment Variety Packs (Non Powered)',
  10001891: 'Watercraft Sports Equipment Other (Non Powered)',
  10001892: 'Sports Equipment Bags/Cases/Covers',
  10001893: 'Sports Goals/Nets/Enclosures',
  10001894: 'Sports Goals/Nets Accessories',
  10001896: 'Sports Marking Equipment',
  10001897: 'Sports Target Pins/Skittles/Stumps',
  10001898: 'Sports Equipment Storage Racks/Holders',
  10001899: 'Sports Scoring Equipment (Non Powered)',
  10001900: 'Sports Mats/Carpets',
  10001902: 'Sports Equipment Accessories Variety Packs',
  10001903: 'Sports Equipment Accessories Other',
  10001904: 'Sports Protective Mouth Guards',
  10001905: 'Sports Protective Goggles/Eye Masks',
  10001907: 'Sports Protective Body Padding/Guards',
  10001909: 'Sports Protective Support Belts',
  10001911: 'Sports Personal Protective Equipment Variety Packs',
  10001912: 'Sports Personal Protective Equipment Other',
  10001913: 'Fishing Rods/Poles',
  10001914: 'Fishing Reels',
  10001915: 'Fishing Bait/Flies',
  10001916: 'Fishing Hooks',
  10001917: 'Fishing Floats',
  10001918: 'Fishing Nets',
  10001920: 'Fishing Line/Gut',
  10001921: 'Fishing Rod Accessories',
  10001922: 'Fishing/Angling Sports Equipment Variety Packs',
  10001923: 'Fishing/Angling Sports Equipment Other',
  10001928: 'Trash Compactors',
  10001929: 'Food Waste Disposers',
  10001930: 'Waste Disposing/Compacting Appliances Other',
  10001931:
    'Waste Disposing/Compacting Appliances Replacement Parts/Accessories',
  10001938: 'Ice Makers',
  10001939: 'Wine Chillers',
  10001940: 'Coolers/Heaters',
  10001941: 'Refrigerating/Freezing Appliances Other',
  10001942: 'Refrigerating/Freezing Appliances Replacement Parts/Accessories',
  10001950: 'Ovens',
  10001951: 'Hobs/Cooktops',
  10001952: 'Microwave Ovens',
  10001953: 'Major Cooking Appliances Other',
  10001954: 'Major Cooking Appliances Replacement Parts/Accessories',
  10001955: 'Warming Drawers',
  10001956: 'Hostess Trolleys (Powered)',
  10001957: 'Warming Appliances Other',
  10001958: 'Warming Appliances Replacement Parts/Accessories',
  10001959: 'Clothes Washers',
  10001961: 'Combination Clothes Washer/Dryers',
  10001962: 'Major Laundry Appliances Other',
  10001963: 'Major Laundry Appliances Replacement Parts/Accessories',
  10001964: 'Dishwashers',
  10001965: 'Kitchen Washing Appliances Other',
  10001966: 'Kitchen Washing Appliances Replacement Parts/Accessories',
  10001967: 'Toasters',
  10001968: 'Toaster Ovens',
  10001969: 'Electric Grills',
  10001970: 'Sandwich/Waffle Makers',
  10001971: 'Pancake/Doughnut Makers',
  10001972: 'Raclettes (Powered)',
  10001974: 'Rotisseries/Roasters (Powered)',
  10001975: 'Slow Cookers/Hot Pots/Cocottes (Powered)',
  10001976: 'Pressure Cookers (Powered)',
  10001977: 'Rice Cookers/Steamers',
  10001978: 'Multi-cookers (Powered)',
  10001979: 'Pasta Cookers (Powered)',
  10001980: 'Egg Cookers',
  10001981: 'Deep Fryers',
  10001982: 'Woks (Powered)',
  10001983: 'Breadmakers',
  10001984: 'Popcorn Makers',
  10001985: 'Pizza Makers',
  10001986: 'Fondues (Powered)',
  10001987: 'Tajines (Powered)',
  10001988: 'Mexican Diners (Powered)',
  10001989: 'Paella Makers (Powered)',
  10001990: 'Hot Stones (Powered)',
  10001991: 'Cooking Appliances Variety Packs (Powered)',
  10001998: 'Knives (Powered)',
  10002000: 'Can Openers (Powered)',
  10002002: 'Knife Sharpeners (Powered)',
  10002003: 'Vacuum Sealers (Powered)',
  10002004: 'Meat Grinders/Mincers (Powered)',
  10002005: 'Graters (Powered)',
  10002006: 'Coffee Grinders (Powered)',
  10002007: 'Juicers (Powered)',
  10002011: 'Hot Beverage Makers',
  10002012: 'Kettles (Powered)',
  10002013: 'Ice Cream Makers (Powered)',
  10002014: 'Yogurt Makers',
  10002015: 'Butter Makers (Powered)',
  10002016: 'Carbonated Drinks Makers',
  10002018: 'Dehydrators (Powered)',
  10002019: 'Candyfloss Machines',
  10002020: 'Food/Beverage Preparation Appliances Other',
  10002021:
    'Food/Beverage Preparation Appliances Replacement Parts/Accessories',
  10002022: 'Food/Beverage Appliances Variety Packs',
  10002023: 'Clothes Irons (Powered)',
  10002024: 'Ironing Boards (Powered)',
  10002025: 'Clothes Presses',
  10002026: 'Laundry Care Appliances Other',
  10002027: 'Laundry Care Appliances Replacement Parts/Accessories',
  10002028: 'Vacuum Cleaners',
  10002029: 'Sweepers (Powered)',
  10002030: 'Floor Polishers/Shampoo Cleaner',
  10002031: 'Steam Cleaners',
  10002032: 'Cleaning Appliances Other',
  10002033: 'Cleaning Appliances Replacement Parts/Accessories',
  10002034: 'Small Cooking Appliances Other',
  10002035: 'Small Cooking Appliances Replacement Parts/Accessories (Powered)',
  10002069: 'Tents',
  10002070: 'Weather Structures/Tent Extensions',
  10002071: 'Tent Treatments/Repair Kits',
  10002072: 'Tent Accessories',
  10002073: 'Tents/Weather Structures Other',
  10002074: 'Tents/Weather Structures Variety Packs',
  10002075: 'Tent Heaters',
  10002076: 'Camping Lanterns',
  10002077: 'Camping Heating/Lighting Equipment Other',
  10002078: 'Camping Heating/Lighting Equipment Variety Packs',
  10002079: 'Camping Beds/Sleeping Mats',
  10002080: 'Sleeping Bags',
  10002081: 'Camping Seating',
  10002083: 'Camping Storage',
  10002084: 'Camping Tables',
  10002085: 'Camping Furniture/Furnishings Other',
  10002086: 'Camping Furniture/Furnishings Variety Packs',
  10002087: 'Camping Stoves/Grills/Ovens',
  10002088: 'Camping Water Equipment',
  10002091: 'Insulated Boxes/Bags',
  10002092: 'Camping Cookware',
  10002093:
    'Camping Cooking/Drinking/Eating Equipment – Replacement Parts/Accessories',
  10002094: 'Camping Cooking/Drinking/Eating Equipment Other',
  10002095: 'Camping Cooking/Drinking/Eating Equipment Variety Packs',
  10002096: 'Camping Toilets (Non Powered)',
  10002097: 'Camping Showers',
  10002098:
    'Camping Washing/Sanitary Equipment – Replacement Parts/Accessories',
  10002099: 'Camping Washing/Sanitary Equipment Other',
  10002100: 'Camping Washing/Sanitary Equipment Variety Packs',
  10002101: 'Camping Variety Packs',
  10002102: 'Clothing Variety Packs',
  10002103: 'Textual/Printed/Reference Materials Variety Packs',
  10002117: 'Drawers',
  10002118: 'Household/Office Wardrobes/Lockers',
  10002121: 'Kitchen Storage Racks/Stands/Holders/Dispensers',
  10002122: 'Food/Beverage Storage Containers',
  10002123: 'Kitchen Storage Variety Packs',
  10002124: 'Kitchen Storage Other',
  10002125: 'Refuse / Waste Bins',
  10002127: 'Water Filters/Water Filter Cartridges',
  10002128: 'Beverage Decorations/Accessories (Non Edible)',
  10002129: 'Kettles (Non Powered)',
  10002130: 'Bottle Stoppers/Pourers',
  10002131: 'Teapots/Cafetieres/Hot Beverages Carafes',
  10002133: 'Grinders/Juicers/Ice Crushers (Non Powered)',
  10002134: 'Water/Beverage Equipment Variety Packs',
  10002135: 'Water/Beverage Equipment Other',
  10002136: 'Cooking Timers (Non Powered)',
  10002139: 'Food Volume Measuring Equipment',
  10002140: 'Food Thermometers',
  10002141: 'Food Measuring Equipment Variety Packs',
  10002142: 'Food Measuring Equipment Other',
  10002143: 'Kitchen Scales (Non Powered)',
  10002144: 'Hob Pots/Pans/Woks/Cocottes',
  10002146: 'Sieves/Strainers/Colanders',
  10002147: 'Slicing/Chopping Boards',
  10002148: 'Mincers/Choppers/Ricers/Pasta Makers (Non Powered)',
  10002149: 'Cake/Pastry Decorations/Accessories (Non Edible)',
  10002150: 'Bakeware/Ovenware/Grillware (Non Disposable)',
  10002151: 'Kitchen Cookware/Bakeware Variety Packs',
  10002152: 'Cookware/Bakeware Other',
  10002153: 'Plates (Non Disposable)',
  10002154: 'Bowls (Non Disposable)',
  10002155: 'Mugs/Cups (Non Disposable)',
  10002158: 'Serving Jugs/Pitchers/Decanters',
  10002159: 'Serving Trays',
  10002160: 'Food Serving Trolleys (Non Powered)',
  10002161: 'Food/Beverage Warmers/Coolers (Non Powered)',
  10002162: 'Ice/Wine Buckets (Non Powered)',
  10002163: 'Salt/Pepper/Spice Mills (Non Powered)',
  10002165: 'Food Stands/Displays',
  10002168: 'Kitchen Knives/Cleavers',
  10002169: 'Corers/Peelers',
  10002170: 'Spatulas/Scoops/Ladles',
  10002171: 'Tongs/Tweezers/Mallets/Mashers/Whisks',
  10002172: 'Kitchen Slicers/Graters/Cutters',
  10002173: 'Rolling Pins',
  10002174: 'Skewers/Sticks',
  10002175: 'Openers – Kitchen',
  10002176: 'Multifunction Kitchen Tools',
  10002177: 'Food Preparation Equipment Variety Packs',
  10002178: 'Food Preparation Equipment Other',
  10002183: 'Kitchen Merchandise Variety Packs',
  10002184: 'Household/Office Shelving Units',
  10002185: 'Filing Cabinets',
  10002186: 'Universal Entertainment Units',
  10002187: 'Household/Office Boxes/Baskets',
  10002188: 'Storage Rails/Holders',
  10002189: 'Household Organisers/Tidies',
  10002190: 'Household/Office Partitions/Screens',
  10002191: 'Household/Office Storage/Display Furniture/Screens Variety Packs',
  10002192: 'Household/Office Chairs/Stools (Powered)',
  10002193: 'Household/Office Chairs/Stools (Non Powered)',
  10002194: 'Household/Office Sofas (Powered)',
  10002195: 'Household/Office Sofas (Non Powered)',
  10002196: 'Household/Office Sofa Beds',
  10002197: 'Bean Bags/Pouffes/Ottomans',
  10002198: 'Inflatable Seating',
  10002199: 'Household/Office Foot Rests',
  10002200: 'Household/Office Seating Variety Packs',
  10002201: 'Household/Office Seating Other',
  10002202: 'Household/Office Tables',
  10002203: 'Household/Office Desks/Workstations',
  10002205: 'Household/Office Tables/Desks Other',
  10002206: 'Household/Office Tables/Desks Variety Packs',
  10002207: 'Household Bed Frames/Bedsteads',
  10002208: 'Household Adjustable Beds (Powered)',
  10002209: 'Household Adjustable Beds (Non Powered)',
  10002210: 'Household Mattresses',
  10002211: 'Household Inflatable Beds/Water Beds',
  10002212: 'Household Beds/Mattresses Other',
  10002213: 'Household Beds/Mattresses Variety Packs',
  10002214: 'Curtains',
  10002215: 'Window Blinds',
  10002216: 'Furnishing Covers/Cloths – Detachable',
  10002217: 'Cushions',
  10002218: 'Furnishing Floor Rugs/Mats – Detachable',
  10002219: 'Fabric/Textile Towels',
  10002220: 'Household/Office Fabric/Textile Furnishing Variety Packs',
  10002221: 'Household/Office Fabric/Textile Furnishings Other',
  10002222: 'Duvets/Quilts/Mattress Toppers',
  10002223: 'Duvet Covers',
  10002224: 'Blankets/Throws (Non Powered)',
  10002225: 'Pillows',
  10002226: 'Pillow Cases',
  10002227: 'Bed Sheets/Valances',
  10002228: 'Mattress/Pillow/Duvet Protectors',
  10002229: 'Bedding Variety Packs',
  10002230: 'Bedding Other',
  10002231: 'Ornaments',
  10002232: 'Artificial Flowers/Plants/Trees',
  10002233: 'Vases',
  10002234: 'Decorative Magnets/Stickers/Window Clings',
  10002235: 'Sun/Dream Catchers/Windchimes',
  10002236: 'Seasonal Decorations (Non Powered)',
  10002237: 'Seasonal Decorations (Powered)',
  10002238: 'Ornaments Variety Packs',
  10002240: 'Paintings',
  10002241: 'Posters/Prints',
  10002243: 'Photographs',
  10002245: 'Mirrors',
  10002246: 'Picture Frames',
  10002247: 'Pictures/Mirrors/Frames Variety Packs',
  10002248: 'Picture/Mirrors/Frames Other',
  10002249: 'Candle Holders/Accessories',
  10002252: 'Clocks',
  10002423: 'Oral/Mouth Treatments',
  10002424: 'Petticoats/Underskirts/Slips',
  10002425: 'Pantyhose/Stockings',
  10002426: 'Suspenders/Garters',
  10002429: 'Wall Coverings – Rolls',
  10002431: 'Wall Coverings – Tiles',
  10002432: 'Wall/Ceiling Covering Accessories',
  10002433: 'Wall Coverings – Sheets/Panels/Slabs',
  10002441: 'Wall/Ceiling Coverings Other',
  10002442: 'Wall/Ceiling Coverings Variety Packs',
  10002443: 'Flooring – Ceramic/Porcelain Tiles',
  10002444: 'Flooring Accessories',
  10002446: 'Flooring – Carpet',
  10002447: 'Flooring – Solid Wood',
  10002448: 'Flooring – Vinyl/Rubber/Linoleum',
  10002449: 'Flooring – Cork/Bamboo',
  10002450: 'Flooring – Stone/Marble',
  10002451: 'Flooring – Laminate',
  10002452: 'Flooring Other',
  10002453: 'Flooring Variety Packs',
  10002454: 'Insulation – Batts/Rolls/Blankets',
  10002455: 'Insulation – Rigid Foam Board (Interior)',
  10002456: 'Insulation – Loose Fill/Spray Foam',
  10002460: 'Insulation Other',
  10002461: 'Insulation Variety Packs',
  10002462: 'Special Purpose Paints',
  10002466: 'Wood Finish/Treatments/Coatings',
  10002481: 'Painting Replacement Parts',
  10002490: 'Dust Sheets/Drop Sheets',
  10002501: 'Paint/Varnish Removers/Cleaners',
  10002504: 'Painting Variety Packs',
  10002505: 'Painting Other',
  10002506: 'Building Products Variety Packs',
  10002507: 'Stairs – Prefabricated',
  10002512: 'Newel Posts',
  10002515: 'Mezzanine/Attic Ladders',
  10002518: 'Stone – Stone Pavers',
  10002521: 'Aggregate',
  10002522: 'Concrete Mixes',
  10002525: 'Brick/Block',
  10002526: 'Cement',
  10002527: 'Stucco',
  10002528: 'Plaster Mixes',
  10002529: 'Lime (DIY)',
  10002530: 'Columns (Structural)',
  10002532: 'Shims/Spacers',
  10002533: 'Floor Trusses',
  10002534: 'I-Beams',
  10002535: 'Hardwood Lumber (Dimension/Structural)',
  10002536: 'Softwood Lumber (Dimension/Structural)',
  10002537: 'Engineered Wood (Dimension/Structural)',
  10002538: 'Plywood/OSB',
  10002540: 'Gypsum/Cement Board',
  10002542: 'Windows – Combination Units – Wood',
  10002543: 'Window Frames',
  10002544: 'Skylights – Non Wood',
  10002547: 'Window Film',
  10002548: 'Window Locks/Bolts',
  10002550: 'Window Screens',
  10002551: 'Awnings – Powered',
  10002552: 'Window Handles',
  10002553: 'Windows – Storm',
  10002554: 'Window Wells',
  10002557: 'Window Balances',
  10002567: 'Doors – Interior',
  10002568: 'Doors – Garage',
  10002569: 'Doors – Patio',
  10002570: 'Doors – Exterior',
  10002572: 'Door Plates',
  10002573: 'Door Handles/Knobs/Levers',
  10002574: 'Door Closers',
  10002575: 'Door Weather Excluders',
  10002577: 'Cat/Dog Flaps',
  10002578: 'Letter Boxes',
  10002579: 'House Identification – Numbers/Letters',
  10002581: 'Door Knockers',
  10002584: 'Glass',
  10002585: 'Bidets',
  10002586: 'Toilets',
  10002587: 'Urinals',
  10002588: 'Urinal Partitions',
  10002589: 'Toilet/Urinal Cisterns',
  10002590: 'Bathtub/Shower Modules',
  10002592: 'Basins/Sinks',
  10002593: 'Sink/Base Combinations',
  10002595: 'Bathtubs – Soaking',
  10002596: 'Bathtubs – Jetted (Hot Tubs/Spas)',
  10002597: 'Shower Enclosures/Suites',
  10002599: 'Shower Pans/Trays',
  10002600: 'Bathtub/Shower Doors',
  10002601: 'Bathtub/Shower Enclosure Panels',
  10002602: 'Faucets/Taps',
  10002608: 'Shower Heads',
  10002609: 'Basin/Sink Pedestals',
  10002610: 'Bathroom Suites',
  10002611: 'Macerators',
  10002612: 'Sanitary Ware – Replacement Parts/Accessories',
  10002614: 'Sanitary Ware Variety Packs',
  10002623: 'Shower Thermo Alarms',
  10002624: 'Bath Lifts',
  10002627: 'Bathroom Fittings Variety Packs',
  10002646: 'Water Tanks',
  10002648: 'Water Treatments (DIY)',
  10002649: 'Scale Inhibitors',
  10002650: 'Water Storage/Treatment – Accessories/Replacement Parts',
  10002652: 'Water Storage/Treatment Variety Packs',
  10002653: 'Heating System Controls',
  10002654: 'Radiators',
  10002657: 'Immersion Heaters',
  10002658: 'Household Boilers/Furnaces/Tank Water Heaters',
  10002660: 'Central Heating Replacement Parts/Accessories',
  10002662: 'Heating Equipment Variety Packs',
  10002663: 'Lawn/Ground-Level Drainage Parts/Fittings',
  10002664: 'Guttering/Drainage Variety Packs',
  10002665: 'Guttering Parts/Fittings',
  10002666: 'Guttering/Drainage Other',
  10002668: 'Deck Railing Parts',
  10002669: 'Decking – Composite',
  10002670: 'Decking Accessories',
  10002671: 'Deck Railing Systems – Composite',
  10002672: 'Deck Drainage Systems',
  10002673: 'Decking/Railing Other',
  10002674: 'Decking/Railing Variety Packs',
  10002677: 'Exterior Trim – Siding',
  10002683: 'Roofing Tiles/Slates/Shingles/Shakes',
  10002684: 'Roll Roofing',
  10002686: 'Roofing Panels/Slabs',
  10002687: 'Roofing Membranes',
  10002688: 'Roof Coatings',
  10002689: 'Roof/Vent Flashing/Trim Coils',
  10002692: 'Roofing Other',
  10002693: 'Roofing Variety Packs',
  10002713: 'Body Plug/Patch',
  10002720: 'Scratch Fill/Plastic Repair Preparations (Automotive)',
  10002723: 'Reducers/Retarders (Automotive)',
  10002726: 'Replacement Moulding/Trim Pieces (Automotive)',
  10002727: 'Weather-strip (Automotive)',
  10002728: 'Pin Striping (Automotive)',
  10002733: 'Cargo Securing Equipment (Automotive)',
  10002734: 'Equipment Racks/Carriers (Automotive)',
  10002743: 'Extenders/Bumper Packs (Automotive)',
  10002746: 'Vehicle Servicing Ramps/Lifts (Automotive)',
  10002748: 'Interior Storage Boxes/Trays/Baskets (Automotive)',
  10002750: 'Cargo Management Other (Automotive)',
  10002757: 'Car Windscreen Preparation (Automotive)',
  10002764: 'Car Tyre Care – Cleaners/Foams/Shines',
  10002767: 'Car Body Care – Washes/Waxes/Protectors/Removers',
  10002773: 'Car Wheel Care – Cleaners/Shines',
  10002776: 'Appearance Chemicals Other (Automotive)',
  10002777: 'Appearance Chemicals Variety Packs (Automotive)',
  10002778: 'Brake Cleaners',
  10002779: 'Carburettor/Choke Sprays',
  10002780: 'Carburettor/Parts Dip Cleaner',
  10002781: 'Engine Degreasers/Pollution Control',
  10002799: 'Transmission Fluid',
  10002800: 'Transmission Fluid Other',
  10002801: 'Transmission Fluid Variety Packs',
  10002817: 'Muffler/Exhaust Repair',
  10002820: 'Fuel Tank/Line Repair/Kits',
  10002821: 'Radiator Repair/Kits',
  10002822: 'Rear-view Mirror Repair/Kits',
  10002823: 'Window Defogger Repair/Kits',
  10002824: 'Glass Repair/Kits',
  10002825: 'Maintenance/Repair Other',
  10002826: 'Emergency Fuel Aids',
  10002829: 'Back-up Alarms/Sensors',
  10002830: 'Emergency Lights (Automotive)',
  10002833: 'Warning Signs/Triangles (Automotive)',
  10002834: 'Emergency Road Side Kits',
  10002835: 'Safety Other (Automotive)',
  10002836: 'Safety Variety Packs (Automotive)',
  10002837: 'Seats (Automotive)',
  10002838: 'Seat Covers (Automotive)',
  10002839: 'Seat Cushions (Automotive)',
  10002840: 'Seat Belts/Extenders',
  10002841: 'Seat Belt Pads',
  10002842: 'Head/Neck Cushions (Automotive)',
  10002843: 'Seat Hardware/Accessories (Automotive)',
  10002844: 'Consoles (Automotive)',
  10002845: 'Litter Bags/Baskets (Automotive)',
  10002846: 'Interior Storage Other (Automotive)',
  10002847: 'Ash Trays (Automotive)',
  10002848: 'Clocks (Automotive)',
  10002849: 'Clothes Bars (Automotive)',
  10002850: 'Compasses (Automotive)',
  10002851: 'Cup Holders (Automotive)',
  10002852: 'Key Holders (Automotive)',
  10002853: 'Snack/Drink Trays (Automotive)',
  10002854: 'Map Lights (Automotive)',
  10002855: 'Thermometers (Automotive)',
  10002856: 'Interior Accessory Combination Units (Automotive)',
  10002857: 'Fans (Automotive)',
  10002858: 'Refrigeration/Warmer Units (Automotive)',
  10002859: 'Windshield Shades',
  10002860: 'Window Tints',
  10002861: 'Window/Door Visors',
  10002862: 'Steering Wheels',
  10002863: 'Steering Wheel Covers',
  10002864: 'Steering Wheel Hardware/Accessories',
  10002865: 'Replacement Carpet (Automotive)',
  10002866: 'Door Steps/Kick Plates (Automotive)',
  10002867: 'Floor Mats (Automotive)',
  10002868: 'Interior Cargo Liner/Trays (Automotive)',
  10002869: 'Interior Flooring Other (Automotive)',
  10002870: 'Dash Trim Kits',
  10002871: 'Dash Mats/Covers',
  10002872: 'Instrument Panels/Bezels',
  10002873: 'Interior Gauges (Automotive)',
  10002875: 'Shifter Knobs/Handles (Automotive)',
  10002876: 'Shifter Boots/Kits (Automotive)',
  10002877: 'Pedal Covers/Sets (Automotive)',
  10002878: 'Decorative Accessory Knobs/Buttons',
  10002879: 'Decorative Handles/Cranks',
  10002880: 'Decorative Accessories/Hardware Other (Automotive)',
  10002881: 'Headliners/Kits (Automotive)',
  10002882: 'Interior Accessories – Decorative Variety Packs (Automotive)',
  10002883: 'Interior Accessories – Decorative Other (Automotive)',
  10002884: 'Running Boards (Automotive)',
  10002885: 'Nerf/Step Bars (Automotive)',
  10002886: 'Extruded/Cast Steps (Automotive)',
  10002887: 'Bumpers',
  10002888: 'Brush/Grill Guards',
  10002889: 'Push/A Bars (Automotive)',
  10002890: 'Decorative/Custom Grills',
  10002891: 'Grill Inserts',
  10002892: 'Skid Plates',
  10002893: 'Bug/Hood Shields (Automotive)',
  10002894: 'Front Windshield Visors',
  10002895: 'Side Window Deflector/Visors',
  10002896: 'Rear Window Deflector/Roof Visors (Automotive)',
  10002897: 'Sunroof Deflectors',
  10002898: 'Cab Fairings',
  10002899: 'Splash Guards/Mud Flaps',
  10002900: 'Vehicle Covers',
  10002901: 'Door Guards (Automotive)',
  10002902: 'Lens Covers (Automotive)',
  10002903: 'License Plate Frame/Shields',
  10002904: 'License Plates – Decorative',
  10002905: 'Spare Tyre Covers',
  10002906: 'Paint Protection Films (Automotive)',
  10002907: 'Truck Hardware/Kits',
  10002908: 'Tops/Skins – Replacement Parts/Accessories (Automotive)',
  10002909: 'Coverings/Protection Other (Automotive)',
  10002910: 'Sunroofs/Moonroofs/T-tops (Automotive)',
  10002911: 'Scoops/Vents (Automotive)',
  10002912: 'Wings/Spoilers (Automotive)',
  10002913: 'Louvres (Automotive)',
  10002914: 'Fenders/Fender Flares',
  10002915: 'Side Window Mouldings/Covers (Automotive)',
  10002916: 'Custom Hoods',
  10002919: 'Light/Lens Mouldings (Automotive)',
  10002920: 'Emblems/Graphics – Decorative (Automotive)',
  10002922: 'Exterior Appearance Accessories Other (Automotive)',
  10002923: 'Exterior Appearance Accessories Variety Packs',
  10002924: 'Tyres',
  10002926: 'Wheels',
  10002928: 'Tyre Pumps (Automotive)',
  10002929: 'Air Compressors (Automotive)',
  10002930: 'Flat Tyre Repair Kits',
  10002931: 'Wheel Hardware',
  10002932: 'Tyre Inflators – Chemical (Automotive)',
  10002933: 'Wheel Covers',
  10002934: 'Disc Brake Simulators',
  10002935: 'Beauty/Trim Rings',
  10002940: 'Washing/Cleaning Systems – Powered (Automotive)',
  10002944: 'Buffers/Polishing Machines (Automotive)',
  10002949: 'Appearance/Fragrance Accessories Other',
  10002950: 'Appearance/Fragrance Accessories Variety Packs (Automotive)',
  10002959: 'Hitches (Automotive)',
  10002960: 'Hitch Hardware/Assemblies (Automotive)',
  10002961: 'Receiver Tubes/Collars (Automotive)',
  10002962: 'Adaptors – Hitch (Automotive)',
  10002963: 'Pins/Clips – Hitch (Automotive)',
  10002964: 'Tow Ropes/Straps (Automotive)',
  10002965: 'Tow Hooks (Automotive)',
  10002966: 'Tow Bars (Automotive)',
  10002967: 'Towing Locking Accessories',
  10002968: 'Hitch Covers (Automotive)',
  10002969: 'Hitch Steps (Automotive)',
  10002970: 'Towing Mirrors (Automotive)',
  10002971: 'Safety Chains/Cables – Towing (Automotive)',
  10002972: 'Trailer/Hitch Balls (Automotive)',
  10002973: 'Draw Bars/Trailer Ball Mounts (Automotive)',
  10002974: 'Towing Components – Heavy Duty',
  10002976: 'Towing/Hitch Other',
  10002977: 'Towing/Hitch Variety Packs',
  10002978: 'Connectors – Towing',
  10002979: 'Brake Controls',
  10002980: 'Power Modules',
  10002981: 'Wiring Adapters/Converters',
  10002982: 'Wiring Kits/Harnesses',
  10002984: 'Tow Lights',
  10002985: 'Towing/Hitch – Electrical Other',
  10002986: 'Towing/Hitch – Electrical Variety Packs',
  10002987: 'Trailer Jacks/Stands',
  10002988: 'Couplers – Trailer (Automotive)',
  10002989: 'Trailer Brakes',
  10002990: 'Wheel Bearing Protectors',
  10002991: 'Trailer Lighting/Reflectors',
  10002992: 'Levelling Devices (Automotive)',
  10002993: 'Trailers',
  10002994: 'Trailer Hardware',
  10002995: 'Trailer/Trailer Accessories Variety Packs',
  10002996: 'Trailer/Trailer Accessories Other',
  10002998: 'Winches (Automotive)',
  10002999: 'Winch Parts/Components',
  10003000: 'Winch/Winch Accessories Other (Automotive)',
  10003001: 'Winch/Winch Accessories Variety Packs',
  10003004: 'Car Alarms/Anti-jacking Alarms',
  10003008: 'Tracking Devices',
  10003009: 'Anti-theft Products Other',
  10003010: 'Anti-theft Products Variety Packs',
  10003011: 'Wiper Blades',
  10003012: 'Wiper Blade Refills',
  10003013: 'Wipers/Wiper Parts Other',
  10003014: 'Wipers/Wiper Parts Variety Packs',
  10003018: 'Spark Plugs Other',
  10003019: 'Spark Plugs Variety Packs',
  10003022: 'Filters – Air (Automotive)',
  10003024: 'Transmission Filters (Automotive)',
  10003026: 'Filter Accessories (Automotive)',
  10003028: 'Performance Filter Kits/Accessories (Automotive)',
  10003029: 'Filters Other (Automotive)',
  10003030: 'Filters Variety Packs (Automotive)',
  10003031: 'Headlights (Automotive)',
  10003034: 'Replacement Bulbs',
  10003036: 'Fog Lights (Automotive)',
  10003037: 'Back Up Lights (Automotive)',
  10003038: 'Driving Lights',
  10003041: 'Clearance/Marker/Running Lights (Automotive)',
  10003042: 'Siren Lights',
  10003044: 'Stop/Turn/Tail Lights',
  10003045: 'Replacement Lenses (Automotive)',
  10003046: 'Reflectors (Automotive)',
  10003047: 'Lights/Bulbs Other (Automotive)',
  10003048: 'Lights/Bulbs Variety Packs (Automotive)',
  10003049: 'Assemblies – Headlight',
  10003050: 'Assemblies – Taillight',
  10003052: 'Light Assemblies Other (Automotive)',
  10003054: 'Under-Car Lighting',
  10003055: 'Strobe Lighting (Automotive)',
  10003056: 'Accent Lighting (Automotive)',
  10003057: 'Decorative Lighting Other (Automotive)',
  10003058: 'Decorative Lighting Variety Packs (Automotive)',
  10003067: 'Fuses (Automotive)',
  10003074: 'Sockets/Pigtails (Automotive)',
  10003080: 'Flex Tube/Wire Loom (Automotive)',
  10003081: 'Cigarette Lighters/Adaptors (Automotive)',
  10003083: 'Electrical Variety Packs (Automotive)',
  10003084: 'Electrical Other (Automotive)',
  10003092: 'Filter Wrenches (Automotive)',
  10003095: 'Drain Plugs (Automotive)',
  10003097: 'Fluid Change Kits/Accessories',
  10003099: 'Fluid Mixers (Automotive)',
  10003105: 'Fluid Management/Accessories Other (Automotive)',
  10003106: 'Fluid Management/Accessories Variety Packs (Automotive)',
  10003113: 'Oil Mats (Automotive)',
  10003114: 'Fluid Change Items Other (Automotive)',
  10003115: 'Fluid Change Items Variety Packs (Automotive)',
  10003142: 'Wiper Arms (Automotive)',
  10003143: 'Wiper Boots (Automotive)',
  10003144: 'Wiper Motors',
  10003145: 'Wiper Motors (Cores)',
  10003146: 'Wiper Nozzles',
  10003147: 'Wiper Pumps',
  10003149: 'Wiper Tubes/Hoses',
  10003150: 'Wiper Components Other',
  10003151: 'Wiper Components Variety Packs',
  10003156: 'Sandpaper',
  10003157: 'Abrasive Pads/Steel Wool',
  10003159: 'Emery Cloths/Sheets',
  10003162: 'Mineral Abrasives',
  10003163: 'Abrasives Other',
  10003164: 'Abrasives Variety Packs',
  10003165: 'Turnbuckles (Fixings/Fasteners)',
  10003166: 'Rings/Grommets',
  10003167: 'Ropes/Chains/Cables (Fixings/Fasteners)',
  10003168: 'Springs',
  10003170: 'Bearings/Bushings',
  10003171: 'Hooks (Fixings/Fasteners)',
  10003173: 'Tubing',
  10003179: 'Anchors/Wall Plugs (Fixings/Fasteners)',
  10003180: 'Washers (Fixings/Fasteners)',
  10003181: 'Screws',
  10003182: 'Nails/Pins (Fixings/Fasteners)',
  10003183: 'Staples (Fixings/Fasteners)',
  10003184: 'Nuts (Fixings/Fasteners)',
  10003185: 'Bolts/Threaded Rods',
  10003186: 'Brackets/Braces',
  10003187: 'Catches (Fixings/Fasteners)',
  10003190: 'Rivets (Fixings/Fasteners)',
  10003191: 'Hinges – Door',
  10003194: 'Fixings/Fasteners Hardware Other',
  10003195: 'Fixings/Fasteners Hardware Variety Packs',
  10003196: 'Curtain Poles/Rods',
  10003197: 'Curtain Tracks',
  10003201: 'Curtain Parts/Accessories Other',
  10003202: 'Curtain Parts/Accessories Variety Packs',
  10003203: 'Grout',
  10003204: 'Sealants',
  10003205: 'Fillers',
  10003206: 'Tape (DIY)',
  10003207: 'Glue/Adhesive',
  10003208: 'Caulking',
  10003210: 'Sealants/Fillers/Adhesives Other',
  10003211: 'Sealants/Fillers/Adhesives Variety Packs',
  10003213: 'Pond/Water Feature Shells/Liners',
  10003215: 'Garden Water Features',
  10003216: 'Pool/Pond/Water Feature Filters (Powered)',
  10003218: 'Pond/Water Feature Foggers',
  10003219: 'Pool/Pond/Water Feature UV Clarifiers/Sterilizers',
  10003220: 'Pond/Water Feature Aerators',
  10003221: 'Pool/Water Feature Chemicals/Treatments',
  10003222: 'Pool/Pond/Water Feature Drainage Pipes',
  10003223: 'Pool/Pond/Water Feature Protective Covers',
  10003224: 'Lawn/Garden Pools/Ponds/Water Features Variety Packs',
  10003225: 'Lawn/Garden Pools/Ponds/Water Features Other',
  10003227: 'Weed-Killer/ Herbicide',
  10003234: 'Plant/Soil Fertilizer/Food',
  10003235: 'Mulch',
  10003236: 'Topsoil',
  10003237: 'Water/Soil Testing Equipment (Powered)',
  10003238: 'Water/Soil Testing Equipment (Non Powered)',
  10003239: 'Lawn/Garden Chemicals/Treatments Variety Packs',
  10003240: 'Lawn/Garden Chemicals/Treatments Other',
  10003242: 'Garden Chairs',
  10003243: 'Garden Loungers',
  10003245: 'Garden Tables',
  10003246: 'Garden Footrests',
  10003248: 'Garden Benches',
  10003249: 'Garden Swing Benches',
  10003250: 'Hammocks',
  10003251: 'Lawn/Garden Furnishings Replacement Parts/Accessories',
  10003252: 'Lawn/Garden Furnishings Variety Packs',
  10003253: 'Lawn/Garden Furnishings Other',
  10003254: 'Hoses',
  10003255: 'Hose Connectors',
  10003256: 'Hose Storage – Stationary',
  10003257: 'Hose Storage – Mobile',
  10003262: 'Sprinklers/Sprayers/Misters (Hose End)',
  10003264: 'Irrigation Systems',
  10003267: 'Watering Cans',
  10003268: 'Garden Water Storage Supplies',
  10003270: 'Sprinklers/Sprayers/Misters (Hand Held)',
  10003271: 'Sprinklers/Sprayers/Misters (Powered)',
  10003272: 'Lawn/Garden Watering Equipment Variety Packs',
  10003273: 'Lawn/Garden Watering Equipment Replacement Parts',
  10003274: 'Lawn/Garden Watering Equipment Other',
  10003276: 'Irrigation Timers/Controllers',
  10003277: 'Fence Panels/Boards',
  10003278: 'Fence Posts/Rails',
  10003279: 'Fence Stays/Braces',
  10003280: 'Garden Borders/Edges',
  10003281: 'Fence Net/Mesh',
  10003283: 'Electric Fence/Radio Fences',
  10003284: 'Trellising',
  10003285: 'Razor/Barbed Wire Fencing',
  10003286: 'Gates (Non Powered)',
  10003287: 'Gates (Powered)',
  10003288: 'Lawn/Garden Fencing Variety Packs',
  10003289: 'Lawn/Garden Fencing Other',
  10003290: 'Bulbs/Corms/Rhizomes/Tubers - Other',
  10003291: 'Seeds/Spores',
  10003305: 'Plants Variety Packs',
  10003308: 'Compost/Vermiculture Bins',
  10003311: 'Lawn/Garden Waste Disposal Other',
  10003313: 'Plant Holders',
  10003314: 'Outdoor Bins',
  10003315: 'Garden/Water Feature Ornaments',
  10003316: 'Garden Display Units',
  10003321: 'Canopies/Tarpaulins (Lawn/Garden)',
  10003323: 'Outdoor Heaters (Powered)',
  10003324: 'Outdoor Heaters (Non Powered)',
  10003328: 'Barbecues',
  10003330: 'Grill Islands (Lawn/Garden)',
  10003332: 'Warmers/Drawers (Lawn/Garden)',
  10003334: 'Lawn/Garden Cooking/Heating Appliances Variety Packs',
  10003335: 'Lawn/Garden Cooking/Heating Appliances Other',
  10003336:
    'Lawn/Garden Cooking/Heating Appliances Replacement Parts/Accessories',
  10003338: 'Garden Vacuums/Blowers',
  10003341: 'Snow Throwers (Powered)',
  10003347: 'Lawn Scarifiers/Aerators (Powered)',
  10003351: 'Chippers/Shredders/Mulchers (Powered)',
  10003352: 'Lawn/Garden Equipment Accessories',
  10003353: 'Lawn Mowers/Rakers (Powered)',
  10003355: 'Brush Cutters/String Trimmers/Edgers (Powered)',
  10003359: 'Chain Saws (Powered)',
  10003365: 'Earth Augers (Powered)',
  10003367: 'Log Splitters (Powered)',
  10003368: 'Stump Grinders/Pullers (Powered)',
  10003370: 'Tampers (Powered)',
  10003373: 'Cultivators/Tillers/Rotary Hoes (Powered)',
  10003375: 'Pressure Washers (Powered)',
  10003376: 'Garden Carts (Powered)',
  10003377: 'Lawn Sweeps/Spreaders (Non Powered)',
  10003379: 'Garden Shears (Non Powered)',
  10003380: 'Loppers',
  10003381: 'Pruners/Secateurs',
  10003383: 'Axes',
  10003384: 'Sickles/Scythes/Snaths',
  10003385: 'Mauls',
  10003386: 'Harrows',
  10003387: 'Lawn Mowers/Rakers (Non Powered)',
  10003388: 'Hoes',
  10003389: 'Edgers (Non Powered)',
  10003390: 'Shovels/Spades',
  10003391: 'Forks (Lawn/Garden)',
  10003392: 'Lawn/Garden Trowels',
  10003393: 'Lawn Aerators (Non Powered)',
  10003394: 'Lawn Rollers (Non Powered)',
  10003395: 'Tampers (Non Powered)',
  10003396: 'Sifters (Lawn/Garden)',
  10003397: 'Cultivators/Tillers (Non Powered)',
  10003398: 'Bulb Planters',
  10003399: 'Rakes',
  10003400: 'Garden Incinerators',
  10003401: 'Weed Burners (Powered)',
  10003402: 'Lawn/Garden Power Tools Replacement Parts/Accessories',
  10003403: 'Lawn Bags',
  10003404: 'Garden Carts (Non Powered)',
  10003405: 'Seed Starters',
  10003406: 'Garden Kneelers/Seats',
  10003407: 'Garden Power Tools Variety Packs',
  10003408: 'Garden Power Tools Other',
  10003409: 'Greenhouses (Complete)',
  10003411: 'Sheds',
  10003412: 'Gazebos',
  10003414: 'Arbours/Bowers',
  10003415: 'Conservatories',
  10003416: 'Pagodas (Lawn/Garden)',
  10003417: 'Marquees',
  10003418: 'Lawn/Garden Outdoor Structures Other',
  10003419: 'Lawn/Garden Outdoor Structures Replacement Parts/Accessories',
  10003421: 'Cold Frames/Propagators/Cloches',
  10003427: 'Lightning Detectors – Powered',
  10003430: 'Anemometers – Non Powered',
  10003432: 'Psychrometers – Powered',
  10003433: 'Pyranometers/Solarimeters – Powered',
  10003434: 'Evaporimeters/Atmometers – Powered',
  10003435: 'Sunshine Recording Equipment – Powered',
  10003436: 'Light Meters – Powered',
  10003437: 'Hygrometers – Non-Powered',
  10003440: 'Thermometers – Garden – Non Powered',
  10003441: 'Barometers – Non Powered',
  10003443: 'Barographs – Non Powered',
  10003444: 'Combination Weather Measuring/Monitoring Equipment – Non Powered',
  10003446: 'Wind Socks/Weather Vanes',
  10003447: 'Rain Gauges – Non Powered',
  10003451:
    'Lawn/Garden Weather Monitoring/Observation Replacement Parts/Accessories',
  10003452: 'Lawn/Garden Weather Monitoring/Observation Other',
  10003453: 'Lawn/Garden Weather Monitoring/Observation Variety Packs',
  10003454: 'Dividers/Compass (DIY)',
  10003455: 'Rulers (DIY)',
  10003458: 'Tape Measures (DIY)',
  10003459: 'Micrometers',
  10003461: 'Measuring Wheels',
  10003463: 'Callipers (DIY)',
  10003464: 'Squares (DIY)',
  10003465: 'Levels',
  10003466: 'Plumb Bobs',
  10003468: 'Work Benches',
  10003470: 'Saw Horses/Trestles',
  10003473: 'Platforms/Scaffolding',
  10003476: 'Putty/Wallboard Knives',
  10003479: 'Combination Cutting Tools (Non Powered)',
  10003480: 'Pipe/Tube Cutters – Non Powered',
  10003481: 'Bolt/Chain Cutters',
  10003482: 'Wire Cutters',
  10003483: 'Cutters/Nibblers – Tiles (Non Powered)',
  10003485: 'Cutters – Glass (Non Powered)',
  10003486: 'Snips/Shears/Nibblers – Sheet Metal (Non Powered)',
  10003487: 'Punches',
  10003488: 'Chisels',
  10003489: 'Nailsets/Countersinks',
  10003490: 'Awls',
  10003491: 'Gouges',
  10003492: 'Knives – Non Powered (Hobby/Utility)',
  10003495: 'Nail Pullers',
  10003496: 'Wheelbarrows – Non Powered',
  10003497: 'Hand Trucks/Dollies',
  10003498: 'Suction Lifters',
  10003499: 'Crowbars/Pry Bars',
  10003500: 'Hammers (DIY)',
  10003501: 'Hammers/Mallets/Hatches Replacement Parts/Accessories',
  10003502: 'Staple/Nail Gun – Non Powered',
  10003504: 'Hammer Tacker – Non Powered',
  10003505: 'Riveting Tools',
  10003507: 'Nailing/Stapling/Fixing Tool Replacement Pars/Accessories',
  10003508: 'Wrenches/Spanners',
  10003527: 'Wrenches/Spanners/Keys Replacement Parts/Accessories',
  10003528: 'Screwdrivers – Non Powered',
  10003530: 'Screwdriver Sets',
  10003532: 'Pliers/Pincers/Grabbers',
  10003533: 'Files',
  10003534: 'Rasps',
  10003535: 'Clamps',
  10003536: 'Vises',
  10003537: 'Vises/Clamps Replacement Parts/Accessories',
  10003538: 'Grinders (Non Powered)',
  10003539: 'Honing Guides',
  10003540: 'Tool Sharpeners (Non Powered)',
  10003541: 'Drills – Non Powered',
  10003542: 'Drilling Replacement Parts/Accessories',
  10003543: 'Scrapers',
  10003544: 'Planes',
  10003545: 'Surface Forming Tools',
  10003546: 'Surface Forming Tool Consumables',
  10003547: 'Smoothers/Floats',
  10003548: 'Tubing Benders',
  10003549: 'Flaring Tools',
  10003550: 'Dies (Non Powered)',
  10003551: 'Tap/Die Sets',
  10003552: 'Anvils (DIY)',
  10003555: 'Air Compressors – Portable',
  10003562: 'Screw Extractors',
  10003563: 'Nut Splitters',
  10003564: 'Drain Augers – Non Powered',
  10003565: 'Plungers',
  10003572: 'Roller Stands',
  10003573: 'Plaster Hawks',
  10003576: 'Pencils/Crayons (DIY)',
  10003578: 'Tool Carts',
  10003586: 'Safety Glasses/Goggles',
  10003594: 'Masonry Trowels',
  10003596: 'Wet Saws/Tile/Glass Cutters',
  10003597: 'Band Saws – Stationary',
  10003598: 'Bench Grinders',
  10003601: 'Table Saws – Stationary',
  10003602: 'Scroll Saws – Stationary',
  10003603: 'Radial Arm Saws',
  10003604: 'Bench Jointers',
  10003605: 'Lathes – Stationary (Powered)',
  10003608: 'Power Tools – Stationary – Replacement Parts/Accessories',
  10003609: 'Disc Sanders',
  10003610: 'Spindle Sanders',
  10003611: 'Combination Sanders – Disc/Belt',
  10003613: 'Drill Presses/Mortisers',
  10003615: 'Surface/Thickness Planers – Portable',
  10003616: 'Jointer Planers – Portable',
  10003618: 'Distance/Linear Measurers (Powered)',
  10003619: 'Angle Measures (Powered)',
  10003620: 'Laser Levels',
  10003626: 'Laminate Trimmers',
  10003627: 'Table Saws – Portable',
  10003629: 'Reciprocating Saws',
  10003631: 'Jigsaws – Powered',
  10003632: 'Nibblers/Shears – Metal (Powered)',
  10003638: 'Foam Cutters – Powered',
  10003639: 'Tappers',
  10003640: 'Pipe Cutters (Powered)',
  10003641: 'Rotary Saws',
  10003642: 'Pipe Threaders – Non Powered',
  10003643: 'Chisels (Powered)',
  10003644: 'Angle Grinders',
  10003645: 'Cut-off Tools',
  10003647: 'Straight/Die Grinders',
  10003648: 'Surface Grinders',
  10003649: 'Soldering/Brazing Irons',
  10003651: 'Arc Welders',
  10003653: 'Drill/Drivers (Powered)',
  10003654: 'Screwdrivers/Rotary Tools (Powered)',
  10003655: 'Impact Drivers',
  10003656: 'Impact Wrenches',
  10003657: 'Screw Guns',
  10003658: 'Drills – Combination (Powered)',
  10003659: 'Hammer Drills',
  10003660: 'Rotary Hammers',
  10003662: 'Heat Guns',
  10003663: 'Grease Guns (Powered)',
  10003664: 'Caulking Guns (Powered)',
  10003665: 'Staplers (Powered)',
  10003666: 'Nail Guns (Powered)',
  10003668: 'Belt Sanders – Stationary',
  10003669: 'Finishing Sanders',
  10003672: 'Detail Sanders',
  10003674: 'Tool Cabinets',
  10003676: 'Tool Boxes/Cases',
  10003677: 'Tool Carrybags/Wallets',
  10003678: 'Tool Belts/Holsters/Pouches',
  10003679: 'Hoists/Winches',
  10003680:
    'Power Tools – Lifting/Handling Equipment Replacement Parts/Accessories',
  10003682: 'Tools/Equipment – Power Variety Packs',
  10003685: 'In-car Electronics Variety Packs',
  10003686: 'Photography/Optics Variety Packs',
  10003688: 'Sports Equipment Variety Packs',
  10003689: 'Non Grape Fermented Alcoholic Beverages – Sparkling',
  10003690: 'Range Cookers/Stoves (Oven/Hob/Cook Top Combined)',
  10003691: 'Steam Ovens',
  10003692: 'Spin/Tumble Dryers',
  10003694: 'Refrigerators',
  10003695: 'Refrigerator/Freezers',
  10003698: 'Freezers',
  10003704: 'Protective Wear Accessories',
  10003705: 'Protective Wear Variety Packs',
  10003707: 'Sportswear – Handwear',
  10003708: 'Sportswear – Headwear',
  10003709: 'Sportswear Hosiery',
  10003710: 'Beverage Chillers Other',
  10003711: 'Shoe Cleaners/Polishers',
  10003712: 'Water Dispensers – Freestanding',
  10003713: 'Water Dispensers – Tabletop',
  10003714: 'Shrubs/Trees',
  10003718: 'Dual Discs – Pre-recorded',
  10003729: 'Surface Planers – Stationary',
  10003730: 'Jointer Planers – Stationary',
  10003737: 'Routers',
  10003738: 'Mitre Saws – Portable',
  10003741: 'Drain Augers (Powered)',
  10003742: 'Belt Sanders – Portable',
  10003744: 'Welding/Blow Torches',
  10003746: 'Shapers – Stationary',
  10003747: 'Power Tools – Hand-held Portable Replacement Parts/Accessories',
  10003749: 'Power Tools – Lifting/Handling Equipment Other',
  10003750: 'Power Tools – Hand-held Portable Other',
  10003751: 'Power Tools – Stationary Other',
  10003752: 'Air Fresheners – Powered (Automotive)',
  10003753: 'Air Fresheners – Non Powered (Automotive)',
  10003755: 'Locking Devices',
  10003757: 'Ice Scrapers (Automotive)',
  10003758: 'Horns/Sirens (Automotive)',
  10003759: 'Spot Lights (Automotive)',
  10003760: 'Safety Replacement Parts/Accessories (Automotive)',
  10003761: 'Body Repair Other (Automotive)',
  10003762: 'Filters – Fluid (Automotive)',
  10003763: 'Spark Plugs',
  10003764: 'Washer Fluid (Automotive)',
  10003765: 'Polishing Compound',
  10003766: 'Floor Screeds',
  10003767: 'Curtain Pole/Rod Accessories',
  10003771: 'Stationery/Office Machinery/Occasion Supplies Variety Packs',
  10003773: 'Camping Tableware',
  10003774: 'Mirrors (Automotive)',
  10003775: 'Electric Parts Cleaner (Automotive)',
  10003776: 'Magnifying Glasses',
  10003777: 'Audio Visual/Photography Variety Packs',
  10003778: 'Awls/Punches/Nailsets Variety Packs',
  10003779: 'Mobile Communication Devices/Services – Replacement Parts',
  10003787: 'Chisels/Gouges Variety Packs',
  10003788: 'Mallets (DIY)',
  10003789: 'Hatchets (DIY)',
  10003790: 'Household/Office Storage/Display Furniture Other',
  10003791: 'Hammers/Mallets/Hatchets Variety Packs (DIY)',
  10003795: 'Wrenches/Spanners/Keys Variety Packs',
  10003796: 'Wrenches/Spanners Sets',
  10003797: 'Wrenches – Ratchet Extensions/Handles',
  10003799: 'Saws – Non Powered',
  10003800: 'Blades – Saw – Non Powered',
  10003801: 'Saws – Hand – Replacement Parts/Accessories',
  10003807: 'Planes/Shapers/Files/Rasps Variety Packs',
  10003808: 'Taps (Non Powered)',
  10003813: 'Fabric/Textile Furnishings Variety Packs',
  10003814: 'Household/Office Furniture Variety Packs',
  10003816: 'Ornamental Furnishings Variety Packs',
  10003817: 'Video Game Consoles – Non Portable',
  10003818: 'Video Game Consoles – Portable',
  10003819: 'Video Game Consoles – Replacement Parts',
  10003821: 'Ladders',
  10003822: 'Carrying/Lifting/Climbing Equipment Replacement Parts/Accessories',
  10003823: 'Knives – Non Powered Replacement Parts/Accessories',
  10003824: 'Knife Blades – Non Powered (Hobby/Utility)',
  10003825: 'Screwdrivers Other',
  10003826: 'Screwdrivers Replacement Parts/Accessories',
  10003827: 'Hex Keys',
  10003834: 'Automotive Body Repair Variety Packs',
  10003839: 'Wiper Cowls',
  10003841: 'Lawn Rollers (Powered)',
  10003842: 'Earth Augers (Non Powered)',
  10003843: 'Pruners (Powered)',
  10003844: 'Post Hole Diggers (Non Powered)',
  10003846: 'Digging Bars',
  10003852: 'Vegetables/Fungi',
  10003854: 'Variety Planters – Box/Pot',
  10003857: 'Garden Water Pumps',
  10003859: 'Plants/Fauna Tunnels',
  10003861: 'Post Hole Diggers (Powered)',
  10003862: 'Wedges',
  10003863: 'Picks',
  10003864: 'Lawn/Garden Hand Tools Replacement Parts/Accessories',
  10003865: 'Lawn/Garden Hand Tools Other',
  10003866: 'Lawn/Garden Hand Tools Variety Packs',
  10003867: 'Applicators/Feeders (Non Powered)',
  10003868: 'Lawn Bag Stands/Holders',
  10003869: 'Applicators/Feeders (Powered)',
  10003870: 'Hedge Trimmers (Powered)',
  10003872: 'Lawn/Garden Equipment Other',
  10003873: 'Lawn/Garden Equipment Variety Packs',
  10003874: 'Household Paints/Primers',
  10003884: 'Wall/Ceiling Covering Tools – Powered',
  10003887: 'Lawn/Garden Testing Diagnostic Equipment Other',
  10003889:
    'Lawn/Garden Testing Diagnostic Equipment Replacement Parts/Accessories',
  10003890: 'Greenhouse Frames',
  10003891: 'Lawn/Garden Outdoor Structures Variety Packs',
  10003894: 'Stone – Building Stone',
  10003896: 'Plaster of Paris (Agent)',
  10003897: 'Sand (DIY)',
  10003898: 'Asphalt/Concrete Patching',
  10003899: 'Concrete Bonding Agents',
  10003900: 'Concrete Colouring Agents/Dyes',
  10003901: 'Concrete Air-entraining Agents',
  10003902: 'Mortar Mixes',
  10003903: 'Asphalt/Concrete/Masonry Variety Packs',
  10003904: 'Asphalt/Concrete/Masonry Other',
  10003906: 'Door Thresholds',
  10003914: 'Keys',
  10003916: 'Storm/Screen Door Replacement Hardware',
  10003918: 'Door Hardware Other',
  10003919: 'Door Hardware Variety Packs',
  10003920: 'Doors – Storm/Screen Combination',
  10003921: 'Doors – Bulkhead (Basement)',
  10003923: 'Doors Other',
  10003924: 'Doors Variety Packs',
  10003925: 'Glass Block (Grid Systems)',
  10003926: 'Decorative Glass Inserts',
  10003927: 'Beams (Structural)',
  10003932: 'Lumber/Wood Panel/Gypsum Other',
  10003933: 'Lumber/Wood Panel/Gypsum Variety Packs',
  10003934: 'Mouldings – Non Wood',
  10003935: 'Mouldings – Wood',
  10003939: 'Millwork – Ornaments',
  10003942: 'Structural Components/Assemblies Other',
  10003943: 'Structural Components/Assemblies Replacement Parts/Accessories',
  10003944: 'Window Parts/Accessories Variety Packs',
  10003946: 'Windows – Single Units – Wood',
  10003955: 'Drop Outlets (Guttering/Drainage)',
  10003956: 'Down Spout Parts/Fittings',
  10003959: 'Stair Railing Systems – Wood',
  10003960: 'Stair Railing Systems – Non Wood',
  10003961: 'Balustrade/Railing Systems – Non Wood',
  10003962: 'Balustrade/Railing Systems – Wood',
  10003966: 'Exterior Trim – Corbels/Pediments',
  10003968: 'Window Shutters',
  10003969: 'Exterior Trim – Veneers',
  10003974: 'Roofing – Thatch',
  10003977: 'Roofing Accessories',
  10003980: 'Ceiling Coverings – Panneling/Tiles',
  10003981: 'Ceiling Grid Systems',
  10003982: 'Air Conditioners/Coolers – Fixed',
  10003984:
    'Air Conditioning/Cooling/Ventilation Equipment Replacement Parts/Accessories',
  10003985: 'Air Conditioning/Cooling/Ventilation Equipment Variety Packs',
  10003988: 'Air Purifiers/Ionisers – Fixed',
  10003990: 'Air Dehumidifiers – Fixed',
  10003992: 'Air Heaters – Portable',
  10003993: 'Air Humidifiers – Fixed',
  10003994: 'Plumbing/Heating Ventilation/Air Conditioning Variety Packs',
  10003995: 'Fans – Ceiling',
  10003996: 'Duct Boosters',
  10003997: 'Ducting',
  10003998: 'Fans – Extractor',
  10004002: 'Thermostats',
  10004003: 'Underfloor Heating Systems',
  10004006: 'De-scalers (DIY)',
  10004008: 'Water Softeners (DIY)',
  10004012: 'Water Meters',
  10004016: 'Water Filtration Machines/Systems',
  10004022: 'Pipes/Tubing Connectors',
  10004024: 'Pipes/Tubing Valves/Fittings',
  10004026: 'Shower Safety Strips',
  10004027: 'Bath Seats',
  10004028: 'Grab Bars',
  10004029: 'Bathtub/Shower Modules – Jetted',
  10004032: 'Bath/Shower Caddies – Fixed',
  10004033: 'Towel Bars/Hooks/Rings – Fixed',
  10004034: 'Soap/Lotion/Sanitizer Dispensers',
  10004044: 'Shower Spas',
  10004049: 'Septic Tanks',
  10004054: 'Pipes/Tubing',
  10004055: 'Pumps',
  10004057: 'Pipes/Tubing – Accessories/Replacement Parts',
  10004058: 'Pipes/Tubing Supply Variety Packs',
  10004062: 'Toilet Seats/Lids',
  10004063: 'Air Conditioning Equipment – Multifunction – Fixed',
  10004064: 'Fans – Window/Exhaust',
  10004096: 'Combat Sports Equipment Other',
  10004097: 'Racquet Sports Equipment Other',
  10004098: 'Fencing Sports Equipment (Powered)',
  10004099: 'Camping Water Heaters',
  10004100: 'Camping Toilets (Powered)',
  10004101: 'Clocks – Replacement Parts',
  10004102: 'Garden Tractors',
  10004103: 'Audio Books',
  10004104: 'Audio Periodicals',
  10004105: 'Printed Maps',
  10004106: 'Electronic Maps',
  10004107: 'Books Variety Packs',
  10004108: 'Periodicals Variety Packs',
  10004109: 'Fungicides',
  10004110: 'Lawn/Garden Soil/Soil Amendments Other',
  10004111: 'Sports Scoring Equipment (Powered)',
  10004112: 'Fencing Sports Equipment (Non Powered)',
  10004113: 'Sportswear – Neckwear',
  10004114: 'Sportswear – Belts',
  10004115: 'Activewear – Badges/Buckles',
  10004116: 'Brasswind Musical Instrument Accessories (Non Powered)',
  10004117: 'Keyboard/Piano Accessories (Powered)',
  10004118: 'Percussion Musical Instrument Accessories (Non Powered)',
  10004119: 'String Musical Instrument Accessories (Non Powered)',
  10004120: 'Woodwind Musical Instrument Accessories (Non Powered)',
  10004121: 'Musical Instrument Cases/Bags/Covers',
  10004122: 'Musical Instrument Cleaning Products',
  10004123: 'Metronomes/Tuners (Powered)',
  10004124: 'Musical Instrument Holders/Stands/Lyres',
  10004125: 'Metronomes/Tuners (Non Powered)',
  10004126: 'Musical Instruments/Accessories Variety Packs',
  10004127: 'Musical Instrument Accessories Variety Packs',
  10004128: 'Musical Instrument Accessories Other',
  10005095: 'Household/Office Tables/Desks – Replacement Parts/Components',
  10005096: 'Household Beds – Replacement Parts/Components',
  10005097: 'Household/Office Chairs – Replacement Parts/Components',
  10005098:
    'Household/Office Storage/Display Furniture – Replacement Parts/Components',
  10005100: 'Workshop Aids Replacement Parts/Accessories',
  10005101: 'Workshop Aids Other',
  10005102: 'Tool Storage Other',
  10005104: 'Tool Storage Variety Packs',
  10005105: 'Environmental Respiratory Protection – Powered',
  10005106: 'Environmental Respiratory Protection – Non Powered',
  10005107: 'Hearing Protection – Powered',
  10005108: 'Hearing Protection – Non Powered',
  10005109: 'Helmets – Powered',
  10005110: 'Helmets – Non Powered',
  10005111: 'Hard Hats/Caps',
  10005112: 'Face Shields/Guards',
  10005115: 'Protective Personal Aids Replacement Parts/Accessories',
  10005116: 'Protective Personal Aids Other',
  10005117: 'Protective Personal Aids Variety Packs',
  10005118: 'Sticky Notes/Paper Cubes',
  10005119: 'Paper Shredders (Powered)',
  10005120: 'Stationery Paper/Card/Film Other',
  10005121: 'Stationery Paper/Card/Film Variety Packs',
  10005122: 'Tax Disc Holders (Automotive)',
  10005124: 'Abrasives Replacement Parts-Accessories',
  10005125: 'Book Covers',
  10005126: 'Stationery Adhesive Tapes',
  10005127: 'Automotive Appearance/Fragrance – Accessories/Replacement Parts',
  10005128: 'Exterior Storage Carriers/Bags (Automotive)',
  10005129: 'Anti-theft Products Replacement Parts/Accessories',
  10005130: 'Cargo Management – Replacement Parts/Accessories',
  10005131: 'Automotive Electrical – Replacement Parts/Accessories',
  10005132: 'Automotive Switches',
  10005133: 'Board Games (Non Powered)',
  10005134: 'Board Games (Powered)',
  10005135: 'Board Games/Cards/Puzzles – Accessories/Replacement Parts',
  10005136: 'Board Games/Cards/Puzzles Other',
  10005137: 'Board Games/Cards/Puzzles Variety Packs',
  10005138: 'Card Games (Non Powered)',
  10005139: 'Card Games (Powered)',
  10005140: 'Puzzles (Non Powered)',
  10005141: 'Puzzles (Powered)',
  10005142: 'Dolls/Soft Toys (Non Powered)',
  10005143: 'Dolls/Soft Toys (Powered)',
  10005144: 'Dolls/Puppets/Soft Toys Other',
  10005145: 'Puppets',
  10005146: 'Dolls Beauty/Cosmetic Accessories',
  10005147: 'Dolls Buildings/Settings',
  10005148: 'Dolls Clothing',
  10005149: 'Dolls Furniture',
  10005150: 'Dolls/Puppets/Soft Toys Accessories Other',
  10005151: 'Dolls/Puppets/Soft Toys Accessories Variety Packs',
  10005152: 'Puppet Theatres',
  10005153: 'Baby/Infant Stimulation Toys (Non Powered)',
  10005154: 'Baby/Infant Stimulation Toys (Powered)',
  10005155: 'Bath/Pool Water Toys',
  10005156: 'Communication Toys (Non Powered)',
  10005157: 'Communication Toys (Powered)',
  10005158: 'Toy Computers',
  10005159: 'Developmental/Educational Toys Other',
  10005160: 'Developmental/Educational Toys Variety Packs',
  10005161: 'Push/Pull-along Toys (Non Powered)',
  10005162: 'Push/Pull-along Toys (Powered)',
  10005163: 'Scientific Toys (Non Powered)',
  10005164: 'Scientific Toys (Powered)',
  10005165: 'Spinning Tops/Yo-Yos',
  10005166: 'Toy Building Blocks (Non Powered)',
  10005167: 'Toy Building Blocks (Powered)',
  10005168: 'Toy Model Construction (Non Powered)',
  10005169: 'Toy Model Construction (Powered)',
  10005170: 'Viewing Toys (Non Powered)',
  10005171: 'Viewing Toys (Powered)',
  10005172: 'Fancy Dress Costumes',
  10005173: 'Fancy Dress Costumes/Accessories Other',
  10005174: 'Fancy Dress Costumes/Accessories Variety Packs',
  10005175: 'Fancy Dress Accessories (Non Powered)',
  10005176: 'Fancy Dress Accessories (Powered)',
  10005177: 'Musical Toys (Non Powered)',
  10005178: 'Musical Toys (Powered)',
  10005179: 'Musical Toys Other',
  10005180: 'Outdoor Games/Play Structures Other',
  10005181: 'Indoor/Outdoor Games',
  10005182: 'Outdoor Play Structures',
  10005183: 'Table Games (Non Powered)',
  10005184: 'Table Games (Powered)',
  10005185: 'Table Games Other',
  10005186: 'Toys/Games Variety Packs',
  10005187: 'Toys – Ride-on (Non Powered)',
  10005188: 'Toys – Ride-on (Powered)',
  10005189: 'Toys – Ride-on Other',
  10005190: 'Car/Train Sets (Non Powered)',
  10005191: 'Car/Train Sets (Powered)',
  10005192: 'Car/Train Set – Replacement Parts/Accessories',
  10005193: 'Toy Vehicles – Non-ride (Non Powered)',
  10005194: 'Toy Vehicles – Non-ride (Powered)',
  10005195: 'Toy Vehicles – Non-ride Other',
  10005196: 'Toy Vehicles – Non-ride Variety Packs',
  10005197: 'Blankets (Powered)',
  10005198: 'Camping Water Purification Treatments',
  10005199: 'Household/Office Cupboards/Display Cabinets',
  10005200: 'Toiletry Bags/Vanity Cases',
  10005201: 'Kitchen Knife Sharpeners (Non Powered)',
  10005204: 'Megaphones',
  10005205: 'Car Audio Cassette Players/Changers',
  10005206: 'Desktop Mats',
  10005207: 'Photograph Albums – Replacement Parts/Accessories',
  10005208: 'Household Water Testing Kits',
  10005209: 'Kitchen Storage – Replacement Parts/Accessories',
  10005210: 'Napkin Rings',
  10005211: 'Generators',
  10005213: 'Glue Guns – Powered',
  10005214: 'Cement/Mortar Mixing Machines',
  10005215: 'Outdoor Lamps/Torches/Lanterns – Powered',
  10005216: 'Outdoor Lamps/Torches/Lanterns – Non Powered',
  10005217: 'Lawn/Garden Lighting Replacement Parts/Accessories',
  10005218: 'Lawn/Garden Lighting Other',
  10005219: 'Umbrellas/Parasols',
  10005220: 'Plant Supports/Stakes',
  10005221: 'Wheelbarrows – Powered',
  10005223: 'Circular Saws',
  10005224: 'Egg Based Products / Meals – Not Ready to Eat (Frozen)',
  10005225: 'Egg Based Products / Meals – Not Ready to Eat (Perishable)',
  10005226: 'Egg Based Products / Meals – Not Ready to Eat (Shelf Stable)',
  10005227: 'Dairy/Egg Based Products / Meals – Ready to Eat (Perishable)',
  10005228: 'Dairy/Egg Based Products / Meals – Ready to Eat (Shelf Stable)',
  10005229: 'Multifunctional Devices',
  10005230: 'Air Compressors – Stationary',
  10005231: 'Band Saws – Portable',
  10005232: 'Batteries (Automotive)',
  10005233: 'Battery Accessories (Automotive)',
  10005234: 'Antifreeze/Coolants (Automotive)',
  10005241: 'Immobilisers (Automotive)',
  10005248: 'Disc Sanders – Portable',
  10005249: 'Automotive Applicators/Brushes',
  10005250: 'Role Play – Kitchen Toys',
  10005252: 'Socket Sets',
  10005253: 'Pool Supplies',
  10005254: 'Shelf Grip Liner/Contact Paper',
  10005255: 'Fuel Additives',
  10005256: 'Fuel Pumps (Non Powered)',
  10005257: 'Fuel Pumps (Powered)',
  10005258: 'Gas Fuel Bottles/Canisters (Empty)',
  10005262: 'Fuels/Fuel Additives Variety Packs',
  10005263: 'Liquid Fuels',
  10005264: 'Gas Fuels',
  10005265: 'Gel Fuels',
  10005266: 'Solid Fuels',
  10005267: 'Lubricating Oils/Fluids',
  10005268: 'Lubricating Greases',
  10005269: 'Lubricating Waxes',
  10005270: 'Lubricating Products Variety Packs',
  10005272: 'Antifreeze/Coolants',
  10005273: 'Anti-corrosives',
  10005275: 'Protective Compounds Variety Packs',
  10005276: 'Lubricant Containers/Dispensers (Empty)',
  10005277: 'Drain Pans',
  10005280: 'Lubricants/Protective Compounds Storage Variety Packs',
  10005281: 'Lubricating Oil/Fluid Pumps (Non Powered)',
  10005282: 'Lubricating Oil/Fluid Pumps (Powered)',
  10005283: 'Lubricants/Protective Compounds Variety Packs',
  10005284: 'Windows – Single Units – Clad Wood',
  10005285: 'Windows – Single Units – Non Wood',
  10005286: 'Windows – Combination Units – Non Wood',
  10005287: 'Windows – Combination Units – Clad Wood',
  10005288: 'Skylights – Tubular',
  10005289: 'Skylights – Clad Wood',
  10005290: 'Windows – Other',
  10005291: 'Awnings – Non Powered',
  10005292: 'Window Parts/Accessories Other',
  10005293: 'Windows – Replacement Sash – Non Wood',
  10005294: 'Windows – Replacement Sash – Wood',
  10005295: 'Windows – Bay/Bow – Wood',
  10005296: 'Windows – Bay/Bow – Non Wood',
  10005297: 'Windows – Bay/Bow – Clad Wood',
  10005298: 'Window Operators',
  10005306: 'Liquid Fuel Bottles/Containers (Empty)',
  10005316: 'Combination Weather Measuring/Monitoring Equipment – Powered',
  10005317: 'Air Conditioners – Portable',
  10005318: 'Anemometers – Powered',
  10005319: 'Thermometers – Garden – Powered',
  10005320: 'Rain Gauges – Powered',
  10005321: 'Anti-spatter Products',
  10005322: 'Cooker Hoods',
  10005323: 'Hygrometers – Powered',
  10005331: 'Air Humidifiers – Portable',
  10005332: 'Air Dehumidifiers – Portable (Powered)',
  10005333: 'Air Ionisers – Portable',
  10005334: 'Air Coolers – Portable',
  10005335: 'Air Controlling Appliances – Multifunction – Portable',
  10005336: 'Air Purifiers – Portable',
  10005337: 'Fans – Portable',
  10005342: 'Insulation – Radiant Barriers/Heat Shields',
  10005343: 'Insulation – Rigid Board (Exterior)',
  10005345: 'Insulation Supports/Anchors',
  10005355: 'Softwood Board',
  10005356: 'Lubricants Variety Packs',
  10005357: 'Ice Crushers/Ice Cube Makers (Powered)',
  10005358: 'Cookie Guns (Powered)',
  10005359: 'Warming Trays (Powered)',
  10005360: 'Leaf Shine/Plant Cleaner',
  10005361: 'Mail/Post Boxes (Lawn/Garden)',
  10005362: 'Animal Scarers/Deterrents (Lawn/Garden) - Non-Powered',
  10005365: 'Cooking Timers (Powered)',
  10005366: 'Floral/Plant Accessories (Lawn/Garden)',
  10005367: 'Garden Shelving/Worktops',
  10005368: 'Lawn/Garden Waste Disposal Replacement Parts/Accessories',
  10005369: 'Greenhouse Heaters/Ventilators',
  10005370: 'Flooring – Engineered Wood',
  10005371: 'Stationery Scissors',
  10005372: 'Artists Drawing Boards',
  10005373: 'Body Alarms',
  10005374: 'Emergency Whistles',
  10005375: 'Key-ring Alarms',
  10005376: 'Personal Luggage Alarms',
  10005377: 'Personal Safety Flares/Signals',
  10005378: 'Personal Safety Lights',
  10005379: 'Self-defence Sprays',
  10005380: 'Stun Guns',
  10005381: 'Wearable Wireless Webcams (Inverse Surveillance)',
  10005382: 'Personal Safety Devices Variety Packs',
  10005383: 'Fire Retardants/Suppressants',
  10005384: 'Fire Escape Chutes/Ladders',
  10005385: 'Public Fire Alarms',
  10005386: 'Smoke Hoods/Respirators',
  10005387: 'Environmental Fire/Chemical Safety Products Variety Packs',
  10005388: 'Air/Fog Horns',
  10005389: 'Lifebelts/Life-Jackets/Lifesuits',
  10005390: 'Liferafts/Life-Buoys/Flotation Cushions',
  10005391: 'Lightning Rods/Accessories',
  10005392: 'Sandbags/Flood-guards',
  10005393: 'Storm Shelters',
  10005394: 'Transponders',
  10005395: 'Weather/Natural Disaster Safety Product Variety Packs',
  10005396: 'Burglar Alarms',
  10005397: 'Gas/Heat/Smoke Detectors',
  10005398: 'Access Control Security Systems',
  10005399: 'Door/Gate Entry Intercoms',
  10005400: 'Door/Gate/Window Bolts/Locks/Keys',
  10005401: 'Door Chains',
  10005402: 'Door/Gate Viewers',
  10005403: 'Security Doors/Gates',
  10005405: 'Window Burglar Bars/Panels/Shutters',
  10005406: 'Door/Window/Perimeter Security Products Variety Packs',
  10005407: 'Fire Blankets',
  10005408: 'Fire Extinguishers – Pressurised',
  10005409: 'Fire Hoses',
  10005410: 'Home/Business Fire Extinguishers Variety Packs',
  10005411: 'Bugging/Debugging Equipment',
  10005412: 'Light/Motion/Sound Sensors',
  10005413: 'Security Lights',
  10005414: 'Surveillance Cameras/Video Recorders',
  10005415: 'Home/Business Surveillance Equipment Variety Packs',
  10005416: 'Safes',
  10005417: 'Home/Business Safety/Security/Surveillance Variety Packs',
  10005418: 'Safety/Security/Surveillance Variety Packs',
  10005424: 'Poles/Pilings/Rods',
  10005425: 'Stair Replacement Parts/Fittings',
  10005426: 'Food Preparation Brushes/Oil Pumps/Baster',
  10005427: 'Egg Cups (Non Disposable)',
  10005428: 'Jambs (Mouldings/Millwork)',
  10005429: 'Food Funnels',
  10005430: 'Food Shaping Moulds',
  10005431: 'Mouldings/Millwork/Stair Parts Other',
  10005432: 'Mouldings/Millwork/Stair Parts Variety Packs',
  10005434: 'Cookie Guns/Food Decorating Syringes (Non Powered)',
  10005435: 'Cappuccino Creamers (Non Powered)',
  10005436: 'Party Horns/Blowers',
  10005437: 'Furniture Castors/Pads/Slides',
  10005438: 'Computer Stands/Supports',
  10005439: 'Styling Dolls Heads (Non Powered)',
  10005440: 'Styling Dolls Heads (Powered)',
  10005441: 'Toys – Ride-on Accessories',
  10005442: 'Toy Drawing Boards/Accessories',
  10005443: 'Practical Jokes',
  10005444: 'Adhesive Paste/Glue Removers',
  10005445: 'Overhead Projectors',
  10005446: 'Insects',
  10005447: 'Arachnids (Spiders/Scorpions)',
  10005448: 'Annelids (Worms)',
  10005449: 'Molluscs',
  10005450: 'Crustaceans',
  10005451: 'Sponges',
  10005452: 'Sea Stars/Sea Urchins',
  10005453: 'Jelly Fish',
  10005454: 'Coral/Sea Anemone',
  10005455: 'Rodents',
  10005456: 'Fishes',
  10005457: 'Birds',
  10005458: 'Amphibians',
  10005459: 'Primates',
  10005460: 'Feline (Cats)',
  10005461: 'Bovine (Cattle)',
  10005462: 'Caprine (Goats)',
  10005463: 'Equine (Horses/Donkeys)',
  10005464: 'Swine (Pigs)',
  10005465: 'Ovine (Sheep)',
  10005466: 'Reptiles',
  10005467: 'Marsupials',
  10005468: 'Lagomorphs (Hares/Rabbits)',
  10005469: 'Cetaceans (Whales/Dolphins/Porpoises)',
  10005470: 'Bottle/Can Insulators',
  10005471: 'Door Accessories',
  10005472: 'Emergency Survival Blankets/Sleeping Bags',
  10005473: 'Alarm Systems Replacement Parts/Accessories',
  10005474: 'Rock Salt/Ice Melting Products',
  10005475: 'Invertebrates Other',
  10005476: 'Vertebrates Other',
  10005478: 'Fireplaces/Fireplace Surrounds/Mantels',
  10005479: 'Tankless Water Heaters',
  10005480: 'Waste Traps',
  10005481: 'Ballasts/Starters',
  10005496: 'Adaptors (Electrical)',
  10005505: 'Wall Plates (Electrical)',
  10005541: 'Electrical Wires',
  10005546: 'Bonding/Grounding Braid',
  10005559: 'Extension/Power Supply Cords',
  10005560: 'Bells/Chimes/Buzzers',
  10005567: 'Sockets/Receptacles/Outlets',
  10005568: 'Splitters',
  10005570: 'Relays/Contactors',
  10005571: 'Cable/Wire Pullers',
  10005572: 'Electrical Connection Variety Packs',
  10005573: 'Connectors (Electrical)',
  10005575: 'Busbars/Busways',
  10005576: 'Circuit Breakers',
  10005577: 'Electrical Distribution Accessories/Fittings',
  10005583: 'Distribution Boards/Boxes',
  10005585: 'Surge Suppressors/Protectors',
  10005586: 'Switches',
  10005588: 'Terminal Blocks/Strips',
  10005599: 'Multimeters',
  10005622: 'Capacitors',
  10005625: 'Canine (Dogs)',
  10005626: 'Absorbents (DIY)',
  10005627: 'Antifatigue Aids (DIY)',
  10005628: 'Antislip Aids (DIY)',
  10005630: 'Safety Nets/Curtains/Barriers',
  10005631: 'Protective Collective Aids Replacement Parts/Accessories',
  10005632: 'Asphalt/Concrete/Masonry Replacement Parts/Accessories',
  10005633: 'Light Bulb Sockets',
  10005634: 'Dimmers',
  10005635: 'Lampshades',
  10005636: 'Lampstands/Bases',
  10005637: 'Lamp Brackets/Fittings',
  10005638: 'Light Bulb Changers',
  10005639: 'Lighting – Fixed',
  10005640: 'Fibre Optic Lighting',
  10005641: 'Lamps – Freestanding',
  10005642: 'Electric Torches/Flashlights',
  10005643: 'Electric Lanterns – Portable',
  10005644: 'Rope/String Lights',
  10005645: 'Tools/Equipment – Hand Variety Packs',
  10005646: 'Protective Collective Aids Other',
  10005647: 'Cable/Wire Conduit/Ducting/Raceways',
  10005648: 'Cable Markers',
  10005649: 'Cable Reels/Pullers',
  10005650: 'Cabling/Wiring Protection/Wrapping',
  10005651: 'Cable Clips/Grommets/Ties',
  10005653: 'Paint Applicators – Powered',
  10005654: 'Paint Applicators – Non Powered',
  10005655: 'Paint Additives/Enhancers',
  10005656: 'Paint Application Accessories',
  10005657: 'Preservers/Preservatives',
  10005658: 'Pipe Freezing Tools',
  10005659: 'Roof Trusses',
  10005660: 'Conduit Fittings',
  10005661: 'Circuit Assemblies/Integrated Circuits',
  10005662: 'Discreet Components',
  10005667: 'Electronic Circuit Accessories',
  10005668: 'Drain Covers (Guttering/Drainage)',
  10005669: 'Extension Light – Portable',
  10005670: 'Fixings/Fasteners Hardware Accessories',
  10005672: 'Wall/Ceiling Covering Tools – Non Powered',
  10005673: 'Gate/Garage Door Opening Systems',
  10005674: 'Cable Marking Accessories',
  10005675: 'Cookware/Bakeware Accessories/Replacement Parts',
  10005676: 'Typewriter Consumables',
  10005677: 'Fax Machine Consumables',
  10005678: 'Lawn/Garden Fencing Accessories',
  10005679: 'Pulleys and Belt Drives',
  10005680: 'Telephone Wipes',
  10005681: 'Fixed Communication Devices Accessories',
  10005682: 'Multi-use/Universal Electrical Timers/Controllers',
  10005683: 'Computer/Video Games Mass Storage',
  10005684: 'Role Play – Housekeeping/Gardening/DIY Toys',
  10005685: 'Role Play – Shopping/Office/Business Toys',
  10005686: 'Digital Pens',
  10005687: 'Trim Paints',
  10005688: 'Curtain Holdbacks',
  10005689: 'Frozen Drinks Makers/Ice Shavers (Powered)',
  10005690: 'Chocolate Fountains (Powered)',
  10005691: 'Wine/Bottle Openers (Powered)',
  10005692: 'Ornament Accessories',
  10005693: 'Salt/Pepper Shakers',
  10005694: 'Flour/Sugar Shakers',
  10005695: 'Kitchen Scales (Powered)',
  10005697: 'Portable Air Control Appliances Replacement Parts/Accessories',
  10005700: 'Digital Photo Frames',
  10005701: 'Food Preparation Bowls',
  10005702: 'Pumps (Non Powered)',
  10005703: 'Pumps ( Powered)',
  10005704: 'Hot Dog Rollers',
  10005705: 'Exterior Trim – Siding Accessories',
  10005706: 'Paint/Stain Strainers',
  10005707: 'Marking Chalks/String Lines',
  10005708: 'Household Paint Brushes/Rollers/Applicators',
  10005709: 'Exterior Convex Mirrors',
  10005710: 'Portable Speakers',
  10005711: 'Personal Digital Broadcasters/Trackers',
  10005712: 'Toy Computer Accessories',
  10005713: 'Foam Craft Materials',
  10005714: 'Funnels (DIY)',
  10005715: 'Wire Brushes',
  10005716: 'Bevel Gauges',
  10005717: 'Room Heaters',
  10005718: 'Biscuit Joiners',
  10005719: 'Garden Ornaments/Plaques',
  10005720: 'Auto Repair Crawlers/Creepers',
  10005721: 'Laths',
  10005722: 'Corner Guards',
  10005723: 'Workshop Cloths/Rags',
  10005724: 'Painting Masking Paper/Film',
  10005725: 'Barricade Safety Tapes',
  10005726: 'Analogue/Digital Converters',
  10005727: 'Lip Balms',
  10005728: 'Car Radar Detectors',
  10005729: 'Ground Cover/Landscaping/Mulching Fabrics',
  10005730: 'Decorative (Faux) Painting Equipment',
  10005731: 'Exterior Trim – Skirting/Underpinning',
  10005732: 'Mobile Home Assembly/Set-up Equipment',
  10005733: 'Insulation – Pipe Lagging/Wrapping',
  10005735: 'Visual Distribution Amplifiers',
  10005736: 'Low-noise Block (LNB) Converters',
  10005738: 'Video Receiving/Installation Accessories',
  10005739: 'Video Receiving/Installation Variety Packs',
  10005740: 'Digital Enhanced Cordless Telecommunications (DECT) Repeaters',
  10005741: 'Computer/Video Game Headsets',
  10005742: 'Electronic Testers',
  10005743: 'Universal Turntables',
  10005744: 'Audio Visual Labelling Systems',
  10005745: 'Communication Headphones Replacement Parts/Accessories',
  10005746: 'Vibration Absorbers/Dampers',
  10005747: 'MP3 Docking Stations',
  10005748: 'Memory Card Recorders',
  10005749: 'Car GPS Antennae',
  10005750: 'Camera Flash Accessories',
  10005751: 'Photographic Slides – Replacement Parts/Accessories',
  10005752: 'Photographic Slide Storage',
  10005753: 'Photographic Studio Flash Gun',
  10005754: 'Computer Cables',
  10005755: 'Photographic Camera Filters',
  10005756: 'Key Rings',
  10005757: 'Audio Visual Cables',
  10005758: 'Telecommunication Cables',
  10005759: 'Satellite Installation Cables',
  10005760: 'Satellite Reception Accessories',
  10005761: 'Air Conditioning Refrigerants',
  10005762: 'Vacuum Cleaner Bags',
  10005763: 'Console Accessories',
  10005764: 'Battery Boxes',
  10005765: 'Portable FM (Frequency Modulation) Transmitters',
  10005766: 'Projection Tables',
  10005767: 'Beef – Prepared/Processed',
  10005768: 'Bison/Buffalo – Prepared/Processed',
  10005769: 'Chicken – Prepared/Processed',
  10005770: 'Deer, other than Roe Deer – Prepared/Processed',
  10005771: 'Duck – Prepared/Processed',
  10005772: 'Frog – Prepared/Processed',
  10005773: 'Goat – Prepared/Processed',
  10005774: 'Horse – Prepared/Processed',
  10005776: 'Land Snail – Prepared/Processed',
  10005777: 'Llama/Alpaca – Prepared/Processed',
  10005778:
    'Mixed Species Meat/Poultry/Other Animal - Alternative Meat – Prepared/Processed',
  10005779: 'Ostrich – Prepared/Processed',
  10005780: 'Pheasant – Prepared/Processed',
  10005781: 'Pork – Prepared/Processed',
  10005782: 'Rabbit – Prepared/Processed',
  10005783:
    'Alternative Meat/Poultry/Other Animals Species – Prepared/Processed',
  10005784: 'Turkey – Prepared/Processed',
  10005785: 'Veal – Prepared/Processed',
  10005786: 'Beef – Unprepared/Unprocessed',
  10005787: 'Bison/Buffalo – Unprepared/Unprocessed',
  10005788: 'Chicken – Unprepared/Unprocessed',
  10005789: 'Deer, other than Roe Deer – Unprepared/Unprocessed',
  10005790: 'Duck – Unprepared/Unprocessed',
  10005791: 'Frog – Unprepared/Unprocessed',
  10005792: 'Goat – Unprepared/Unprocessed',
  10005793: 'Horse – Unprepared/Unprocessed',
  10005795: 'Land Snail – Unprepared/Unprocessed',
  10005796: 'Llama/Alpaca – Unprepared/Unprocessed',
  10005797: 'Mixed Species Meat – Unprepared/Unprocessed',
  10005798: 'Ostrich – Unprepared/Unprocessed',
  10005799: 'Pheasant – Unprepared/Unprocessed',
  10005800: 'Pork – Unprepared/Unprocessed',
  10005801: 'Rabbit – Unprepared/Unprocessed',
  10005802:
    'Alternative Meat/Poultry/Other Animal Species – Unprepared/Unprocessed',
  10005803: 'Turkey – Unprepared/Unprocessed',
  10005804: 'Veal – Unprepared/Unprocessed',
  10005805: 'Air Hopper Guns/Sprayers',
  10005806: 'Router Tables',
  10005807: 'Portable PA (Public Address) Music Systems',
  10005808: 'Audiograms',
  10005809: 'Sound-active Effect Lighting',
  10005810: 'Household/Office Bar Counters',
  10005811: 'Sweepers (Non Powered)',
  10005812: 'Rangefinders',
  10005813: 'Electronic Gift Cards',
  10005814: 'Scooters/Skateboards/Hoverboards (Powered)',
  10005815: 'Cycles (Powered)',
  10005816: 'Decorative Banners/Flags',
  10005817: 'Personal Carrier Bags (Disposable)',
  10005818: 'Wheel Chocks (Automotive)',
  10005819: 'Cargo Management Ramps/Ramp Accessories (Automotive)',
  10005820: 'Warning Flags/Flag Staffs (Automotive)',
  10005821: 'Protective Hose Bridges (Automotive)',
  10005822: 'Caramel/Toffee Apples',
  10005823: 'Meat Substitutes  (Frozen)',
  10005824: 'Meat Substitutes (Perishable)',
  10005825: 'Meat Substitutes (Shelf Stable)',
  10005826:
    'Dairy Based Products / Meals – Not Ready to Eat/Drink (Perishable)',
  10005827: 'Dairy Based Products / Meals – Not Ready to Eat/Drink (Frozen)',
  10005828: 'Car Audio Subwoofers',
  10005829: 'Satellite/Terrestrial Antenna Systems',
  10005830: 'Ironing Steam Station',
  10005831: 'USB Internet Stick',
  10005832:
    'Alternative Meat/Poultry/Other Animal Sausages – Prepared/Processed',
  10005833: 'Beef Sausages – Prepared/Processed',
  10005834: 'Chicken Sausages – Prepared/Processed',
  10005835: 'Lamb/Mutton Sausages – Prepared/Processed',
  10005836: 'Mixed Species Sausages – Prepared/Processed',
  10005837: 'Turkey Sausages – Prepared/Processed',
  10005838: 'Veal Sausages – Prepared/Processed',
  10005839: 'Oral Care Centre – Brush/Cleanser/Storage (Powered)',
  10005840: 'Pork Sausages – Prepared/Processed',
  10005841: 'Audio/Visual Receivers',
  10005842: 'Mobile Photo Storage',
  10005843: 'Video Editor',
  10005844: 'Medical Devices',
  10005845: 'Pharmaceutical Drugs',
  10005846: 'Storage Barrels/Kegs (Empty)',
  10005847: 'Storage Drums (Empty)',
  10005848: 'Storage/Haulage Boxes (Empty)',
  10005849: 'Storage/Haulage Crates (Empty)',
  10005850: 'Storage/Haulage Trays (Empty)',
  10005851: 'Storage Bottles (Empty)',
  10005852: 'Portable Storage Cylinders (Empty)',
  10005853: 'Storage/Haulage Tanks (Empty)',
  10005854: 'Pallets',
  10005855: 'Transport Dollies',
  10005856: 'Slip Sheets',
  10005857: 'Pallet Converters/Frames',
  10005858: 'Racks',
  10005859: 'Ocean Intermodal Freight Containers (Empty)',
  10005860: 'Air Freight Containers (Empty)',
  10005861: 'Flexible Bulk Containers (Empty)',
  10005862: 'Rigid Intermediate Bulk Containers (Empty)',
  10005863: 'Backflow Test Kits',
  10005864: 'Vacuum Breakers',
  10005865: 'Backflow Preventer Parts/Accessories',
  10005866: 'Backflow Preventers',
  10005867: 'Pipes/Tubing Flanges',
  10005868: 'Party Drink Fountains (Powered)',
  10005869: 'Stud Finders/Detectors/Sensors',
  10005870: 'Fishfinders',
  10005872: 'Marine Electronic Chartplotters',
  10005873: 'Marine Navigation Software',
  10005874: 'Marine Navigation Radar Systems',
  10005875: 'Solar Power Stations',
  10005876: 'Grapefruits',
  10005877: 'Pummelos',
  10005878: 'Honey Pomelos',
  10005879: 'Sweeties',
  10005880: 'Minneolas and other Tangelos',
  10005881: 'Ugli',
  10005882: 'Lemons',
  10005883: 'Mexican Limes',
  10005884: 'Limes',
  10005885: 'Limequats',
  10005886: 'Clementines',
  10005887: 'Satsuma Mandarins',
  10005888: 'Tangerines',
  10005889: 'Oranges',
  10005893: 'Exercise Books',
  10005894: 'Gloves',
  10005895: 'Apple Bananas',
  10005896: 'Baby Bananas',
  10005897: 'Bananas',
  10005898: 'Plantain Bananas',
  10005899: 'Red Bananas',
  10005900: 'Apples',
  10005901: 'Japanese Medlars',
  10005902: 'Nashi',
  10005903: 'Pears',
  10005905: 'Apricots',
  10005907: 'Sour Cherries',
  10005908: 'Stemless/Sweet Cherries',
  10005909: 'Damsons',
  10005910: 'Mirabelles',
  10005911: 'Nectarines',
  10005912: 'Peaches',
  10005913: 'Greengages',
  10005914: 'Japanese Plums',
  10005915: 'Plumcots',
  10005916: 'Stonefruit Hybrids',
  10005917: 'Plums',
  10005918: 'Table Grapes',
  10005921: 'Strawberries',
  10005922: 'Wood Strawberries',
  10005923: 'Blackberries',
  10005924: 'Boysenberries',
  10005925: 'Cloudberries',
  10005927: 'Raspberries',
  10005928: 'Bilberries',
  10005929: 'Blueberries',
  10005930: 'Cranberries',
  10005932: 'Gooseberries',
  10005934: 'Jostaberries',
  10005935: 'Pineapples',
  10005937: 'Kiwifruits',
  10005938: 'Kiwiberries',
  10005939: 'Cherimoya',
  10005940: 'Sugar Apples',
  10005941: 'Bullock Hearts',
  10005942: 'Soursop',
  10005946: 'Kaki/ Sharon Fruits',
  10005948: 'American Persimmon',
  10005949: 'Barbadines',
  10005950: 'Curubas',
  10005951: 'Sweet Granadilla',
  10005952: 'Yellow Maracujas',
  10005953: 'Purple Maracujas',
  10005954: 'Papayas Formosa',
  10005955: 'Babacos',
  10005956: 'Yellow Dragonfruits',
  10005957: 'Sweet Pitayas',
  10005959: 'Dates',
  10005960: 'Figs',
  10005961: 'Carambola',
  10005963: 'Bilimbi',
  10005964: 'Lychees (Litchi)',
  10005965: 'Cape Gooseberries',
  10005966: 'Rambutan',
  10005967: 'Prickly Pears (Barbary Figs)',
  10005968: 'Mangosteen',
  10005969: 'Mangos',
  10005970: 'Pomegranates',
  10005971: 'Guavas',
  10005972: 'Durian',
  10005973: 'Breadfruits',
  10005974: 'Jackfruits',
  10005976: 'French/Wax Beans',
  10005979: 'Runner Beans',
  10005980: 'Broad Beans',
  10005981: 'Jack Beans',
  10005982: 'Lima Beans',
  10005984: 'Peas',
  10005985: 'Sugar Snap Peas',
  10005986: 'Carobs',
  10005987: 'Cauliflower',
  10005988: 'Broccoli',
  10005996: 'Brussel Sprouts',
  10005997: 'Red Cabbages',
  10005999: 'White Cabbages',
  10006000: 'Savoy Cabbages',
  10006003: 'Garlic',
  10006004: 'Elephant Garlic',
  10006005: 'Spring (or Spanish) Onions',
  10006006: 'Onions',
  10006007: 'Kurrat',
  10006009: 'Shallots',
  10006014: 'Cucumbers',
  10006015: 'Courgettes',
  10006031: 'Oyster Mushrooms',
  10006032: 'Morels',
  10006033: 'Chanterelles',
  10006034: 'Shiitake Mushrooms',
  10006035: 'Cep',
  10006036: 'Truffles',
  10006037: 'Watermelons',
  10006038: 'Pumpkins/Winter Squash',
  10006040: 'Ramsons',
  10006041: 'Basil',
  10006044: 'Mugwort',
  10006045: 'Summer Savoury',
  10006046: 'Winter Savoury',
  10006047: 'Borage',
  10006048: 'Watercress',
  10006049: 'Dill',
  10006050: 'Archangel',
  10006051: 'Tarragon',
  10006052: 'Fennel  (Subspecies dulce)',
  10006053: 'Chervil',
  10006054: 'Coriander',
  10006055: 'Garden Cress',
  10006056: 'Caraway',
  10006057: 'Lovage',
  10006058: 'Laurel',
  10006059: 'Marjoram',
  10006060: 'Pot Marjoram',
  10006061: 'Balm',
  10006063: 'Mint',
  10006065: 'Sweet Cicely',
  10006066: 'Oregano',
  10006071: 'Burnet Saxifrage',
  10006072: 'Rosemary',
  10006074: 'Chives',
  10006075: 'Common Thyme',
  10006076: 'Lemon Thyme',
  10006077: 'Hyssop',
  10006078: 'Lemon Verbena',
  10006079: 'Head Lettuce (Butterhead)',
  10006085: 'Romaine (Cos) Lettuce',
  10006086: 'Lambs Lettuce',
  10006088: 'Rocket',
  10006089: "Dandelion Greens/Lion's Tooth",
  10006090: 'Sorrel',
  10006091: 'Spinach',
  10006092: 'Purslane',
  10006093: 'Witloof (Belgian Endive)',
  10006094: 'Radicchio Rosso',
  10006095: 'Sugarloaf',
  10006097: 'Endive (Curled)',
  10006100: 'Elongated Sweet Peppers (Pointed)',
  10006102: 'Chilli Peppers',
  10006104: 'Potatoes',
  10006107: 'Taro',
  10006108: 'Cassava',
  10006109: 'Lilac Tannia',
  10006110: 'White Tannia',
  10006111: 'Sweet Potatoes',
  10006112: 'Yams',
  10006113: 'Ginger',
  10006114: 'Radishes',
  10006115: 'Black Radishes',
  10006116: 'May Turnips',
  10006117: 'Turnip Tops',
  10006118: 'Swedish Turnips (Rutabagas)',
  10006119: 'Teltow Turnips',
  10006120: 'Turnips',
  10006121: 'Beetroot',
  10006122: 'Carrots',
  10006123: 'Celeriac',
  10006124: 'Horseradish',
  10006125: 'Jerusalem Artichokes',
  10006126: 'Parsnips',
  10006127: 'Parsley Root (Hamburg)',
  10006128: 'Aubergines',
  10006129: 'Asparagus',
  10006130: 'Globe Artichokes',
  10006131: 'Celery',
  10006133: 'Leek',
  10006134: 'Rhubarb',
  10006135: 'Cardoons',
  10006136: 'Palm Hearts',
  10006137: 'Bamboo Shoots',
  10006143: 'Chinese Cabbages',
  10006144: 'Kale',
  10006145: 'Pak Choi',
  10006146: 'Kohlrabi',
  10006147: 'Sweetcorn',
  10006148: 'Okra',
  10006155: 'Endive (Broad Leaf)',
  10006157: 'Common Cultivated Mushroom (Agaricus)',
  10006158: 'Yardlong Beans',
  10006159: 'Lemongrass',
  10006160: 'Feijoas',
  10006161: 'Cherry Tomatoes – Oblong',
  10006162: 'Cherry Tomatoes – Round',
  10006163: 'Tomatoes – Oblong',
  10006164: 'Tomatoes – Ribbed',
  10006165: 'Tomatoes – Round',
  10006166: 'Tomatoes Variety Packs',
  10006167: 'Finger Avocados',
  10006168: 'Avocados – Pebbled Peel (Hass-Type)',
  10006169: 'Avocados – Smooth Peel',
  10006171: 'Vegetables – Unprepared/Unprocessed (Fresh) Variety Packs',
  10006172: 'Fruits – Unprepared/Unprocessed (Fresh) Variety Packs',
  10006173: 'Quinces',
  10006190: 'Square Sweet Peppers (Blunt)',
  10006191: 'Square Tapering Sweet Peppers (Peg Top)',
  10006192: 'Flat Sweet Peppers (Tomato Peppers)',
  10006193: 'Red Currants',
  10006194: 'Black Currants',
  10006195: 'Pepper Variety Packs',
  10006196: 'Romanesco',
  10006197: 'Pointed Cabbage',
  10006198: 'Curled Parsley',
  10006199: 'Flat Parsley (Italian)',
  10006200: 'Scorzonera',
  10006201: 'Display Test (Cosmetics)',
  10006202: 'In-Shell Nest Run Eggs',
  10006203: 'In-Shell Checked/Dirty Eggs',
  10006204: 'Eggs Extracts',
  10006210: 'In Shell Table Eggs',
  10006211: 'Individually Cooked Eggs',
  10006212: 'Eggs Products/Substitutes',
  10006213: 'Eggs Imitations',
  10006214: 'Extracts/Seasonings/Flavour Enhancers (Shelf Stable)',
  10006215: 'Dispensers for Cleaning/Hygiene Products',
  10006216: 'Soups – Prepared Variety Packs',
  10006217: 'Sandwiches/Filled Rolls/Wraps Variety Packs',
  10006218: 'Soy/Rice Milk Maker',
  10006219: 'Pasta/Noodles Variety Packs',
  10006220: 'Disinfecting Cabinet',
  10006221: 'Vegetable Based Products / Meals Variety Packs',
  10006222: 'Dough Based Products / Meals Variety Packs',
  10006223: 'Signs, Preprinted',
  10006224: 'Signs, Unprinted',
  10006225: 'Signs, Combination',
  10006226: 'Sign Holders',
  10006227: 'Sign – Replacement Part/Accessory',
  10006228: 'Grain Based Products / Meals Variety Packs',
  10006229: 'Dairy/Egg Based Products / Meals Variety Packs',
  10006230: 'Meat Substitutes Variety Packs',
  10006231: 'Stanchions',
  10006232: 'Hand Dryers',
  10006233: 'Food Treatments',
  10006234: 'Sanitizers',
  10006235: 'Computer/Video Game Gaming Software – Digital',
  10006236: 'Computer Software (Non Games) –  Digital',
  10006237: 'GPS Software – Mobile Communications – Digital',
  10006238: 'Mobile Phone Software – Digital',
  10006239: 'Music – Digital',
  10006240: 'Audio (Non-Music) – Digital',
  10006241: 'Movies – Digital',
  10006242: 'Video (Non-Movies) – Digital',
  10006243: 'Ring Tones – Digital',
  10006244: 'Television Shows – Digital',
  10006245: 'Graphics – Digital',
  10006246: 'Penetration Accessories (Powered)',
  10006247: 'Penetration Accessories (Non Powered)',
  10006248: 'Suction Devices (Powered)',
  10006249: 'Suction Devices (Non Powered)',
  10006250: 'Cereals Products – Not Ready to Eat (Frozen)',
  10006251: 'Vegetable Juice – Ready to Drink (Perishable)',
  10006252: 'Vegetable Juice – Ready to Drink (Shelf Stable)',
  10006253: 'Vegetable Juice – Not Ready to Drink (Frozen)',
  10006254: 'Vegetable Juice – Not Ready to Drink (Shelf Stable)',
  10006255: 'Vegetable Juice Drinks – Ready to Drink (Perishable)',
  10006256: 'Vegetable Juice Drinks – Ready to Drink (Shelf Stable)',
  10006257: 'Vegetable Juice Drinks – Not Ready to Drink (Shelf Stable)',
  10006258: 'Caulking Guns (Non-Powered)',
  10006259: 'Seedlings - Ready to Eat',
  10006260: 'Sprouts',
  10006261: 'Edible Flowers',
  10006262: 'Tidal Sea Vegetables Other',
  10006263: 'Beech Mushrooms',
  10006264: 'Enokitake',
  10006265: 'Eryngii',
  10006266: 'Wild Mushrooms (Other)',
  10006267: 'Iceberg Lettuce',
  10006268: 'Loose Leaf/Multileaf Lettuce Other',
  10006269: 'Baby Leaves',
  10006270: 'Snow Peas',
  10006271: 'Chickpeas',
  10006272: 'Fennel (subspecies azoricum)',
  10006273: 'Baby/Infant – Specialised Foods (Frozen)',
  10006274: 'Air Monitors',
  10006275: 'After-Sun Moisturisers',
  10006276: 'Personal Computers  – Tablets/E-Book Readers',
  10006277: 'Metal Detectors',
  10006278: 'Lamb – Unprepared/Unprocessed',
  10006279: 'Mutton – Unprepared/Unprocessed',
  10006280: 'Wild Boar – Unprepared/Unprocessed',
  10006281: 'Hare – Unprepared/Unprocessed',
  10006282: 'Antelope – Unprepared/Unprocessed',
  10006283: 'Beefalo/Cattalo – Unprepared/Unprocessed',
  10006284: 'Elk/Wapiti – Unprepared/Unprocessed',
  10006285: 'Moose/Elk – Unprepared/Unprocessed',
  10006286: 'Water Buffalo – Unprepared/Unprocessed',
  10006287: 'Reindeer/Caribou – Unprepared/Unprocessed',
  10006288: 'Emu – Unprepared/Unprocessed',
  10006289: 'Goose – Unprepared/Unprocessed',
  10006290: 'Guinea Fowl – Unprepared/Unprocessed',
  10006291: 'Quail – Unprepared/Unprocessed',
  10006292: 'Rhea – Unprepared/Unprocessed',
  10006293: 'Squab/Pigeon – Unprepared/Unprocessed',
  10006294: 'Lamb – Prepared/Processed',
  10006295: 'Mutton – Prepared/Processed',
  10006296: 'Wild Boar – Prepared/Processed',
  10006297: 'Hare – Prepared/Processed',
  10006298: 'Antelope – Prepared/Processed',
  10006299: 'Beefalo/Cattalo – Prepared/Processed',
  10006300: 'Elk/Wapiti – Prepared/Processed',
  10006301: 'Moose/Elk – Prepared/Processed',
  10006302: 'Water Buffalo – Prepared/Processed',
  10006303: 'Reindeer/Caribou – Prepared/Processed',
  10006304: 'Emu – Prepared/Processed',
  10006305: 'Goose – Prepared/Processed',
  10006306: 'Guinea Fowl – Prepared/Processed',
  10006307: 'Quail – Prepared/Processed',
  10006308: 'Rhea – Prepared/Processed',
  10006309: 'Squab/Pigeon – Prepared/Processed',
  10006310: 'Coffee Substitutes – Regular(Non-Instant)',
  10006311: 'Coffee Substitutes – Instant',
  10006312: 'Coffee Substitutes – Ready to Drink',
  10006313: 'Herbal Chew/Snuff – Non Tobacco',
  10006314: 'Soup Additions (Frozen)',
  10006315: 'Soup Additions (Perishable)',
  10006316: 'Soup Additions (Shelf Stable)',
  10006317: 'Mayonnaise/Mayonnaise Substitutes (Frozen)',
  10006318: 'Mayonnaise/Mayonnaise Substitutes (Perishable)',
  10006319: 'Mayonnaise/Mayonnaise Substitutes (Shelf Stable)',
  10006320: 'Mustard (Frozen)',
  10006321: 'Mustard (Perishable)',
  10006322: 'Mustard (Shelf Stable)',
  10006323: 'Tomato Ketchup/Ketchup Substitutes (Frozen)',
  10006324: 'Tomato Ketchup/Ketchup Substitutes (Perishable)',
  10006325: 'Tomato Ketchup/Ketchup Substitutes (Shelf Stable)',
  10006327: 'Apple/Pear Alcoholic Beverage – Still',
  10006328: 'Air/Dust Filter Cleaner',
  10006329: 'Exhaust Filter Cleaner',
  10006330: 'Display Stand',
  10006331: 'Disposable Food Containers',
  10006332: 'Disposable Food Containers Variety Packs',
  10006333: 'Disposable Food Containers Other',
  10006334: 'Anise',
  10006335: 'Arracacha',
  10006336: 'Beans (Winged)',
  10006337: 'Corn (Indian)',
  10006338: 'Crabapples',
  10006339: 'Gai Choy (Mustard Greens)',
  10006340: 'Gourds',
  10006341: 'Black Mustard',
  10006342: 'Greens (Texas Mustard)',
  10006343: 'Orangelos',
  10006344: 'Jicama Bean',
  10006345: 'Kumquat',
  10006346: 'Loganberries',
  10006347: 'Madrona',
  10006348: 'Other Melons',
  10006349: 'Bitter Melon',
  10006350: 'Melon (Horned)',
  10006351: 'Name Mapuey',
  10006352: 'Water Spinach /Ong Choy',
  10006353: 'Sage',
  10006354: 'Saskatoon Berries',
  10006355: 'Squash (Calabaza)',
  10006356: 'Squash (Choko)',
  10006357: 'Squash (Opo)',
  10006358: 'Tamarillo',
  10006359: 'Tamarindo',
  10006360: 'Aloe Vera',
  10006361: 'Ferns (Cinnamon)',
  10006362: 'Ferns (Royal)',
  10006363: 'Gobo Root/Burdock',
  10006364: 'Lotus Root',
  10006365: 'Mamey',
  10006366: 'Okra (Chinese)',
  10006367: 'Salsify',
  10006368: 'Sapodillo',
  10006369: 'Sapote (Black)',
  10006370: 'Sapote (White)',
  10006371: 'Sugar Cane',
  10006372: 'Water Chestnuts',
  10006373: 'Motorcycles',
  10006374: 'Cars/Vans/Sport Utility Vehicles/Light Trucks',
  10006375: 'Car Interior Cleaning Kit',
  10006376: 'Parking Protections',
  10006377: 'Wheel Rim',
  10006378: 'Automotive Paint',
  10006379: 'Fuel Injectors',
  10006380: 'Glow Plugs',
  10006381: 'Glow Plug Variety Packs',
  10006382: 'Starter',
  10006383: 'Battery Booster',
  10006384: 'Brake Pads/Lining',
  10006385: 'Brake Disc',
  10006386: 'Brake Disc Clip',
  10006387: 'Drum Brakes Kit',
  10006388: 'Other Parts for Brake Systems',
  10006389: 'Brake Drum/Brake Drum Parts',
  10006390: 'Chewing Gum',
  10006391: 'Scooter (Non Powered)',
  10006392: 'Cycle Anti-theft Device',
  10006393: 'Roe Deer – Prepared/Processed',
  10006394: 'Roe Deer – Unprepared/Unprocessed',
  10006395: 'Action Figures (Non Powered)',
  10006396: 'Action Figures (Powered)',
  10006397: 'Action Figure Accessories',
  10006398: 'USB Flash Drives/Thumb Drives',
  10006399: 'Fireplace Tools',
  10006400: 'Fireplace Grates',
  10006401: 'Fireplace Screens',
  10006402: 'Fireplace Fuel Storage',
  10006403: 'Automotive GPS Mounts and Cradles',
  10006404: 'Gate/Garage Door Opener Replacement Parts and Accessories',
  10006405: 'Personal Computers – All-in-One',
  10006406: 'Presentation Boards (Powered)',
  10006407: 'Carbon Dioxide Gas',
  10006408: 'Nitrogen Gas',
  10006409: 'Nitrous Oxide  Gas',
  10006410: 'Technical Gases Other',
  10006411: 'Helium Gas',
  10006412: 'Veterinary Medical Devices',
  10006414: 'Medlar',
  10006415: 'Ya Pear (Shandong)',
  10006416: 'Arrowroot',
  10006417: 'White Radish (Daikon)',
  10006418: 'Turnip Rooted Chervil',
  10006419: 'Batavia',
  10006420: 'Hin Choy',
  10006421: 'Radicchio (Redloof)',
  10006422: 'Common Chicory',
  10006423: 'Puntarelle',
  10006424: 'Lollo Bionda',
  10006425: 'Lollo Rosso',
  10006426: 'Oakleaf Lettuce',
  10006427: 'New-Zealand Spinach',
  10006428: 'Leaf Vegetables – Unprepared/Unprocessed Variety Packs',
  10006429: 'Goji Berries',
  10006430: 'Hybrids of Berries',
  10006431: 'Lingonberries',
  10006432: 'Elderberries',
  10006433: 'Annona Other',
  10006434: 'Jambolan',
  10006435: 'Longan (Dragons Eye)',
  10006436: 'Salak (Snake Fruit)',
  10006437: 'Cassia',
  10006438: 'Indian Limes',
  10006439: 'King Mandarins',
  10006440: 'Mediterranean (Willowleaf) Mandarins',
  10006441: 'Mandarin Hybrids',
  10006442: 'Tangor',
  10006443: 'Paraguaya',
  10006444: 'Mizuna',
  10006445: 'Bimi and Other Brassica Interbreeds',
  10006446: 'Choi Sum',
  10006447: 'Tatsoi',
  10006449: 'Gherkins',
  10006450: 'Crooked Cucumber',
  10006451: 'Tomatillos',
  10006452: 'Antroewa',
  10006453: 'Pepino',
  10006454: 'Lentils',
  10006455: 'Winged Pea',
  10006456: 'Herbs Variety Pack',
  10006457: 'Celery Leaves',
  10006458: 'Sea Kale',
  10006459: 'Sea Lavender',
  10006460: 'Glasswort',
  10006461: 'Agretti',
  10006462: 'Agapanthus – Cut Flowers',
  10006463: 'Alchemilla Mollis – Cut Flowers',
  10006464: 'Alstroemeria – Cut Flowers',
  10006465: 'Anemone Coronaria – Cut Flowers',
  10006466: 'Anthurium – Cut Flowers',
  10006467: 'Antirrhinum Majus – Cut Flowers',
  10006468: 'Aster – Cut Flowers',
  10006469: 'Bouvardia – Cut Flowers',
  10006470: 'Celosia Argentea – Cut Flowers',
  10006471: 'Chamelaucium Other – Cut Flowers',
  10006472: 'Chamelaucium Uncinatum – Cut Flowers',
  10006473: 'Chrysanthemum – Cut Flowers',
  10006474: 'Cymbidium – Cut Flowers',
  10006476: 'Dahlia – Cut Flowers',
  10006477: 'Delphinium – Cut Flowers',
  10006478: 'Dianthus Barbatus – Cut Flowers',
  10006479: 'Dianthus Other – Cut Flowers',
  10006480: 'Eryngium – Cut Flowers',
  10006481: 'Eustoma Russellianum – Cut Flowers',
  10006482: 'Freesia – Cut Flowers',
  10006483: 'Gerbera – Cut Flowers',
  10006484: 'Gladiolus – Cut Flowers',
  10006485: 'Gypsophila Paniculata – Cut Flowers',
  10006486: 'Helianthus Annuus – Cut Flowers',
  10006487: 'Hippeastrum – Cut Flowers',
  10006488: 'Hyacinthus Orientalis – Cut Flowers',
  10006489: 'Hydrangea Macrophylla – Cut Flowers',
  10006490: 'Hypericum Androsaemum – Cut Flowers',
  10006491: 'Hypericum Other – Cut Flowers',
  10006492: 'Hypericum X Inodorum – Cut Flowers',
  10006493: 'Ilex Verticillata – Cut Flowers',
  10006494: 'Iris – Cut Flowers',
  10006495: 'Lilium Longiflorum – Cut Flowers',
  10006496: 'Lilium Other – Cut Flowers',
  10006497: 'Limonium Other – Cut Flowers',
  10006498: 'Limonium Sinuatum – Cut Flowers',
  10006499: 'Matthiola Incana – Cut Flowers',
  10006500: 'Narcissus – Cut Flowers',
  10006501: 'Ornithogalum Saundersiae – Cut Flowers',
  10006502: 'Cut Flowers Other',
  10006503: 'Paeonia – Cut Flowers',
  10006504: 'Phalaenopsis – Cut Flowers',
  10006505: 'Phlox – Cut Flowers',
  10006506: 'Pittosporum – Cut Flowers',
  10006507: 'Ranunculus Asiaticus – Cut Flowers',
  10006508: 'Ranunculus Other – Cut Flowers',
  10006509: 'Rosa – Cut Flowers',
  10006510: 'Solidago – Cut Flowers',
  10006511: 'Strelitzia Reginae – Cut Flowers',
  10006512: 'Syringa Vulgaris – Cut Flowers',
  10006513: 'Tanacetum Parthenium – Cut Flowers',
  10006514: 'Trachelium Caeruleum – Cut Flowers',
  10006515: 'Tulipa – Cut Flowers',
  10006516: 'Vanda – Cut Flowers',
  10006517: 'Veronica – Cut Flowers',
  10006518: 'Viburnum Opulus – Cut Flowers',
  10006519: 'Zantedeschia Aethiopica – Cut Flowers',
  10006520: 'Zantedeschia Other – Cut Flowers',
  10006521: 'Agapanthus – Cut Greens',
  10006522: 'Anthurium – Cut Greens',
  10006523: 'Asparagus Setaceus – Cut Greens',
  10006524: 'Asparagus Umbellatus – Cut Greens',
  10006525: 'Aspidistra Elatior – Cut Greens',
  10006526: 'Astilbe Other – Cut Greens',
  10006527: 'Brassica Oleracea – Cut Greens',
  10006528: 'Carthamus Tinctorius – Cut Greens',
  10006529: 'Corylus Avellana – Cut Greens',
  10006530: 'Crocosmia – Cut Greens',
  10006531: 'Cucumis – Cut Greens',
  10006532: 'Cucurbita Maxima – Cut Greens',
  10006533: 'Cucurbita Other – Cut Greens',
  10006534: 'Cucurbita Pepo – Cut Greens',
  10006535: 'Cut Green Variety Packs',
  10006536: 'Dracaena Sanderiana – Cut Greens',
  10006537: 'Eucalyptus Cinerea – Cut Greens',
  10006538: 'Eupatorium Rugosum – Cut Greens',
  10006539: 'Fatsia Japonica – Cut Greens',
  10006540: 'Gomphocarpus Fruticosus – Cut Greens',
  10006541: 'Hydrangea Macrophylla – Cut Greens',
  10006542: 'Ilex Verticillata – Cut Greens',
  10006543: 'Leucadendron – Cut Greens',
  10006544: 'Lilium – Cut Greens',
  10006545: 'Matthiola Incana – Cut Greens',
  10006546: 'Monstera – Cut Greens',
  10006547: 'Cut Greens Other',
  10006548: 'Panicum – Cut Greens',
  10006549: 'Physalis Alkekengi – Cut Greens',
  10006550: 'Pittosporum – Cut Greens',
  10006551: 'Quercus Rubra – Cut Greens',
  10006552: 'Rosa Rose/Hip – Cut Greens',
  10006553: 'Ruscus Hypophyllum – Cut Greens',
  10006554: 'Salix – Cut Greens',
  10006555: 'Setaria Italica – Cut Greens',
  10006556: 'Strelitzia Reginae – Cut Greens',
  10006557: 'Symphoricarpos – Cut Greens',
  10006558: 'Syringa Vulgaris – Cut Greens',
  10006559: 'Thlaspi – Cut Greens',
  10006560: 'Viburnum Opulus – Cut Greens',
  10006561: 'Zantedeschia Aethiopica – Cut Greens',
  10006562: 'Aechmea – Live Plants',
  10006563: 'Aeonium Arboreum – Live Plants',
  10006564: 'Agapanthus – Live Plants',
  10006565: 'Alocasia – Live Plants',
  10006566: 'Aloe – Live Plants',
  10006567: 'Alstroemeria – Live Plants',
  10006568: 'Anemone Hupehensis – Live Plants',
  10006569: 'Angelonia – Live Plants',
  10006570: 'Anisodontea Capensis – Live Plants',
  10006571: 'Anthurium – Live Plants',
  10006572: 'Antirrhinum Majus – Live Plants',
  10006573: 'Argyranthemum Frutescens – Live Plants',
  10006574: 'Armeria Maritima – Live Plants',
  10006575: 'Aster – Live Plants',
  10006576: 'Astilbe – Live Plants',
  10006577: 'Aubrieta Gracilis – Live Plants',
  10006578: 'Begonia – Live Plants',
  10006579: 'Bellis Perennis – Live Plants',
  10006580: 'Bidens – Live Plants',
  10006581: 'Bougainvillea – Live Plants',
  10006582: 'Brachyscome Multifida – Live Plants',
  10006583: 'Brassica – Live Plants',
  10006584: 'Bromelia – Live Plants',
  10006585: 'Brugmansia – Live Plants',
  10006586: 'Calathea – Live Plants',
  10006587: 'Calibrachoa – Live Plants',
  10006588: 'Calocephalus Brownii – Live Plants',
  10006589: 'Campanula Portenschlagiana – Live Plants',
  10006590: 'Canna – Live Plants',
  10006591: 'Celosia – Live Plants',
  10006592: 'Chamaedorea Elegans – Live Plants',
  10006593: 'Chlorophytum Comosum – Live Plants',
  10006594: 'Chrysanthemum – Live Plants',
  10006595: 'Clivia Miniata – Live Plants',
  10006596: 'Cocos Nucifera – Live Plants',
  10006597: 'Codiaeum Variegatum – Live Plants',
  10006598: 'Cordyline Australis – Live Plants',
  10006599: 'Coreopsis Grandiflora – Live Plants',
  10006600: 'Cortaderia Selloana – Live Plants',
  10006601: 'Cosmos Bipinnatus – Live Plants',
  10006602: 'Cuphea Hyssopifolia – Live Plants',
  10006603: 'Cupressus Macrocarpa – Live Plants',
  10006604: 'Curcuma Alismatifolia – Live Plants',
  10006605: 'Cycas Revoluta – Live Plants',
  10006606: 'Cyclamen Persicum – Live Plants',
  10006607: 'Cymbidium – Live Plants',
  10006608: 'Cyperus Alternifolius – Live Plants',
  10006609: 'Dahlia – Live Plants',
  10006610: 'Delphinium – Live Plants',
  10006611: 'Dendrobium Nobile – Live Plants',
  10006612: 'Dianthus – Live Plants',
  10006613: 'Dicentra Spectabilis – Live Plants',
  10006614: 'Dieffenbachia – Live Plants',
  10006615: 'Dorotheanthus Bellidiformis – Live Plants',
  10006616: 'Dracaena Marginata – Live Plants',
  10006617: 'Dypsis Lutescens – Live Plants',
  10006618: 'Echeveria – Live Plants',
  10006619: 'Echinacea Purpurea – Live Plants',
  10006620: 'Epipremnum Pinnatum – Live Plants',
  10006621: 'Euphorbia Pulcherrima – Live Plants',
  10006622: 'Euryops – Live Plants',
  10006623: 'Fargesia Murieliae – Live Plants',
  10006624: 'Felicia Amelloides – Live Plants',
  10006625: 'Festuca Glauca – Live Plants',
  10006626: 'Fittonia – Live Plants',
  10006627: 'Fuchsia – Live Plants',
  10006628: 'Gardenia Jasminoides – Live Plants',
  10006629: 'Gaura Lindheimeri – Live Plants',
  10006630: 'Gazania – Live Plants',
  10006631: 'Gentiana – Live Plants',
  10006632: 'Gerbera – Live Plants',
  10006633: 'Guzmania – Live Plants',
  10006634: 'Gypsophila Muralis – Live Plants',
  10006635: 'Ficus Benjamina – Live Plants',
  10006636: 'Hedera Helix – Live Plants',
  10006637: 'Helianthus Annuus – Live Plants',
  10006638: 'Helichrysum Petiolare – Live Plants',
  10006639: 'Heliotropium – Live Plants',
  10006640: 'Helleborus Niger – Live Plants',
  10006641: 'Heuchera – Live Plants',
  10006642: 'Hibiscus Rosa-Sinensis – Live Plants',
  10006643: 'Hippeastrum – Live Plants',
  10006644: 'Hordeum – Live Plants',
  10006645: 'Hosta – Live Plants',
  10006646: 'Howea Forsteriana – Live Plants',
  10006647: 'Hyacinthus Orientalis – Live Plants',
  10006648: 'Hydrangea Macrophylla – Live Plants',
  10006649: 'Impatiens – Live Plants',
  10006650: 'Jasminum Polyanthum – Live Plants',
  10006651: 'Kalanchoe Blossfeldiana – Live Plants',
  10006652: 'Lantana Camara – Live Plants',
  10006653: 'Leucanthemum – Live Plants',
  10006654: 'Lewisia Cotyledon – Live Plants',
  10006655: 'Lilium – Live Plants',
  10006656: 'Lithodora Diffusa – Live Plants',
  10006657: 'Live Plant Variety Packs',
  10006658: 'Livistona Rotundifolia – Live Plants',
  10006659: 'Lobelia Erinus – Live Plants',
  10006660: 'Lotus Corniculatus – Live Plants',
  10006661: 'Lupinus – Live Plants',
  10006662: 'Mandevilla – Live Plants',
  10006663: 'Medinilla Magnifica – Live Plants',
  10006664: 'Miltonia – Live Plants',
  10006665: 'Muscari – Live Plants',
  10006666: 'Myosotis Sylvatica – Live Plants',
  10006667: 'Narcissus – Live Plants',
  10006668: 'Nephrolepis Exaltata – Live Plants',
  10006669: 'Nolina Recurvata – Live Plants',
  10006670: 'Nymphaea – Live Plants',
  10006671: 'Oncidium – Live Plants',
  10006672: 'Orchis – Live Plants',
  10006673: 'Ornithogalum Thyrsoides – Live Plants',
  10006674: 'Osteospermum – Live Plants',
  10006675: 'Succulents/Cacti – Live Plants Other',
  10006676: 'Ferns – Live Plants Other',
  10006677: 'Grasses – Live Plants Other',
  10006678: 'Herbs – Live Plants Other',
  10006679: 'Live Plants Other',
  10006680: 'Water Plants – Live Plants Other',
  10006681: 'Pachira Aquatica – Live Plants',
  10006682: 'Paeonia – Live Plants',
  10006683: 'Papaver Nudicaule – Live Plants',
  10006684: 'Paphiopedilum – Live Plants',
  10006685: 'Pelargonium – Live Plants',
  10006686: 'Pennisetum – Live Plants',
  10006687: 'Petunia – Live Plants',
  10006688: 'Phalaenopsis – Live Plants',
  10006689: 'Phlox – Live Plants',
  10006690: 'Phoenix Roebelenii – Live Plants',
  10006691: 'Platycodon Grandiflorus – Live Plants',
  10006692: 'Plectranthus – Live Plants',
  10006693: 'Portulaca – Live Plants',
  10006694: 'Primula – Live Plants',
  10006695: 'Ranunculus – Live Plants',
  10006696: 'Rhipsalidopsis – Live Plants',
  10006697: 'Rhododendron – Live Plants',
  10006698: 'Saintpaulia – Live Plants',
  10006699: 'Salvia Nemorosa – Live Plants',
  10006700: 'Sansevieria Cylindrica – Live Plants',
  10006701: 'Sanvitalia Procumbens – Live Plants',
  10006703: 'Saxifraga – Live Plants',
  10006704: 'Schefflera Arboricola – Live Plants',
  10006705: 'Schlumbergera – Live Plants',
  10006706: 'Sedum – Live Plants',
  10006707: 'Sempervivum – Live Plants',
  10006708: 'Senecio Maritima – Live Plants',
  10006709: 'Sinningia – Live Plants',
  10006710: 'Solanum Rantonnetii – Live Plants',
  10006711: 'Spathiphyllum – Live Plants',
  10006712: 'Stephanotis Floribunda – Live Plants',
  10006713: 'Sutera Cordata – Live Plants',
  10006714: 'Tagetes – Live Plants',
  10006715: 'Tillandsia Cyanea – Live Plants',
  10006716: 'Tulipa – Live Plants',
  10006717: 'Vanda – Live Plants',
  10006718: 'Verbena – Live Plants',
  10006719: 'Viola – Live Plants',
  10006720: 'Vriesea – Live Plants',
  10006721: 'Xburrageara – Live Plants',
  10006722: 'Xcitrofortunella Microcarpa – Live Plants',
  10006723: 'Yucca – Live Plants',
  10006724: 'Zamioculcas Zamiifolia – Live Plants',
  10006725: 'Zantedeschia – Live Plants',
  10006726: 'Rosa – Live Plants',
  10006728: 'Dairy By-Products',
  10006729: 'Electronic Cigarettes',
  10006730: 'Electronic Cigarette Accessories',
  10006731: 'Worktops/Countertops',
  10006732: 'Lawn/Garden Insecticides / Pesticides',
  10006733: 'Plant Growth Regulators',
  10006734: 'Seed Protection/ Mordants',
  10006735: 'Kitchen Combination Mixing/Blending/Chopping Appliances',
  10006736: 'Kitchen Slicing Appliances',
  10006737: 'Kitchen Chopping Appliances',
  10006738: 'Kitchen Mixing Appliances',
  10006739: 'Kitchen Blending Appliances',
  10006740: 'Cake / Pie Maker',
  10006742: 'Smokers – Cooking',
  10006743: 'Smart Watches',
  10006744: 'Personal Video Recorder',
  10006745: 'Keyboard, Voice, Mouse (KVM) Switch',
  10006746: 'Doodles/ Puffs',
  10006747: 'Salt Sticks / Mini Pretzels',
  10006748: 'Ready-Made Combination Meals – Not Ready to Eat (Frozen)',
  10006749: 'Ready-Made Combination Meals – Not Ready to Eat (Perishable)',
  10006750: 'Ready-Made Combination Meals – Not Ready to Eat (Shelf Stable)',
  10006751: 'Ready-Made Combination Meals – Ready to Eat (Perishable)',
  10006752: 'Ready-Made Combination Meals – Ready to Eat (Shelf Stable)',
  10006753: 'Ready-Made Combination Meals – Ready to Eat Variety Packs',
  10006754: 'Ready-Made Combination Meals – Not Ready to Eat Variety Packs',
  10006755: 'Lottery and Scratch Cards',
  10006759: 'Acai Berries',
  10006760: 'Naranjilla/Lulo',
  10006761: 'Celtuce',
  10006763: 'Rose Bouquets',
  10006764: 'Carnation Bouquets',
  10006765: 'Mini Carnation Bouquets',
  10006766: 'Lily Bouquets',
  10006767: 'Chrysanthemum Bouquets',
  10006768: 'Alstroemeria Bouquets',
  10006769: 'Tropical Flowers Bouquets',
  10006770: 'Mixed Bouquets',
  10006771: 'Other Bouquets',
  10006772: 'All Terrain Vehicles (ATVs)',
  10006773:
    'Utility Task Vehicles (UTVs)/ Recreational Off-Road Vehicles (ROVs)',
  10006774: 'Seedlings - Ready to Grow',
  10006775: 'Tyre Pressure Meter',
  10006776: 'Moisture Meter (Soil)',
  10006777: 'Thermal Leak Detector',
  10006778: 'Pulley Puller (Hand)',
  10006779: 'Pulley Puller (Powered)',
  10006780: 'Plier Set',
  10006781: 'Forceps (DIY)',
  10006782: 'Fluid Guns',
  10006783: 'Gas Torches',
  10006784: 'Solder Torches',
  10006785: 'Gravel',
  10006786: 'Wooden Tiles - Outdoor Ground',
  10006787: 'Concrete Tiles  - Outdoor Ground',
  10006788: 'Grind Tiles  - Outdoor Ground',
  10006789: 'Natural Stone Tiles  - Outdoor Ground',
  10006790: 'Other Tiles  - Outdoor Ground',
  10006791: 'Coping Stones',
  10006792: 'Windowsill',
  10006793: 'Iron on Edging Strip/Banding',
  10006794: 'Mounting Rails',
  10006795: 'Baby Sanitary Furnishings Variety Pack',
  10006796: 'Baby Sanitary Furnishings - Replacement Parts',
  10006797: 'Baby Sanitary Furnishings - Other',
  10006798: 'Air Dehumidifier - Portable (Non-Powered)',
  10006801: 'Baby/Infant Cutlery (Non Disposable)',
  10006802: 'Baby/Infant Tableware Variety Packs',
  10006806: 'Household Baby Beds/Mattresses Variety Pack',
  10006807: 'Household Baby Beds/Mattresses - Replacement Parts',
  10006808: 'Household Baby Beds/Mattresses - Other',
  10006809: 'Household Baby Seating Variety Pack',
  10006810: 'Household Baby Seating - Replacement Parts',
  10006811: 'Household Baby Seating - Other',
  10006812: 'Baby Exercisers/Transportation Variety Pack',
  10006813: 'Baby Exercisers/Transportation - Replacement Parts',
  10006814: 'Automotive Interior Accessories – Seats Variety Packs',
  10006815: 'Waste Storage Products Variety Packs',
  10006816: 'Waste Storage Products - Replacement Parts',
  10006817: 'Waste Storage Products - Other',
  10006818: 'Baby Safety/Security/Surveillance Variety Packs',
  10006819: 'Baby Safety/Security/Surveillance - Replacement Parts',
  10006820: 'Baby Safety/Security/Surveillance - Other',
  10006821: 'Baby Diapers/Accessories Other',
  10006822: 'Baby Diapers/Accessories Variety Packs',
  10006823: 'Gai Lan',
  10006824: 'Fiddlehead Ferns',
  10006825: 'Black Eyed Peas',
  10006826: 'Non-Netted Cantaloupe Melons',
  10006827: 'Winter Melons or Odourless Muskmelons',
  10006828: 'Netted Muskmelons',
  10006829: 'Conomon Melons',
  10006830: 'Armenian Cucumber',
  10006831: 'Mumes',
  10006832: 'Five-Flavor Berries',
  10006833: 'Ginseng',
  10006834: 'Adzuki Beans',
  10006835: 'Sweet Potato Stems',
  10006836: 'Lingzhi Mushrooms',
  10006837: 'Jams/Marmalades/Fruit Spreads (Perishable)',
  10006838: 'Jumper Cables',
  10006839: 'Tyre Holder',
  10006840: 'Sportswear - Other',
  10006841: 'Flooring - Underlay',
  10006842: 'Firelighting Tools/Matches Accessories',
  10006843: 'Terrarium Aids/Accessories',
  10006845: 'Tools/Equipment - Hand Other',
  10006846: 'Automotive Instruments and Measurement Systems',
  10006847: 'Wildlife Habitat',
  10006848: 'Honey Substitutes',
  10006849: 'Postage Stamps',
  10006850: 'Remote Controlled Vehicles',
  10006851: 'Remotely Controlled Vehicle Replacement Parts and Accessories',
  10006852: 'Coffee Bean Roasters',
  10006853: 'Animal Scarers/Deterrents (Lawn/Garden) – Powered',
  10006854: 'Hippeastrum',
  10006855: 'Muscari',
  10006856: 'Dahlia',
  10006857: 'Gladiolus',
  10006858: 'Hyacinthus Orientalis',
  10006859: 'Iris',
  10006860: 'Crocus',
  10006861: 'Lilium',
  10006862: 'Narcissus',
  10006863: 'Tulipa',
  10006864: 'Allium',
  10006865: 'Zantedeschia',
  10006866: 'Citron',
  10006867: 'Indian flaxplants (Abroma augustum)',
  10006868: 'China juteplants (Abutilon avicennae)',
  10006869: 'Pita plants (Agave americana)',
  10006870: 'Maguey plants (Agave cantala)',
  10006871: 'Mauritian hempplants (Furcraea foetida)',
  10006872: 'Henequen plants (Agave fourcroydes )',
  10006873: 'Ixtle or tampico plants (Agave lecheguilla)',
  10006874: 'Other agave hemp plants (Agave letonae)',
  10006875: 'Sisalplants (Agave sisalane)',
  10006876: 'Kyenkyen / Upastrees (Antiaris Africana)',
  10006877: 'Bambooshrubs (Bambuseae)',
  10006878: 'Ramieplants (Boehmeria nivea)',
  10006879: 'Rattan palmtrees (Calamus rotang)',
  10006880: 'Hempplants (Cannabis sativa)',
  10006881: 'Kapoktrees (Ceiba pentandra)',
  10006882: 'Juteshrubs (Corchorus)',
  10006883: 'Sea island cotton plants (Gossypium barbadense)',
  10006884: 'Cottonplants (Gossypium hirsutum)',
  10006885: 'Kenafplants (Hibiscus cannabinus)',
  10006886: 'Roselle hempplants (Hibiscus sabdariffa var. altissima)',
  10006887: 'Flaxplants (Linum usitatissimum)',
  10006888: 'Aramina fiberplants (Musa textilis)',
  10006889: 'Raffia palmtrees (Raphia farinifera)',
  10006890: 'Congo Jute plants (Urena lobata)',
  10006891: 'Nettleplants (Urtica dioica)',
  10006892: 'Rubbertrees (Hevea brasiliensis)',
  10006893: 'Decorative Banners/Flags - Accessories',
  10006894: 'Small Domestic Appliances - Other',
  10006895: 'Building Products - Other',
  10006896: 'Electrical Lighting - Other',
  10006897: 'Pencil/Pen Cases',
  10006898: 'Stationery/Office Machinery - Other',
  10006899: 'Toys/Games - Other',
  10006900: 'Access Covers/Panels',
  10006901: 'Entrance Grid/Mat Frame',
  10006902: 'Channel (Guttering/Drainage)',
  10006903: 'Clothing/Fashion Tape',
  10006904: 'Automotive Fire Extinguishers',
  10006905: 'Asafoetida plants (Ferula assa-foetida)',
  10006906: 'Gutta-percha trees (Palaquium sp.)',
  10006907: 'Guayule plants (Parthenium argentatum)',
  10006908: 'Russian dandelion plants (Taraxacum kok-saghyz)',
  10006909: 'Agarwood trees (Aquilaria malaccensis)',
  10006910: 'Arabic Gum trees (Acacia senegal)',
  10006911: 'Balsam fir trees (Abies balsamea)',
  10006912: 'Camphor trees (Cinnamomum camphora)',
  10006913: "Dyer's broom shrubs (Genista tinctoria)",
  10006914: 'Galbanum plants (Ferula gummosa)',
  10006915: 'Henna trees (Lawsonia inermis)',
  10006916: 'Indigo plants (Indigofera tinctoria)',
  10006917: 'Kamala trees (Mallotus philippensis)',
  10006918: 'Labdanum trees (Cistus ladanifer)',
  10006919: 'Madder plants (Rubia tinctorum)',
  10006920: 'Mastic shrubs (Pistacia lentiscus)',
  10006921: 'Peru balsam trees (Myroxylon balsamum)',
  10006922: 'Senegal Rosewood trees (Pterocarpus erinaceus)',
  10006923: 'Styrax trees (Styrax benzoin)',
  10006924: 'Olibanum trees (Boswelia)',
  10006925: 'Turpentine trees (Pistacia terebinthus)',
  10006926: 'Wax Palm trees (Ceroxylon quindiuense)',
  10006927: 'Cherimoya trees (Annona cherimola)',
  10006928: 'Ilama trees (Annona diversifolia)',
  10006929: 'Soursop trees (Annona muricata)',
  10006930: 'Bullock heart trees (Annona reticulata)',
  10006931: 'Sweetsop/Sugar apple trees (Annona squamosa)',
  10006932: 'Atemoya trees (Annona x atemoya)',
  10006933: 'Pawpaw trees (Asimina)',
  10006934: 'Snowbanana trees (Ensete glaucum)',
  10006935: 'Abyssinian Banana trees (Ensete ventricosum)',
  10006936: 'Plantain Banana shrubs (Musa x paradisiaca - AAB)',
  10006937: 'Cavendish banana shrubs (Musa acuminata - AAA)',
  10006938: 'Babybanana shrubs (Musa acuminata - AA)',
  10006939: 'Red Dacca banana shrubs (Musa acuminata - AAA var. Rubra)',
  10006940:
    'Latundan (or apple) banana shrubs (Musa acuminata × M. balbisiana (AAB Group) Silk)',
  10006941:
    'Lacatan banana shrubs (Musa acuminata × M. balbisiana - AA Group-  Lakatan)',
  10006942: 'Quincetrees (Cydonia oblonga)',
  10006943: 'Japanese Medlartrees (Eriobotrya japonica)',
  10006944: 'Appletrees (Malus domestica)',
  10006945: 'Crabappletrees (Malus sylvestris)',
  10006946: 'Medlartrees (Mespilus germanica)',
  10006947: 'Ya Peartrees (Pyrus bretschneideri)',
  10006948: 'Peartrees (Pyrus communis)',
  10006949: 'Nashipeartrees (Pyrus pyrifolia)',
  10006950: 'Harbinpeartrees (Pyrus ussuriensis)',
  10006951: 'Elephant Garlicplants (Allium ampeloprasum)',
  10006952: 'Shallotplants (Allium ascalonicum)',
  10006953: 'Onionplants (Allium cepa)',
  10006954: 'Scallionplants (Allium cepa var. cepa)',
  10006955: 'Welsh onionplants (Allium fistulosum)',
  10006956: 'Kurratplants (Allium kurrat)',
  10006957: 'Garlicplants (Allium sativum)',
  10006958: 'Oils Edible - Vegetable or Plant (Perishable)',
  10006959: 'Green Manure Seeds',
  10006960: 'Health Treatments/Aids Sheets',
  10006961: 'Toilet Accessories',
  10006962: 'Bathroom Sink Accessories',
  10006963: 'Swimwear/Swimsuits',
  10006964: 'Beachwear/Cover Ups',
  10006965: 'Swimwear - Other',
  10006966: 'Crosne',
  10006967: 'Mashua (Capucine Tubereuse)',
  10006968: 'Oca',
  10006969: 'Milk Substitutes (Frozen)',
  10006970: 'Milk Substitutes (Perishable)',
  10006971: 'Milk Substitutes (Shelf Stable)',
  10006972: 'Dairy Substitute Based Drinks – Ready to Drink (Perishable)',
  10006973: 'Dairy Substitute Based Drinks - Ready to Drink (Shelf Stable)',
  10006974: 'Dairy Substitute Based Drinks - Not Ready to Drink (Shelf Stable)',
  10006975: 'Cream Substitute (Frozen)',
  10006976: 'Cream Substitute (Perishable)',
  10006977: 'Cream Substitute (Shelf Stable)',
  10006978: 'Yogurt Substitutes (Frozen)',
  10006979: 'Yogurt Substitutes (Perishable)',
  10006980: 'Yogurt Substitutes (Shelf Stable)',
  10006981: 'Margarine (Shelf Stable)',
  10006982: 'Margarine (Perishable)',
  10006983: 'Margarine (Frozen)',
  10006984: 'Dairy Spreads (Perishable)',
  10006985: 'Dairy Spreads (Frozen)',
  10006986: 'Dairy Spreads (Shelf Stable)',
  10006987: 'Mixed Fat Spreads (Shelf Stable)',
  10006988: 'Mixed Fat Spreads (Frozen)',
  10006989: 'Mixed Fat Spreads (Perishable)',
  10006990: 'Fats Edible - Mixed (Perishable)',
  10006991: 'Fats Edible - Mixed (Shelf Stable)',
  10006992: 'Cannabis Oil',
  10006993: 'Cannabis Dried Flower',
  10006994: 'Cannabis Pre-Rolled',
  10006995: 'Cheese Substitutes (Frozen)',
  10006996: 'Cheese Substitutes (Perishable)',
  10006997: 'Cheese Substitutes (Shelf Stable)',
  10006998: 'Carport',
  10006999: 'Patio Roof/Shelter',
  10007000: 'Garage',
  10007001: 'Dowel Pins',
  10007002: 'Biscuits (DIY)',
  10007003: 'Heating Cable/Heat Tape/Heating Cord',
  10007004: 'Fireplace Treatments/Cleaning Products',
  10007005:
    'Household Boilers/Furnaces/Tank Water Heaters Replacement Parts/Accessories',
  10007006: 'Alarm Clocks',
  10007007: 'Anti-Climb/Deterrent Security Product',
  10007008: 'Glass Break Detector',
  10007009: 'Artificial Turf',
  10007010: 'Christmas Tree - Cut',
  10007011: 'Artificial Christmas Tree',
  10007012: 'Gabion',
  10007013: 'Drain Grids (Guttering/Drainage)',
  10007014: 'Garden Storage Boxes',
  10007015: 'Toilet/Bidet Frames',
  10007016: 'Toilet/Bidet Kits',
  10007017: 'Toilet/Bidet Replacement Parts/Accessories',
  10007018: 'Toilet/Bidet Wall Covers',
  10007019: 'Ladder Replacement Parts/Accessories',
  10007020: 'Mobile Phone/Smartphone Accessories',
  10007021: 'Smart Home/Home Automation Equipment - Control Panel',
  10007022: 'Smart Home/Home Automation Equipment - Security Appliances',
  10007023:
    'Smart Home/Home Automation Equipment - Temperature Regulation Appliances',
  10007024:
    'Smart Home/Home Automation Equipment - Lawn/Garden/Leisure Appliances',
  10007025: 'Smart Home/Home Automation Equipment - Lighting Appliances',
  10007026: 'Abrasive Blasters/Sandblasters',
  10007027: 'Hammer Drill and Impact Driver Kit',
  10007028: 'Demolition Hammer',
  10007029: 'Endoscope Camera (DIY)',
  10007030: 'Hole Saw',
  10007031: 'Mixer/Vibrator',
  10007032: 'Oscillating Multitools',
  10007033: 'Rotary Multitools',
  10007034: 'Sanding Rollers (Powered)',
  10007035: 'Wall Slotter (Powered)',
  10007036: 'Umbrellas/Parasols Stands/Bases',
  10007037: 'Pool Shells/Liners',
  10007038: 'Water Softeners Replacement Parts/Accessories',
  10007039: 'Window Shutter Motorisation',
  10007040: 'Amelanchiershrubs (Amelanchier)',
  10007041: 'Madronatrees (Arbutus menziesii)',
  10007042: 'Bearberrytrees (Arctostaphylos uva-ursi)',
  10007043: 'Chokeberryshrubs (Aronia)',
  10007044: 'Hawthornshrubs (Crataegus)',
  10007045: 'Goumitrees (Elaeagnus multiflora)',
  10007046: 'Crowberry shrubs (Empetrum nigrum)',
  10007047: 'Strawberryplants (Fragaria x ananassa)',
  10007048: 'Sea Buckthornshrubs (Hippophae)',
  10007049: 'Acerola/Barbados-cherrytrees (Malpighia emarginata)',
  10007050: 'Golden currantshrubs (Ribes aureum)',
  10007051: 'Dewberryshrubs (Rubus flagellaris)',
  10007052: 'Blackberryplants (Rubus fruticosus)',
  10007053: 'Raspberryplants (Rubus idaeus)',
  10007054: 'Tayberryshrubs (Rubus Tayberry hybrids)',
  10007055: 'Boysenberryplants (Rubus ursinus)',
  10007056: 'Loganberrytrees (Rubus x loganobaccus)',
  10007057: 'Eldershrubs (Sambucus)',
  10007058: 'Five-flavor berryshrubs (Schisandra chinensis)',
  10007059: 'Rowanberrytrees (Sorbus aucuparia)',
  10007060: 'Servicetrees (Sorbus domestica)',
  10007061: 'Blue/Cascade Huckleberryshrubs (Vaccinium deliciosum)',
  10007062: 'American Cranberryshrubs (Vaccinium macrocarpon)',
  10007063: 'Black Huckleberryshrubs (Vaccinium membranaceum)',
  10007064: 'Bilberryshrubs (Vaccinium myrtillus)',
  10007065: 'Small Cranberryshrubs (Vaccinium oxycoccos)',
  10007066: 'Red Huckleberryshrubs (Vaccinium parvifolium)',
  10007067: 'Blueberryshrubs (Vaccinium sect. Cyanococcus)',
  10007068: 'Cowberry/Lingonberryshrubs (Vaccinium vitis-idaea)',
  10007069: 'Nannyberrytrees (Viburnum lentago)',
  10007070: 'Tablegrapeplants (Vitis sp.)',
  10007071: 'Baeltrees (Aegle marmelos)',
  10007072: 'Calamondintrees (Citrofortunella microcarpa)',
  10007073: 'Citrontrees (Citrus medica)',
  10007074: 'Clementinetrees (Citrus clementina)',
  10007075: 'Graprefruittrees (Citrus paradisi)',
  10007076: 'Hardy orangetrees (Poncirus trifolata)',
  10007077: 'Indian limetrees (Citrus limettioides)',
  10007078: 'Kingtrees (Citrus nobilis)',
  10007079: 'Kumquattrees (Citrus japonica)',
  10007080: 'Lemontrees (Citrus limon)',
  10007081: 'Limetrees (Citrus latifolia)',
  10007082: 'Mandarintrees (Citrus x reticulata)',
  10007083: 'Mexican limetrees (Citrus aurantifolia)',
  10007084: 'Minneolatrees (Citrus x tangelo)',
  10007085: 'Papedatrees (Citrus papeda)',
  10007086: 'Pomelotrees (Citrus maxima)',
  10007087: "Satsumatrees (Citrus reticulata 'Satsuma')",
  10007088: 'Sour orangetrees (Citrus aurantium)',
  10007089: 'Sweet limetrees (Citrus limetta)',
  10007090: 'Sweet orangetrees (Citrus sinensis)',
  10007091: 'Tangerinetrees (Citrus tangerina)',
  10007092: 'Wampeetrees (Clausena lansium)',
  10007093: 'Apricottrees (Prunus armeniaca)',
  10007094: 'Damsontrees (Prunus domestica ssp. Insititia)',
  10007095: 'Greengagetrees (Prunus domestica ssp. Italica)',
  10007096: 'Nectarinetrees (Prunus persica var nucipersica)',
  10007097: 'Paraguayotrees (Prunus persica var. Platycarpa)',
  10007098: 'Peachtrees (Prunus persica)',
  10007099: 'Plumtrees (Prunus domestica)',
  10007100: 'Prunus interspecific hybridtrees (Prunus hybrids)',
  10007101: 'Sloetrees (Prunus spinosa)',
  10007102: 'Sour Cherrietrees (Prunus cerasus)',
  10007103: 'Sweet Cherrietrees (Prunus avium)',
  10007104: 'Cactus figplants (Opuntia ficus-indica)',
  10007105:
    'Redfleshed Sweet Pitahaya or Dragonfruitplants (Hylocereus costaricensis)',
  10007106: 'Sour Pitayaplants (Stenocereus)',
  10007107: 'Whitefleshed Pitahaya or Dragonfruitplants (Hylocereus undatus)',
  10007108: 'Yellow Pitahayaplants (Selenicereus megalanthus)',
  10007109: 'Acaipalmtrees (Euterpe oleracea)',
  10007110: 'Coconut palmtrees (Cocos nucifera)',
  10007111: 'Datepalmtrees (Phoenix dactylifera)',
  10007112: 'Palmyra palmtrees (Borassus)',
  10007113: 'Salaktrees (Salacca edulis)',
  10007114: 'Feijoatrees (Feijoa sellowiana)',
  10007115: 'Guavetrees (Psidium guajava)',
  10007116: 'Jabuticabatrees (Myrciaria cauliflora)',
  10007117: 'Jambolantrees (Syzygium cumini)',
  10007118: 'Java-appletrees (Syzygium samarangense)',
  10007119: 'Ma-kiangtrees (Cleistocalyx operculatus var. paniala)',
  10007120: 'Malayrose-appletrees (Syzygium malaccense)',
  10007121: 'Strawberry Guavatrees (Psidium cattleianum)',
  10007122: 'Water appletrees (Syzygium aqueum)',
  10007123: 'Ambarellatrees (Spondias dulcis)',
  10007124: 'Argus pheasanttrees (Dracontomelon dao)',
  10007125: 'Cajatrees (Spondias mombin)',
  10007126: 'Gandaria, Marian plumtrees (Bouea macrophylla)',
  10007127: 'Horse mangotrees (Mangifera foetida)',
  10007128: 'Kuwinitrees (Mangifera odorata)',
  10007129: 'Mangotrees (Mangifera indica)',
  10007130: 'Marulatrees (Sclerocarya birrea)',
  10007131: 'Purple mombriltrees (Spondias purpurea)',
  10007132: 'Ackeetrees (Blighia sapida)',
  10007133: 'Longantrees (Dimocarpus longan)',
  10007134: 'Lycheetrees (Litchi chinensis)',
  10007135: 'Rambutantrees (Nephelium lappaceum)',
  10007136: 'Tavatrees (Pometia pinnata)',
  10007137: 'African star apple/white star appletrees (Chrysophyllum albidum)',
  10007138: 'Lucumatrees (Pouteria lucuma)',
  10007139: 'Mamey Sapotetrees (Pouteria sapota)',
  10007140: 'Sapodillatrees (Manilkara zapota)',
  10007141: 'Star-appletrees (Chrysophyllum cainito)',
  10007142: 'White Sapotetrees (Casimiroa edulis)',
  10007143: 'Yellow Mameytrees (Mammea americana)',
  10007144: 'Yellow Sapotetrees (Pouteria campechiana)',
  10007145: 'Bignay, Chinese laurel, or Salamandertrees (Antidesma bunius)',
  10007146: 'Burmese grapetrees (Baccaurea ramiflora)',
  10007147: 'Indian gooseberrytrees (Phyllanthus emblica)',
  10007148: 'Rambaitrees (Baccaurea motleyana)',
  10007149: 'Star-gooseberrytrees (Phyllanthus acidus)',
  10007150: 'Tampoitrees (Baccaurea macrocarpa)',
  10007151: 'American Persimmontrees (Diospyros virginiana)',
  10007152: 'Avocadotrees (Persea americana)',
  10007153: 'Barbadine/Giant Granadillatrees (Passiflora quadrangularis)',
  10007154: 'Bayberrytrees (Myrica)',
  10007155: 'Bilimbitrees (Averrhoa bilimbi)',
  10007156: 'Black Sapotetrees (Diospyros digyna)',
  10007157: 'Cape Gooseberrytrees (Physalis peruviana)',
  10007158: 'Carambola - starfruittrees (Averrhoa carambola)',
  10007159: 'Chempedaktrees (Artocarpus integer)',
  10007160: 'Chinese Jujubetrees (Ziziphus jujuba)',
  10007161: 'Cupuaçutrees (Theobroma grandiflora)',
  10007162: 'Duriantrees (Durio zibethinus)',
  10007163: 'Figtrees (Ficus carica)',
  10007164: 'Guamachil, Manila tamarindtrees (Pithecellobium dulce)',
  10007165: 'Indian jujubetrees (Ziziphus mauritiana)',
  10007166: 'Indian plumtrees (Flacourtia indica)',
  10007167: 'Jackfruit/Nankatrees (Artocarpus heterophyllus)',
  10007168: 'Jamaica cherrytrees (Muntingia calabura)',
  10007169: 'Jengkoltrees (Archidendron jiringa)',
  10007170: 'Kakitrees (Diospyros kaki)',
  10007171: 'Kiwifruittrees (Actinidia deliciosa)',
  10007172: 'Kokumtrees (Garcinia indica)',
  10007173: 'Langsattrees (Lansium domesticum)',
  10007174: 'Mabolotrees (Diospyros discolor)',
  10007175: 'Mangosteentrees (Garcinia mangostana)',
  10007176: 'Maracujatrees (Passiflora edulis)',
  10007177: 'Mountain papayatrees (Vasconcellea pubescens)',
  10007178: 'Mulberrytrees (Morus)',
  10007179: 'Nonitrees (Morinda citrifolia)',
  10007180: 'Papayatrees (Carica papaya)',
  10007181: 'Pineappleplants (Ananas comosus)',
  10007182: 'Pomegranatetrees (Punica granatum)',
  10007183: 'Santoltrees (Sandoricum koetjape)',
  10007184: 'Sweet Granadillatrees (Passiflora ligularis)',
  10007185: 'Tamarillotrees (Cyphomandra betacea)',
  10007186: 'Tamarind or Indian datetrees (Tamarindus indica)',
  10007187: 'Almondtrees (Prunus dulcis var. dulcis)',
  10007188: 'Betel palms, areca palmstrees (Areca catechu)',
  10007189: 'Bitter almondtrees (Prunus dulcis var. amara)',
  10007190: 'Braziltrees (Bertholletia excelsa)',
  10007191: 'Butter or swarri nuttrees (Caryocar nuciferum)',
  10007192: 'Cashewtrees (Anacardium occidentale)',
  10007193: 'Chestnuttrees (Castanea sativa)',
  10007194: 'Chinquapintrees (Castanopsis)',
  10007195: 'Hazeltrees (Corylus avellana)',
  10007196: 'Indian almondtrees (Terminalia catappa)',
  10007197: 'Java almondtrees (Canarium indicum)',
  10007198: 'Kolatrees (Cola acuminata)',
  10007199: 'Macadamiatrees (Macadamia ternifolia)',
  10007200: 'Monkeypottrees (Lecythis ollaria)',
  10007201: 'Mozindatrees (Treculia africana)',
  10007202: 'Paradise or sapucaia nuttrees (Lecythis zabucajo)',
  10007203: 'Pecannuttrees (Carya illinoinensis)',
  10007204: 'Pinetrees (Pinus pinea)',
  10007205: 'Pistacciotrees (Pistacia vera)',
  10007206: 'Sheatrees (Vitellaria paradoxa)',
  10007207: 'American Groundnutplants (Apios americana)',
  10007208: 'Bambara groundnutplants (Vigna subterranea)',
  10007209: 'Hausa groundnutplants (Macrotyloma geocarpum)',
  10007210: 'Peanutplants (Arachis hypogaea)',
  10007211: 'Aloe Veraplants (Aloe vera)',
  10007212: 'Asam Gelugurtrees (Garcinia atroviridis)',
  10007213: 'Basswoodtrees (Tilia)',
  10007214: 'Cacaotrees (Theobroma cacao)',
  10007215: 'Camomilaplants (Matricaria chamomilla)',
  10007216: 'Cape Aloeplants (Aloe ferox)',
  10007217: 'Coffeeshrubs (Coffea)',
  10007218: 'Elecampaneplants (Inula helenium)',
  10007219: 'Guaranaplants (Paullinia cupana)',
  10007220: 'Hopplants (Humulus lupulus)',
  10007221: 'Imbetrees (Garcinia livingstonei)',
  10007222: 'Jasmineplants (Jasminum officinale)',
  10007223: 'Kavashrubs (Piper methysticum)',
  10007224: 'Knapweedplants (Centaurea)',
  10007225: 'Ledumplants (Ledum groenlandicum)',
  10007226: 'Moringatrees (Moringa oleifera)',
  10007227: 'Rooibosplants (Aspalathus linearis)',
  10007228: 'Roselleplants (Hibiscus sabdariffa)',
  10007229: 'Roseplants (Rosa)',
  10007230: 'Sennaplants (Senna alexandrina)',
  10007231: 'Socotrine Aloeplants (Aloe perryi)',
  10007232: 'Teashrubs (Camellia sinensis)',
  10007233: 'Teatreeplants (Leptospermum)',
  10007234: 'Violetplants (Viola)',
  10007235: 'Wine Palmtrees (Jubaea)',
  10007236: 'Winegrapeplants (Vitis vinifera)',
  10007237: 'Yerba Mateplants (Ilex paraguariensis)',
  10007238: 'Portable Food Boxes/Bags/Containers (Non Powered)',
  10007239: 'Fondue Set (Non Powered)',
  10007240: 'Fondue Set (Non Powered) - Accessories/Spare Parts',
  10007241: 'Hob Pots/Pans/Woks/Cocottes Variety Packs',
  10007242: 'Dinnerware Variety Pack',
  10007243: 'Stemmed Glasses for Wine/Water/Champagne',
  10007244: 'Tumblers',
  10007245: 'Bar/Cocktail Glasses',
  10007246: 'Set of Glasses',
  10007247: 'Drinkware Other',
  10007248: 'Drinkware Variety Pack',
  10007249: 'Beer Glasses',
  10007250: 'Tea/Coffee/Chocolate Accessories',
  10007251: 'Tea/Coffee/Chocolate Variety Pack',
  10007252: 'Wine Accessories',
  10007253: 'Cocktail Accessories (Non Disposable)',
  10007254: 'Other Bar and Wine Accessories',
  10007255: 'Bar and Wine Variety Pack',
  10007256: 'Buffet',
  10007257: 'Serveware Variety Pack',
  10007258: 'Flat Serving Platters',
  10007259: 'Deep Serving Platters',
  10007260: 'Serveware Other',
  10007261: 'Drinkware (Disposable)',
  10007262: 'Flatware (Disposable)',
  10007263: 'Tableware Accessories (Disposable)',
  10007264: 'Table Mat/Napkins (Disposable)',
  10007265: 'Tableware Variety Packs',
  10007266: 'Tableware Accessories Other',
  10007267: 'Tableware Accessory Variety Packs',
  10007268: 'Tea/Coffee Flatware (Non Disposable)',
  10007269: 'Other Flatware (Non Disposable)',
  10007270: 'Flatware Variety Packs (Non Disposable)',
  10007271: 'Travel Folding Knives',
  10007272: 'Table Flatware (Non Disposable)',
  10007273: 'Serving Flatware (Non Disposable)',
  10007274: 'Fish/Shellfish/Snail Flatware (Non Disposable)',
  10007275: 'Starter/Dessert/Cheese Flatware (Non Disposable)',
  10007276: 'Snacks Other',
  10007277: 'Curtain Track Accessories',
  10007278: 'Parking Barrier',
  10007279: 'Abyssinian Oatplants (Avena Abyssinica)',
  10007280: 'Oatsplants (Avena Sativa)',
  10007281: 'Black Oatplants (Avena Strigosa)',
  10007282: 'Canagua Or Coaihuaplants (Chenopodium Pallidicaule)',
  10007283: 'Quinoaplants (Chenopodium Quinoa)',
  10007284: "Job's-Tearsplants (Coix Lacryma-Jobi)",
  10007285: 'White Fonioplants (Digitaria Exilis)',
  10007286: 'Black Fonioplants (Digitaria Iburua)',
  10007287: 'Japanese Milletplants (Echinochloa Frumentacea)',
  10007288: 'Finger Milletplants (Eleusine Coracana)',
  10007289: 'Teff/Ingeraplants (Eragrostis Tef)',
  10007290: 'Buckwheatplants (Fagopyrum Esculentum)',
  10007291: 'African Riceplants (Oryza Glaberrima)',
  10007292: 'Riceplants (Oryza Sativa)',
  10007293: 'Milletplants (Panicum Spp.)',
  10007294: 'Koda Or Ditch Milletplants (Paspalum Scrobiculatum)',
  10007295: 'Pearl Or Cattail Milletplants (Pennisetum Glaucum)',
  10007296: 'Canary Grassplants (Phalaris Canariensis)',
  10007297: 'Sorghumplants (Sorghum Bicolor)',
  10007298: 'Triticaleplants (Triticosecale)',
  10007299: 'Polish Wheatplants (Triticum Polonicum)',
  10007300: 'Speltplants (Triticum Spelta)',
  10007301: 'Kamutplants (Triticum Turgidum subsp. Turanicum)',
  10007302: 'Maizeplants (Zea Mays subsp. Mays)',
  10007303: 'Wild Riceplants (Zizania Aquatica)',
  10007304: 'Sugar Mapletrees (Acer Saccharum)',
  10007305: 'Sugar Palmtrees (Arenga Saccharifera)',
  10007306: 'Sugarbeetplants (Beta Vulgaris subsp.Vulgaris var. Altissima )',
  10007307: 'Sugar Caneplants (Saccharum Officinarum)',
  10007308: 'Sweet Sorghumplants (Sorghum Saccharatum)',
  10007309: 'Babussa Palmtrees (Attalea Speciosa)',
  10007310: 'Canola/Rapeseedplants (Brassica Napus)',
  10007311: 'Safflowerplants (Carthamus Tinctorius)',
  10007312: 'Soy Beanplants (Glycine Max)',
  10007313: 'African Oil Palmstrees (Elaeis Guineensis)',
  10007314: 'American Oil Palmstrees (Elaeis Oleifera)',
  10007315: 'Sunflowerplants (Helianthus Annuus)',
  10007316: 'Flaxplants (Linum Usitatissimum)',
  10007317: 'Olivetrees (Olea Europea)',
  10007318: 'Common Sesameplants (Sesamum Indicum)',
  10007319: 'Barleyplants (Hordeum vulgare)',
  10007320: 'Ryeplants (Secale cereale)',
  10007321: 'Wheatplants (Triticum spp.)',
  10007322: 'Hybrid Fescue (× Schedolium Loliaceum)',
  10007323: 'Nile Grass (Acroceras Macrum)',
  10007324: 'Bentgrass (Agrostis spp.)',
  10007325: 'European Beachgrass (Ammophila Arenaria)',
  10007326: 'American Beachgrass (Ammophila Breviligulata)',
  10007327: 'Beardgrass (Andropogon spp.)',
  10007328: 'Anthephora (Anthephora spp.)',
  10007329: 'Giant Reed (Arundo Donax)',
  10007330: 'Carpetgrass (Axonopus spp.)',
  10007331: 'Bluestemgrass (Bothriochloa spp.)',
  10007332: 'Gramagrass (Bouteloua spp.)',
  10007333: 'Taraplants (Caesalpinia Spinosa)',
  10007334: 'African Marigoldplants (Tagetes Erecta)',
  10007335: 'African Birchtrees (Anogeissus Leiocarpa)',
  10007336: 'Yellow Rocketplants (Barbarea Vulgaris)',
  10007337: 'Fodderbeetplants (Beta Vulgaris Subsp. Vulgaris var. Crassa)',
  10007338: 'Black Mustardplants (Brassica Nigra)',
  10007339: 'False Flaxplants (Camelina Sativa)',
  10007340: 'Charlockplants (Sinapis Arvensis)',
  10007341: 'White Mustardplants (Sinapsis Alba)',
  10007342: 'Acaciatrees (Acacia Spp.)',
  10007343: 'American Jointvetch Plants (Aeschynomene Americana)',
  10007344: 'Albizia Trees (Albizia Spp.)',
  10007345: 'Alyce Clover Plants (Alysicarpus Spp.)',
  10007346: 'Rhizoma Peanut Plants (Arachis Glabrata)',
  10007347: 'Pinto Peanut Plants (Arachis Pintoi)',
  10007348: 'Bauhinia Plants (Bauhinia Spp.)',
  10007349: 'Calliandratrees (Calliandra Calothyrsus)',
  10007350: 'Calopo Plants (Calopogonium Spp.)',
  10007351: 'Carob Plants (Ceratonia Siliqua)',
  10007352: 'Round Leaf Cassia Plants (Chamaecrista Rotundifolia)',
  10007353: 'Yeheb Plants (Cordeauxia Edulis)',
  10007354: 'Cratylia Plants (Cratylia Argentea)',
  10007355: 'Crotalaria Plants (Crotalaria Spp.)',
  10007356: 'Tagasaste Plants (Cytisus Proliferus)',
  10007357: 'Desmanthusplants (Desmanthus Spp.)',
  10007359: 'Desmodiumplants (Desmodium Spp.)',
  10007360: 'Sicklebush Plants (Dichrostachys Cinerea)',
  10007361: 'Guanacastetrees (Enterolobium Cyclocarpum)',
  10007362: 'Coraltrees (Erythrina Spp.)',
  10007363: 'Apple-Ring Acacia Trees (Faidherbia Albida)',
  10007364: 'Flemingia Plants (Flemingia Macrophylla)',
  10007365: 'Honey Locust Trees (Gleditsia Triacanthos)',
  10007366: 'Gliricidia Trees (Gliricidia Sepium)',
  10007367: 'Sulla Plants (Hedysarum Coronarium)',
  10007368: 'Indigoplants (Indigofera Spp.)',
  10007369: 'Grass Peaplants (Lathyrus Sativus)',
  10007370: 'Sericea Plants (Lespedeza Cuneata)',
  10007371: 'Leucaena Trees (Leucaena Leucocephala)',
  10007372: 'Lotononis Trees (Lotononis Bainesii)',
  10007373: 'Birdsfoot Trefoil Plants (Lotus Corniculatus)',
  10007374: 'Lupinplants (Lupinus Spp.)',
  10007375: 'Siratro Plants (Phaseolus Atropurpureus)',
  10007376: 'Phasey Bean Plants (Macroptilium Lathyroides)',
  10007377: 'Black Medic Plants (Medicago Lupulina)',
  10007378: 'Bur Clover Plants (Medicago Polymorpha)',
  10007379: 'Alfalfa Plants (Medicago Sativa)',
  10007380: 'Barrel Medic Plants (Medicago Truncatula)',
  10007381: 'White Melilotplants (Melilotus Albus)',
  10007382: 'Sour Clover Plants (Melilotus Indicus)',
  10007383: 'Perennial Soybeanplants (Glycine Wightii)',
  10007384: 'Sainfoinplants (Onobrychis Viciifolia)',
  10007385: 'Serradellaplants (Ornithopus Sativus)',
  10007386: 'African Locust Beanplants (Parkia Africana)',
  10007387: 'Fodder Peaplants (Pisum Sativum var. Arvense)',
  10007388: 'Manila Tamarindtrees (Pithecellobium Dulce)',
  10007389: 'Prosopisplants (Prosopis Spp.)',
  10007390: 'Kudzuplants (Pueraria Spp.)',
  10007391: 'Sesbanplants (Sesbania Spp.)',
  10007392: 'Styloplants (Stylosanthes Spp.)',
  10007393: 'Ahuhuplants (Tephrosia Purpurea)',
  10007394: 'Unspecified Cloverplantsplants (Trifolium)',
  10007395: 'Berseemplants (Trifolium Alexandrinum)',
  10007396: 'Hybrid Clover/Alsikeplants (Trifolium Hybridum)',
  10007397: 'Crimson Cloverplants (Trifolium Incarnatum)',
  10007398: 'Red Cloverplants (Trifolium Pratense)',
  10007399: 'White Cloverplants (Trifolium Repens)',
  10007400: 'Persian Cloverplants (Trifolium Resupinatum)',
  10007401: 'Subcloverplants (Trifolium Subterraneum)',
  10007402: 'Arrowleaf Cloverplants (Trifolium Vesiculosum)',
  10007403: 'Vetchplants (Vicia Sativa)',
  10007404: 'Hairy Vetchplants (Vicia Villosa)',
  10007405: 'Black Gramplants (Vigna Mungo)',
  10007406: 'African Baobabtrees (Adansonia Digitata)',
  10007407: 'Kapok Bushplants (Aerva Javanica)',
  10007408: 'Amaranth Feedplants (Amaranthus Spp.)',
  10007409: 'Arganplants (Argania Spinosa)',
  10007410: 'Saltbushplants (Atriplex Spp.)',
  10007411: 'Cadabaplants (Cadaba Farinosa)',
  10007412: 'Combretumtrees (Combretum Aculeatum)',
  10007413: 'Tansy Phaceliaplants (Phacelia Tanacetifolia)',
  10007414: 'Oaktrees (Quercus Spp)',
  10007415: 'Arakplants (Salvadora Persica)',
  10007416: 'Corn Spuryplants (Spergula Arvensis)',
  10007417: 'African Marigold (Tagetes Erecta)',
  10007418: 'Mexican Sunflowerplants (Tithonia Diversifolia)',
  10007419: 'Buffalo Thorntrees (Ziziphus Mucronata)',
  10007420: 'Yarrowplants (Achillea Millefolium)',
  10007421: 'Vanillaleafplants (Achlys Triphylla)',
  10007422: 'Paracressplants (Acmella Oleracea)',
  10007423: "Pheasant's Eyeplants (Adonis Vernalis)",
  10007424: 'Buchutrees (Agathosma)',
  10007425: 'Ammishrubs (Ammi)',
  10007426: "Wolf's Baneplants (Arnica Montana)",
  10007427: 'African Wormwoodshrubs (Artemisia Afra)',
  10007428: 'Sweet Wormwoodplants (Artemisia Annua)',
  10007429: 'Tree Wormwoodtrees (Artemisia Arborescens)',
  10007430: 'Santonicashrubs (Artemisia Cina)',
  10007431: 'Sea Wormwoodplants (Artemisia Maritima)',
  10007432: 'Asarabaccaplants (Asarum Europaeum)',
  10007433: 'Milkvetchplants (Astragalus)',
  10007434: 'Udjong Atuptrees (Baeckea Frutescens)',
  10007435: 'Paragrass (Brachiaria Mutica)',
  10007436: 'Boroniashrubs (Boronia)',
  10007437: 'Buffelgrass (Cenchrus Ciliaris)',
  10007438: 'White Bryonyplants (Bryonia Alba)',
  10007439: 'Rhodes Grass (Chloris Gayana)',
  10007440: 'Verawoodtrees (Bulnesia Sarmientoi)',
  10007441: 'Vetivergrass (Chrysopogon spp.)',
  10007442: 'Ipecactrees (Carapichea Ipecacuanha)',
  10007443: "Job's tears (Coix Lacryma-jobi)",
  10007444: 'African Laburnumplants (Cassia Sieberiana)',
  10007445: 'Roman Chamomileplants (Chamaemelum Nobile)',
  10007446: 'Kinatrees (Cinchona)',
  10007447: 'Camphor Trees (Cinnamomum Camphora)',
  10007448: 'Colocynthplants (Citrullus Colocynthis)',
  10007449: 'Bermuda grass (Cynodon Dactylon)',
  10007450: 'Calamintplants (Clinopodium Nepeta)',
  10007451: 'Syrian Bindweedplants (Convolvulus Scammonia)',
  10007452: 'Copaiba/Dieseltrees (Copaifera Langsdorffii)',
  10007453: 'Purging Crotonplants (Croton Tiglium)',
  10007454: 'Fraxinellaplants (Dictamnus Albus)',
  10007455: 'Maleferns (Dryopteris Filix-Mas)',
  10007456: 'Epazoteplants (Dysphania Ambrosioides)',
  10007457: 'Cocaplants (Erythroxylum Coca)',
  10007458: 'Oakmoss (Evernia Prunastri)',
  10007459: 'Ginkgo Bilobaplants (Ginkgo Biloba)',
  10007460: 'Curryplants (Helichrysum Italicum)',
  10007461: "St John's Wortplants (Hypericum Perforatum)",
  10007462: "Crested dog'stail (Cynosurus Cristatus)",
  10007463: 'Flatsedges (Papyrus) (Cyperus spp.)',
  10007464: 'Candytuftplants (Iberis)',
  10007465: 'Jalapplants (Ipomoea Purga)',
  10007466: 'Savinshrubs (Juniperus Sabina)',
  10007467: 'Red Cedartrees (Juniperus Virginiana)',
  10007468: 'Kanukashrubs (Kunzea)',
  10007469: 'Tarwiplants (Lupinus Mutabilis)',
  10007470: 'Gypsywortplants (Lycopus Europaeus)',
  10007471: 'Cabreuvaplants (Myrocarpus Frondosus)',
  10007472: 'Evening Primroseplants (Oenothera Fruticosa)',
  10007473: 'Yohimbetrees (Pausinystalia Johimbe)',
  10007474: 'Syrian Rueshrubs (Peganum Harmala)',
  10007475: 'Psylliumplants (Plantago Ovata)',
  10007476: 'Senegal Rosewoodtrees (Pterocarpus Erinaceus)',
  10007477: 'Serpentine Woodplants (Rauvolfia Serpentina)',
  10007478: 'Castor-Oil Plants (Ricinus Communis)',
  10007479: 'Damask Roseplants (Rosa × Damascena)',
  10007480: 'Henbane Bellplants (Scopolia Carniolica)',
  10007481: 'Jojobaplants (Simmondsia Chinensis)',
  10007482: 'Sarsaparillaplants (Smilax)',
  10007483: 'Goldenrodplants (Solidago)',
  10007484: 'Tansyplants (Tanacetum Vulgare)',
  10007485: 'Wild Garmanderplants (Teucrium Chamaedrys)',
  10007486: 'Arbor Vitaetrees (Thuja Occidentalis)',
  10007487: 'Beard Lichen (Usnea)',
  10007488: 'Valerianplants (Valeriana Officinalis)',
  10007489: 'Verbenaplants (Verbena)',
  10007490: 'Yuccaplants (Yucca)',
  10007491: 'Cananga/Ylang Ylangtrees (Cananga Odorata)',
  10007492: 'Vetivergrass (Chrysopogon Zizanioides)',
  10007493: 'Eucalyptustrees (Eucalyptus Sp.)',
  10007494: 'Lavenderplants (Lavandula Angustifolia)',
  10007495: 'May Changtrees (Litsea Cubeba)',
  10007496: 'Paperbark /Teatrees (Melaleuca Sp.)',
  10007497: 'Nardusplants (Nardostachys Jatamansi)',
  10007498: 'Patchoulishrubs (Pogostemon Cablin)',
  10007499: 'Ravensaretrees (Ravensara Aromatica)',
  10007500: 'Costmaryplants (Tanacetum Balsamita)',
  10007501: 'Monkshoodplants (Aconitum)',
  10007502: 'Calamusplants (Acorus Calamus)',
  10007503: 'Belladonnaplants (Atropa Belladonna)',
  10007504: 'Ergot Funghi (Claviceps Purpurea)',
  10007505: 'Autumn Crocusplants (Colchicum Autumnale)',
  10007506: 'Lily Of The Valleyplants (Convallaria Majalis)',
  10007507: 'Daturaweed (Datura)',
  10007508: 'Foxgloveplants (Digitalis Purpurea)',
  10007509: 'Henbaneplants (Hyoscyamus Niger)',
  10007510: 'Mandrakeplants (Mandragora Officinarum)',
  10007511: 'Mayappleplants (Podophyllum Peltatum)',
  10007512: 'Brackenplants (Pteridium Aquilinum)',
  10007513: 'Bloodrootplants (Sanguinaria Canadensis)',
  10007514: 'Bittersweetshrubs (Solanum Dulcamara)',
  10007515: 'Black Nightshadeplants (Solanum Nigrum)',
  10007516: 'Kombe Arrow Poisonvines (Strophantus Kombe)',
  10007517: 'Strychninetrees (Strychnos Nux-Vomica)',
  10007518: 'Tansyplants (Tanacetum Vulgare)',
  10007519: 'Drimia Maritimaplants (Urginea Maritima)',
  10007520: 'Periwinkleplants (Vinca)',
  10007521: 'Swedish Turnips/Rutabagaplants (Brassica Napobrassica)',
  10007522:
    'Romanescoplants (Brassica Oleracea Convar. Botrytis var. Botrytis)',
  10007523: 'Bimi/Broccoliniplants (Brassica Oleracea Italica X Alboglabra)',
  10007524: 'Kai-Lanplants (Brassica Oleracea var. Alboglabra)',
  10007525: 'Cauliflowerplants (Brassica Oleracea var. Botrytis)',
  10007526: 'White Cabbageplants (Brassica Oleracea var. Capitata)',
  10007527: 'Oxheart Cabbageplants (Brassica Oleracea var. Capitata F. Conica)',
  10007528: 'Red Cabbageplants (Brassica Oleracea var. Capitata F. Rubra)',
  10007529: 'Brussels Sproutplants (Brassica Oleracea var. Gemmifera)',
  10007530: 'Broccoliplants (Brassica Oleracea var. Italica)',
  10007531: 'Savoy Cabbageplants (Brassica Oleracea var. Sabauda)',
  10007532: 'Curly Kaleplants (Brassica Oleracea var. Sabellica)',
  10007533: 'Collard Greenplants (Brassica Oleracea var. Viridis)',
  10007534: 'Common Turnipplants (Brassica Rapa Subsp. Rapa)',
  10007535: 'Cocksfoot (Dactylis Glomerata)',
  10007536: 'Egyptian Crowfoot Grass (Dactyloctenium Aegyptium)',
  10007537: 'Bamboo (Dendrocalamus Strictus)',
  10007538: 'Bluegrass (Dichanthium spp.)',
  10007539: 'Fingergrass (Digitaria spp.)',
  10007540: 'Weeping Meadow Grass (Ehrharta Stipoides)',
  10007541: 'Goose Grass (Eleusine Indica)',
  10007542: 'Couch Grass (Elymus repens)',
  10007543: 'Lovegrass (Eragrostis spp.)',
  10007544: 'Pigeon Peaplants (Cajanus Cajan)',
  10007546: 'Mortar Tubs/Builders Buckets',
  10007547: 'Jack Beanplants (Canavalia Ensiformis)',
  10007548: 'Sword Beanplants (Canavalia Gladiata)',
  10007549: 'Chikpeaplants (Cicer Arietinum)',
  10007550: 'Asian Pigeonwingplants (Clitoria Ternatea)',
  10007551: 'Guar Beanplants (Cyamopsis Tetragonoloba)',
  10007552: 'Lablabplants (Lablab Purpureus)',
  10007553: 'Sweet Peaplants (Lathyrus Odoratus)',
  10007554: 'Earthnut Peaplants (Lathyrus Tuberosus)',
  10007555: 'Lentilplants (Lens Culinaris)',
  10007556: 'Velvet Beanplants (Mucuna Pruriens)',
  10007557: 'African Locust Beantrees (Parkia Biglobosa)',
  10007558: 'Peteh Beantrees (Parkia Speciosa)',
  10007559: 'Tepary Beanplants (Phaseolus Acutifolius)',
  10007560: 'Runner Beanplants (Phaseolus Coccineus)',
  10007561: 'Lima Beanplants (Phaseolus Lunatus)',
  10007562: 'French And Waxbeanplants (Phaseolus Vulgaris)',
  10007563: 'Kidney Beanplants (Phaseolus Vulgaris)',
  10007564: 'Garden Peaplants (Pisum Sativum)',
  10007565: 'Field Peaplants (Pisum Sativum Subsp. Arvense)',
  10007566: 'Swedish Turnips/Rutabagaplants (Brassica Napobrassica)',
  10007567: 'Snow Peaplants (Pisum Sativum var. Saccharatum)',
  10007568: 'Winged Beanplants (Psophocarpus Tetragonolobus)',
  10007569: 'Asparagus Peaplants (Tetragonolobus Purpureus)',
  10007570: 'Field Beanplants (Vicia Faba subsp. Minor)',
  10007571: 'Horse Beanplants (Vicia Faba var. Equina)',
  10007572: 'Broad Beanplants (Vicia Faba var. Major)',
  10007573: 'Adzuki Bean Plansplants (Vigna Angularis)',
  10007574: 'Mung Beanplants (Vigna Radiata)',
  10007575: 'Rice Beanplants (Vigna Umbellata)',
  10007576: 'Blackeyed Peaplants (Vigna Unguiculata)',
  10007577: 'Yardlong Beanplants (Vigna Unguiculata subsp. Sesquipedalis)',
  10007578: 'Accounting Services',
  10007579: 'Advertising Services',
  10007580: 'Architectural and Engineering Service',
  10007581: 'Business Management & Consulting Services',
  10007582: 'Computer and Technology Service',
  10007583: 'Legal Services',
  10007584: 'Building Construction & Related Services',
  10007585: 'Cleaning Services',
  10007586: 'Audio-Visual Services',
  10007587: 'Telecommunications Services',
  10007588: 'Educational Services',
  10007589: 'Entertainment Services',
  10007590: 'Energy Services',
  10007591: 'Environmental Services',
  10007592: 'Financial Services',
  10007593: 'Packaging/Storage Services',
  10007594: 'Postal Services',
  10007595: 'Scientific and Technological  Services',
  10007596: 'Food and Drink Services',
  10007597: 'Temporary Accommodation Services',
  10007598: 'Maintenance/Repair Services',
  10007599: 'Installation Services',
  10007600: 'Hygienic and Beauty Care Services',
  10007601: 'Medical Services',
  10007602: 'Veterinary Services',
  10007603: 'Transportation Services',
  10007605: 'Travel Services',
  10007606: 'Potting Table',
  10007607: 'Baseboard',
  10007608: 'Edge Trims',
  10007609: 'Chimney Cap/Rain Cap',
  10007610: 'Air Conduits',
  10007611: 'Centipedegrass (Eremochloa Ophiuroides)',
  10007612: 'Hard Fescue (Festuca Brevipila)',
  10007613: 'Sheepsfescue (Festuca Ovina)',
  10007614: 'Meadowfescue (Festuca Pratensis)',
  10007615: 'Redfescue (Festuca Rubra)',
  10007616: 'Limpo Grass (Hemarthria Altissima)',
  10007617: 'Spear Grass (Heteropogon Contortus)',
  10007618: 'Jaragua (Hyparrhenia Rufa)',
  10007619: 'Alang-Alang (Imperata Cylindrica)',
  10007620: 'Murainagrass (Ischaemum spp.)',
  10007621: 'Southern Cutgrass (Leersia Hexandra)',
  10007622: 'American Dune Grass (Leymus spp.)',
  10007623: 'Italian Ryegrass (Lollium Multiflorum)',
  10007624: 'Pernnial Rye (Lolium Perenne)',
  10007625: 'Hybrid Ryegrass (Lolium X Hybridum)',
  10007626: 'Natal Grass (Melinis Repens)',
  10007627: 'Napier Grass (Pennisetum Purpureum)',
  10007628: 'Air Conduits Variety Pack',
  10007629: 'Highlighter',
  10007630: 'Indian Ricegrass (Oryzopsis Hymenoides)',
  10007631: 'Klein Grass (Panicum Coloratum)',
  10007632: 'Guinea Grass (Panicum Maximum)',
  10007633: 'Switch Grass (Panicum Virgatum)',
  10007634: 'Buffalo Grass (Paspalum Conjugatum)',
  10007635: 'Bahia Grass (Paspalum Notatum)',
  10007636: 'Scrobic Grass (Paspalum Scrobiculatum)',
  10007637: 'Kikuyu Grass (Pennisetum Clandestinum)',
  10007638: 'Canarygrass (Phalaris spp.)',
  10007639: 'Timothygrass (Phleum Pratense)',
  10007640: 'Fowl Meadowgrass (Poa Palustris)',
  10007641: 'Kentucky Bluegrass (Poa Pratensis)',
  10007642: 'Bluegrass (Poa spp.)',
  10007643: 'Java Grass (Polytrias Armaura)',
  10007644: 'Tall Fescue (Schedonorus Arundinaceus)',
  10007645: 'Hammam Cabin',
  10007646: 'Infrared Cabin',
  10007647: 'Sauna Cabin',
  10007648: 'Sunbed Structure',
  10007649: 'Health and Wellness Fittings - Accessories and Replacement Parts',
  10007650: 'Health and Wellness Multi-Purpose Cabin',
  10007651: 'Asparagusplants (Asparagus Officinalis)',
  10007652: 'Foxtail Millet (Setaria Italica)',
  10007653: 'Iceplant (Mesembryanthemum Crystallinum)',
  10007654: 'Kohlrabiplants (Brassica Oleracea var. Gongylodes)',
  10007655: 'Cardoonplants (Cynara Cardunculus)',
  10007656: 'Korali (Setaria Pumila)',
  10007657: 'Artichokeplants (Cynara Scolymus)',
  10007658: 'Fennelplants (Foeniculum Vulgare)',
  10007659: 'Sago Palmtrees (Metroxylon Spp.)',
  10007660: 'Rhubarbplants (Rheum Rhaponticum)',
  10007661: 'Foxtail Grass (Setaria spp.)',
  10007663: 'Sudan Grass (Sorghum × Drummondii)',
  10007665: 'Giant Taroplants (Alocasia Macrorrhizos)',
  10007666: 'Columbus Grass (Sorghum X Almum)',
  10007667: 'Konjacplants (Amorphophallus Konjac)',
  10007668: 'Celery Plants (Apium Graveolens)',
  10007669: 'St Augustine Grass (Stenotaphrum Secundatum)',
  10007670: 'Gobo Root /Burdockplants (Arctium Lappa)',
  10007671: 'Red Oat Grass (Themeda Triandra)',
  10007672: 'Arracachaplants (Arracacia Xanthorrhiza)',
  10007673:
    'Red Beet / Beetrootplants (Beta Vulgaris Subsp. Vulgaris var. Conditiva)',
  10007674: 'Eddoplants (Colocasia Antiquorum)',
  10007675: 'Taroplants (Colocasia Esculenta)',
  10007676: 'Gamagrass (Tripsacum spp.)',
  10007677: 'Tigernutsedge (Cyperus Esculentus)',
  10007678: 'Carrotplants (Daucus Carota)',
  10007679: 'Sabi Grass (Urochloa Mosambicensis)',
  10007680: 'Yamplants (Dioscorea Esculenta)',
  10007681: 'Ubeplants (Dioscorea Alata)',
  10007682: 'Liverseed Grass (Urochloa Panicoides)',
  10007683: 'Airpotatoeplants (Dioscorea Bulbifera)',
  10007684: 'Name Mapueyplants (Dioscorea Trifida)',
  10007685: 'Water Chestnutplants (Eleocharis Dulcis)',
  10007686: 'Zoysia Grass (Zoysia spp.)',
  10007687: 'Jerusalem Artichokeplants (Helianthus Tuberosus)',
  10007688: 'Sweet Potatoeplants (Ipomoea Batatas)',
  10007689: 'Cassaveplants (Manihot Esculenta)',
  10007690: 'Arrowrootplants (Maranta Arundinacea)',
  10007691: 'Lotusrootplants (Nelumbo Nucifera)',
  10007692: 'Ocaplants (Oxalis Tuberosa)',
  10007693: 'Jicama Beanplants (Pachyrhizus Erosus)',
  10007694: 'Ajipoplants (Pachyrhizus Tuberosus)',
  10007695: 'Parsnipplants (Pastinaca Sativa)',
  10007696: 'Common Radishplants (Raphanus Sativus)',
  10007697: 'Daikonplants (Raphanus Sativus var. Longipinnatus)',
  10007698: 'Winter-Radishplants (Raphanus Sativus var. Niger)',
  10007699: 'Scorzoneraplants (Scorzonera Hispanica)',
  10007700: 'Skirretplants (Sium Sisarum)',
  10007701: 'Yaconplants (Smallanthus Sonchifolius)',
  10007702: 'Potatoeplants (Solanum Tuberosum)',
  10007703: 'African Yam Beanplants (Sphenostylis Stenocarpa)',
  10007704: 'Salsify/Oysterplants (Tragopogon Porrifolius)',
  10007705: 'Mashuaplants (Tropaeolum Tuberosum)',
  10007706: 'Ullucusplants (Ullucus Tuberosus)',
  10007707: 'Tanniaplants (Xanthosoma Sagittifolium)',
  10007708: 'Gingerplants (Zingiber Officinale)',
  10007709: 'Common Mushroom Funghi (Agaricus)',
  10007710: 'Cep Funghi (Boletus Edulis)',
  10007711: 'Chantarelle Funghi (Cantharellus Cibarius)',
  10007712: 'Enokitake Funghi (Flammulina Velutipes)',
  10007713: 'Linghzi / Reishi Funghi (Ganoderma Lucidum)',
  10007714: 'Beech Mushrooms Funghi (Hypsizygus Tessellatus)',
  10007715: 'Shiitake Mushroom Funghi (Lentinula Edodes)',
  10007716: 'Morel Funghi (Morchella Esculenta)',
  10007717: 'Eryngii Funghi (Pleurotus Eryngii)',
  10007718: 'Oyster Mushroom Funghi (Pleurotus Ostreatus)',
  10007719: 'Truffle Funghi (Tuber Aestivum)',
  10007720: 'Wild Mushroom Funghi',
  10007721: 'Furniture Legs',
  10007722: 'Defect/Crack Examination Agents',
  10007723: 'Flush Wall Plate',
  10007724: 'Shower Arms',
  10007725: 'Shower Hose',
  10007726: 'Shower Sets',
  10007727: 'Shower Slide Bars',
  10007728: 'Bell Pepperplants (Capsicum Annuum)',
  10007729: 'Cayenne Peppertrees (Capsicum Annuum)',
  10007730: 'Ajiplants (Capsicum Baccatum)',
  10007731: 'Chilipepperplants (Capsicum Frutescens)',
  10007732: 'Gojiberrieplants (Lycium Barbarum)',
  10007733: 'Tomatilloplants (Physalis Philadelphica)',
  10007734: 'Tomatoplants (Solanum Lycopersicum)',
  10007735: 'Antroewaplants (Solanum Macrocarpon)',
  10007736: 'Aubergineplants - Eggplants (Solanum Melongena)',
  10007737: 'Pepinoplants (Solanum Muricatum)',
  10007738: 'Luloplants (Solanum Quitoense)',
  10007739: 'Wonderberrieplants (Solanum Retroflexum)',
  10007740: 'Ash Gourdplants (Benincasa Hispida)',
  10007741: 'Watermelonplants (Citrullus Lunatus)',
  10007742: 'Ivy Gourd/ Tindolaplants (Coccinia Grandis)',
  10007743: 'Cantaloupe Melonplants (Cucumis Melo var. Cantaloupensis)',
  10007744: 'Conomon Melonplants (Cucumis Melo var. Conomon)',
  10007745: 'Armenian Cucumberplants (Cucumis Melo var. Flexuosus)',
  10007746: 'Wintermelonplants (Cucumis Melo var. Inodorus)',
  10007747: 'Muskmelonplants (Cucumis Melo var. Reticulatus)',
  10007748: 'Horned Melonplants (Cucumis Metuliferus)',
  10007749: 'Cucumberplants (Cucumis Sativus)',
  10007750: 'Giant Pumpkinplants (Cucurbita Maxima)',
  10007752:
    'Marrow, Courgette And Other Cucurbita Pepo Varieties (Cucurbita Pepo)',
  10007753: 'Pattypan Squashplants (Cucurbita Melopepo)',
  10007754: 'Butternut Squashplants (Cucurbita Moschata)',
  10007755: 'Calabash Gourdplants (Lagenaria Siceraria)',
  10007756: 'Luffaplants (Luffa)',
  10007757: 'Bitter Melonplants (Momordica Charantia)',
  10007758: 'Chayote Gourdplants (Sechium Edule)',
  10007759: 'Okraplants (Abelmoschus Esculentus)',
  10007760: 'Leveling Cement/Mortar',
  10007761: 'Musk Okraplants (Abelmoschus Moschatus)',
  10007762: 'Melinjotrees (Gnetum Gnemon)',
  10007763: 'Sweetcornplants (Zea Mays Subsp. Saccharata)',
  10007764: 'Endiveplants (Cichorium Endivia)',
  10007765: 'Radicchio Rossoplants (Cichorium Intybus var. Foliosum)',
  10007766: 'Sugarloafplants (Cichorium Intybus var. Foliosum)',
  10007767: 'Root Chicoryplants (Cichorium Intybus var. Sativum)',
  10007768: 'Aquarium/Vivarium',
  10007769: 'Belgian Endive/ Witloofplants (Cichorium Intybus var. Foliosum)',
  10007770: 'Puntarelleplants (Cichorium Intybus Gr. Catalugna)',
  10007771: 'Head Lettuceplants (Lactuca Sativa var. Capitata)',
  10007772: 'Romaine / Cos Lettuceplants (Lactuca Sativa var. Romana)',
  10007773: 'Leaf Lettuceplants (Lactuca Sativa var. Crispa)',
  10007774: 'Kinatrees (Cinchona)',
  10007775: 'Celtuceplants (Lactuca Sativa var. Angustana)',
  10007776: 'Mamoncillotrees (Meliococcus Bijgatus)',
  10007777: 'Rocketplants (Eruca Sativa)',
  10007778: 'American Gooseberryshrubs (Ribes Hirtellum)',
  10007779: 'Choy Sumplants (Brassica Chinensis var. Parachinensis)',
  10007780: 'Blackcurrant Shrubs (Ribes Nigrum)',
  10007781: 'Leaf Mustard / Sareptaplants (Brassica Juncea)',
  10007782: 'Red Currantshrubs (Ribes Rubrum)',
  10007783: 'Tatsoiplants (Brassica Narinosa)',
  10007784: 'Gooseberryshrubs (Ribes Uva-Crispa)',
  10007785: 'Pak Choyplants (Brassica Chinensis)',
  10007786: 'Jostaberryshrubs (Ribes X Nidigrolaria)',
  10007787: 'Cloudberryshrubs (Rubus Chamaemorus)',
  10007788: 'Wineberryplants (Rubus Phoenicolasius)',
  10007789: 'Collard greenplants (Brassica oleracea var. viridis)',
  10007790: 'Umbu/Brazilia Plumtrees (Spondias Tuberosa)',
  10007791: 'Breadfruittrees (Artocarpus Altilis)',
  10007792: 'Curabastrees (Passiflora Mollissima)',
  10007793: 'Komatsunaplants (Brassica Perviridis)',
  10007794: 'Mibunaplants (Brassica Rapa Japonica)',
  10007795:
    'Mizuna / Japanese Mustardplants (Brassica Rapa Subsp. Nipposinica)',
  10007796: 'Chinese Cabbageplants (Brassica Pekinensis)',
  10007797: 'Cressplants (Lepidium Sativum)',
  10007798: 'Watercressplants (Nasturtium Officinale)',
  10007799: 'Amaranthplants (Amaranthus)',
  10007800: 'Oracheplants (Atriplex)',
  10007801: 'Chardplants (Beta Vulgaris Subsp. Vulgaris var. Cicla)',
  10007802: 'Spinachplants (Spinacia Oleracea)',
  10007803: 'Chayatrees (Cnidoscolus Aconitifolius)',
  10007804: 'Lambs Lettuceplants (Valerianella Locusta)',
  10007805: 'Ong Choy/ Kangkungplants (Ipomoea Aquatica)',
  10007806: 'Purslaneplants (Portulaca Oleracea)',
  10007807: 'Sorrel- Dockplants (Rumex Acetosa)',
  10007808: 'New Zealand Spinachplants (Tetragonia Tetragonioides)',
  10007809: 'Leekplants (Allium Porrum)',
  10007810: 'Castanospermum Australe - Live Plants',
  10007811: 'Coffea - Live Plants',
  10007812: 'Dionaea Muscipula - Live Plants',
  10007813: 'Alexandersplants (Smyrnium Olusatrum)',
  10007814: 'Angelicaplants (Angelica Archangelica)',
  10007815: 'Aniseplants (Pimpinella Anisum)',
  10007816: 'Asiatic Ginsengplants (Panax)',
  10007817: 'Basilplants (Basilicum Spp.)',
  10007818: 'Bayleafplants (Laurus Nobilis)',
  10007819: 'Bee Balmplants (Monarda Didyma)',
  10007820: 'Blessed Milkthistleplants (Silybum Marianum)',
  10007821: 'Boldoplants (Peumus Boldus)',
  10007822: 'Borageplants (Borago Officinalis)',
  10007823: 'Burnetplants (Sanguisorba Spp.)',
  10007824: 'Celeryplants (Apium Graveolens)',
  10007825: 'Chervilplants (Anthriscus Cerefolium)',
  10007826: 'Chiveplants (Allium Schoenoprasum)',
  10007827: 'Cilantro/Corianderplants (Coriandrum Sativum)',
  10007828: 'Country Borage/Mexican Mintplants (Plectranthus Amboinicus)',
  10007829: 'Dandelionplants (Taraxacum)',
  10007830: 'Dillplants (Anethum Graveolens)',
  10007831: 'Fenugreekplants (Trigonella Foenum-Graecum)',
  10007832: 'Fingerrootplants (Boesenbergia Rotunda)',
  10007833: 'Garlic Chiveplants (Allium Tuberosum)',
  10007834: 'Gentianplants (Gentiana Spp.)',
  10007835: 'Guascaplants (Galinsoga Parviflora)',
  10007836: 'Hyssopplants (Hyssopus Officinalis)',
  10007837: 'Indian Tobaccoplants (Lobelia Inflata)',
  10007838: 'Johnny Jumpplants (Viola Tricolor)',
  10007839: 'Lemon Balmplants (Melissa Officinalis)',
  10007840: 'Lemon Verbenaplants (Aloysia Citriodora)',
  10007841: 'Lemongrass/Citronellaplants (Cymbopogon Citratus)',
  10007842: 'Lovageplants (Levisticum Officinale)',
  10007843: 'Marjoramplants (Origanum Majorana)',
  10007844: 'Meadowsweetplants (Filipendula Ulmaria)',
  10007845: 'Mintplants (Mentha Spp.)',
  10007846: 'Mugwortplants (Artemisia Vulgaris)',
  10007847: 'Origanoplants (Origanum Vulgare)',
  10007848: 'Parsleyplants (Petroselinum Crispum)',
  10007849: 'Perilla and Shisoplants (Perilla Frutescens)',
  10007850: 'Pot Marigoldplants (Calendula Officinalis)',
  10007851: 'Purple Coneflowerplants (Echinacea Purpurea)',
  10007852: 'Ramsonplants (Allium Ursinum)',
  10007853: 'Ribwort Plantainplants (Plantago Lanceolata)',
  10007854: 'Rice Paddy Herbplants (Limnophila Aromatica)',
  10007855: 'Rosemaryplants (Rosmarinus Officinalis)',
  10007856: 'Rueplants (Ruta Graveolens)',
  10007857: 'Sageplants (Salvia Officinalis)',
  10007858: 'Sassafrasplants (Sassafras Albidum)',
  10007859: 'Savoryplants (Satureja)',
  10007860: 'Sour Dockplants (Rumex Arcticus)',
  10007861: 'Steviaplants (Stevia Rebaudiana)',
  10007862: 'Sweet Cicelyplants (Myrrhis Odorata)',
  10007863: 'Tarragonplants (Artemisia Dracunculus)',
  10007864: 'Thymeplants (Thymus Vulgaris)',
  10007865: 'Wasibiplants (Eutrema Japonicum)',
  10007866: 'Wormwoodplants/Absinth (Artemisia Absinthium)',
  10007867: 'African Peppertrees (Xylopia Aethiopica)',
  10007868: 'Ajwainplants (Trachyspermum Ammi)',
  10007869: 'Allspice/Pimentplants (Pimenta Dioica)',
  10007870: 'Amargoshrubs (Quassia Amara)',
  10007871: 'Annato/Achiotetrees (Bixa Orellana)',
  10007872: 'Black Cardamomtrees (Amomum Subulatum)',
  10007873: 'Black Cuminplants (Bunium Bulbocastanum)',
  10007874: 'Black Peppervines (Piper Nigrum)',
  10007875: 'Brazilian Peppertrees (Schinus Terebinthifolia)',
  10007876: 'Caper Bushshrubs (Capparis Spinosa)',
  10007877: 'Carawayplants (Carum Carvi)',
  10007878: 'Cassiatrees (Cinnamomum Cassia)',
  10007879: 'Chameleonplants (Houttuynia Cordata)',
  10007880: 'Cinnamontrees (Cinnamomum Verum)',
  10007881: 'Clovetrees (Syzygium Aromaticum)',
  10007882: 'Cubebplants (Piper Cubeba)',
  10007883: 'Cuminplants (Cuminum Cyminum)',
  10007884: 'Curryplants (Murraya Koenigii)',
  10007885: 'Epazoteplants (Chenopodium Ambrosioides)',
  10007886: 'Galengaltrees (Alpinia Galanga)',
  10007887: 'Green Cardamomtrees (Elettaria Cardamomum)',
  10007888: 'Indian Longpepperplants (Piper Longum)',
  10007889: 'Indonesian Bay-Leaftrees (Eugenia Polyantha)',
  10007890: 'Junipertrees (Juniperus Communis)',
  10007891: 'Kawakawaplants (Piper Excelsum)',
  10007892: 'Lemon Myrtleplants (Backhousia Citriodoria)',
  10007893: 'Licoricetrees (Glycyrrhiza Glabra)',
  10007894: 'Long Coriander/Culantroplants (Eryngium Foetidum)',
  10007895: 'Mahlebtrees (Prunus Mahaleb)',
  10007896: 'Malaguetta Pepper/Grains of Paradiseplants (Aframomum Melegueta)',
  10007897: 'Mexican Pepperleafplants (Piper Auritum )',
  10007898: 'Mountain-Horopitotrees (Pseudowintera Colorata)',
  10007899: 'Myrtleplants (Myrtus)',
  10007900: 'Nigella/Black Carawayplants (Nigella Sativa )',
  10007901: 'Njangsatrees (Ricinodendron Heudelotii)',
  10007902: 'Nutmegtrees (Myristica Fragrans)',
  10007903: 'Pandantrees (Pandanus Utilis)',
  10007904: 'Pink/Peruvian Peppertrees (Schinus Molle)',
  10007905: 'Poppyplants (Papaver Somniferum)',
  10007906: 'Pot Majoramplants (Origanum Onites)',
  10007907: 'Saffronplants (Crocus Sativus)',
  10007908: 'Salepplants (Orchis Militaris)',
  10007909: 'Sichuan Pepperplants (Zanthoxylum)',
  10007910: 'Southernwoodshrubs (Artemisia Abrotanum)',
  10007911: 'Star-Anisetrees (Illicium Verum)',
  10007912: 'Sumactrees (Rhus Coriaria)',
  10007913: 'Tasmanian Peppershrubs (Drimys Lanceolata)',
  10007914: 'Tonka Beanplants (Dipteryx Odorata)',
  10007915: 'Turmericplants (Curcuma Longa)',
  10007916: 'Vanillaplants (Vanilla Planifolia)',
  10007917: 'Vietnamese Corianderplants (Persicaria Odorata)',
  10007918: 'Vitextrees (Vitex Agnus-Castus)',
  10007919: 'Waterpepperplants (Persicaria Hydropiper)',
  10007920: 'Zedoaryplants (Curcuma Zedoaria)',
  10007921: 'Ludwigia - Live Plants',
  10007922: 'Musa - Live Plants',
  10007923: 'Peperomia - Live Plants',
  10007924: 'Pilea - Live Plants',
  10007925: 'Philodendron - Live Plants',
  10007926: 'Polyscias - Live Plants',
  10007927: 'Rhapis - Live Plants',
  10100000: 'Pet Care',
  10101500: 'Pet Welfare/Hygiene',
  10101600: 'Pet Nutritional Supplements',
  10101700: 'Pet Accessories',
  10101800: 'Pet Care Variety Packs',
  10110000: 'Pet Food/Drinks',
  10111500: 'Pet Drinks',
  10111600: 'Pet Food',
  10111700: 'Pet Food/Drinks Variety Packs',
  10120000: 'Pet Care/Food Variety Packs',
  10120100: 'Pet Care/Food Variety Packs',
  47000000: 'Cleaning/Hygiene Products',
  47100000: 'Cleaning Products',
  47101500: 'Fresheners/Deodorisers',
  47101600: 'Cleaners',
  47101700: 'Laundry',
  47101900: 'Surface Care',
  47102000: 'Cleaning Variety Packs',
  47120000: 'Insect/Pest/Allergen Control',
  47121500: 'Insect/Pest/Allergen Control',
  47190000: 'Cleaning/Hygiene Products Variety Packs',
  47190100: 'Cleaning/Hygiene Products Variety Packs',
  47200000: 'Cleaning/Hygiene Supplies',
  47200100: 'Product Supplies Dispensers',
  47210000: 'Waste Management Products',
  47210100: 'Waste Storage Products',
  50000000: 'Food/Beverage/Tobacco',
  50100000: 'Fruits/Vegetables/Nuts/Seeds Prepared/Processed',
  50101800: 'Nuts/Seeds – Prepared/Processed',
  50101900: 'Fruit/Nuts/Seeds Combination',
  50102000: 'Fruit – Prepared/Processed',
  50102100: 'Vegetables – Prepared/Processed',
  50102200: 'Fruits/Vegetables/Nuts/Seeds Variety Packs',
  50120000: 'Seafood',
  50121500: 'Fish – Unprepared/Unprocessed',
  50121700: 'Shellfish Unprepared/Unprocessed',
  50121800: 'Aquatic Plants Unprepared/Unprocessed',
  50121900: 'Fish – Prepared/Processed',
  50122000: 'Aquatic Invertebrates – Prepared/Processed',
  50122100: 'Shellfish Prepared/Processed',
  50122200: 'Aquatic Plants Prepared/Processed',
  50122300: 'Aquatic Invertebrates – Unprepared/Unprocessed',
  50122400: 'Seafood Variety Packs',
  50122500: 'Aquatic Invertebrates/Fish/Shellfish/Seafood Combination',
  50130000: 'Milk/Butter/Cream/Yogurts/Cheese/Eggs/Substitutes',
  50131700: 'Milk/Milk Substitutes',
  50131800: 'Cheese/Cheese Substitutes',
  50131900: 'Butter/Butter Substitutes',
  50132000: 'Cream/Cream Substitutes',
  50132100: 'Yogurt/Yogurt Substitutes',
  50132200: 'Milk/Butter/Cream/Yogurts/Cheese/Eggs/Substitutes Variety Packs',
  50132300: 'Eggs/Eggs Extracts (Industrial Process)',
  50132500: 'Eggs/Eggs Substitutes',
  50132600: 'Dairy Derivatives/By Products',
  50150000: 'Oils/Fats Edible',
  50151500: 'Oils Edible',
  50151600: 'Fats Edible',
  50151700: 'Oils/Fats Edible Variety Packs',
  50160000: 'Confectionery/Sugar Sweetening Products',
  50161500: 'Sugars/Sugar Substitute Products',
  50161800: 'Confectionery Products',
  50161900: 'Confectionery/Sugar Sweetening Products Variety Packs',
  50170000: 'Seasonings/Preservatives/Extracts',
  50171500: 'Herbs/Spices/Extracts',
  50171700: 'Vinegars/Cooking Wines',
  50171800: 'Sauces/Spreads/Dips/Condiments',
  50171900: 'Pickles/Relishes/Chutneys/Olives',
  50172000: 'Seasonings/Preservatives/Extracts Variety Packs',
  50180000: 'Bread/Bakery Products',
  50181700: 'Baking/Cooking Mixes/Supplies',
  50181900: 'Bread',
  50182000: 'Sweet Bakery Products',
  50182100: 'Biscuits/Cookies',
  50182200: 'Savoury Bakery Products',
  50182300: 'Bread/Bakery Products Variety Packs',
  50190000: 'Prepared/Preserved Foods',
  50191500: 'Prepared Soups',
  50192100: 'Snacks',
  50192300: 'Desserts/Dessert Sauces/Toppings',
  50192400: 'Sweet Spreads',
  50192500: 'Sandwiches/Filled Rolls/Wraps',
  50192900: 'Pasta/Noodles',
  50193000: 'Baby/Infant – Foods/Beverages',
  50193100: 'Vegetable Based Products / Meals',
  50193200: 'Grain Based Products / Meals',
  50193300: 'Dough Based Products / Meals',
  50193400: 'Prepared/Preserved Foods Variety Packs',
  50193500: 'Dairy/Egg Based Products / Meals',
  50193600: 'Meat Substitutes',
  50193800: 'Ready-Made Combination Meals',
  50200000: 'Beverages',
  50201700: 'Coffee/Tea/Substitutes',
  50202200: 'Alcoholic Beverages',
  50202300: 'Non Alcoholic Beverages – Ready to Drink',
  50202400: 'Non Alcoholic Beverages – Not Ready to Drink',
  50202500: 'Beverages Variety Packs',
  50210000: 'Tobacco/Cannabis/Smoking Accessories',
  50211500: 'Tobacco Products/Cannabis Products/Smoking Accessories',
  50220000: 'Cereal/Grain/Pulse Products',
  50221000: 'Grains/Flour',
  50221200: 'Processed Cereal Products',
  50221300: 'Cereal/Grain/Pulse Products Variety Packs',
  50230000: 'Food/Beverage/Tobacco Variety Packs',
  50230100: 'Food/Beverage/Tobacco Variety Packs',
  50240000: 'Meat/Poultry/Other Animals',
  50240100: 'Meat/Poultry/Other Animals – Prepared/Processed',
  50240200: 'Meat/Poultry/Other Animals – Unprepared/Unprocessed',
  50240300: 'Meat/Poultry/Other Animals Sausages – Prepared/Processed',
  50250000: 'Fruits – Unprepared/Unprocessed (Fresh)',
  50250600: 'Citrus',
  50250700: 'Bananas',
  50250800: 'Pome Fruits',
  50250900: 'Stone Fruit',
  50251000: 'Berries/Small Fruit',
  50251100: 'Pineapples',
  50251200: 'Kiwifruits',
  50251300: 'Annona',
  50251400: 'Avocados',
  50251500: 'Persimmon',
  50251600: 'Passionfruits',
  50251700: 'Papayas',
  50251800: 'Pitayas',
  50251900: 'Miscellaneous Fruit',
  50252000: 'Fruits – Unprepared/Unprocessed (Fresh) Variety Packs',
  50260000: 'Vegetables (Non Leaf) – Unprepared/Unprocessed (Fresh)',
  50260100: 'Root/Tuber Vegetables',
  50260200: 'Bulb Vegetables',
  50260300: 'Tomatoes',
  50260400: 'Peppers',
  50260500: 'Solanacea/Others',
  50260600: 'Cucumbers',
  50260700: 'Cucurbits – Edible Peel',
  50260800: 'Melons',
  50260900: 'Cucurbits – Inedible Peel',
  50261000: 'Other Vegetables',
  50261100: 'Brassica Vegetables',
  50261300: 'Herbs',
  50261400: 'Beans (With Pods)',
  50261500: 'Peas  (With Pods)',
  50261600: 'Stem Vegetables',
  50261700: 'Fungi',
  50261800: 'Vegetables – Unprepared/Unprocessed (Fresh) Variety Packs',
  50261900: 'Micro Vegetables',
  50262000: 'Edible Flowers',
  50262100: 'Tidal Sea Vegetables',
  50262200: 'Chickpeas',
  50262300: 'Succulent',
  50262400: 'Ferns',
  50262500: 'Sapote',
  50262600: 'Sugar Canes',
  50262700: 'Sedges',
  50270000: 'Fruits – Unprepared/Unprocessed (Frozen)',
  50270100: 'Fruits – Unprepared/Unprocessed (Frozen)',
  50290000: 'Vegetables – Unprepared/Unprocessed (Frozen)',
  50290100: 'Vegetables – Unprepared/Unprocessed (Frozen)',
  50310000: 'Fruits – Unprepared/Unprocessed (Shelf Stable)',
  50310100: 'Fruits – Unprepared/Unprocessed (Shelf Stable)',
  50320000: 'Vegetables – Unprepared/Unprocessed (Shelf Stable)',
  50320100: 'Vegetables – Unprepared/Unprocessed (Shelf Stable)',
  50330000: 'Nuts/Seeds – Unprepared/Unprocessed (Perishable)',
  50330100: 'Nuts/Seeds – Unprepared/Unprocessed (Perishable)',
  50340000: 'Nuts/Seeds – Unprepared/Unprocessed (Shelf Stable)',
  50340100: 'Nuts/Seeds – Unprepared/Unprocessed (Shelf Stable)',
  50350000: 'Leaf Vegetables – Unprepared/Unprocessed (Fresh)',
  50350100: 'Chicory Leaves',
  50350200: 'Head Lettuce',
  50350300: 'Loose Leaf/Multileaf Salad Greens',
  50350400: 'Single Leaf Salad Greens',
  50350500: 'Spinach (Fresh)',
  50350600: 'Leaf Vegetables – Unprepared/Unprocessed Variety Packs',
  50350700: 'Stem Lettuce',
  51000000: 'Healthcare',
  51100000: 'Health Treatments/Aids',
  51101500: 'Personal Aids',
  51101600: 'Drug Administration',
  51101700: 'First Aid',
  51101800: 'Foot/Leg Care/Treatments',
  51101900: 'Habit Treatment',
  51102100: 'Sensory Organs Care/Treatments',
  51102200: 'Baby Treatments',
  51102300: 'Health Treatments/Aids Variety Packs',
  51102400: 'Bladder/Genital/Rectal Products',
  51102500: 'Pain Relief Products',
  51102600: 'Flower/Homoeopathic/Homeopathic Remedies',
  51102700: 'Gastrointestinal Remedy Products',
  51102800: 'Sleeping/Stress Relieving Products',
  51102900: 'Respiratory/Allergy Products',
  51103000: 'Skin/Scalp Aid Products',
  51103100: 'Travel Sickness Products',
  51103200: 'Enteral Feeding Equipment',
  51103300: 'Oral/Mouth Treatments',
  51103400: 'Health Treatments/Aids Materials',
  51110000: 'Family Planning',
  51111500: 'Barrier Contraception',
  51111600: 'Hormonal Contraception',
  51111700: 'Intra-uterine Contraception',
  51111800: 'Family Planning Variety Packs',
  51120000: 'Health Enhancement',
  51121500: 'Dietary Aids',
  51121600: 'Vitamins/Minerals/Nutritional Supplements',
  51121800: 'Health Enhancement Variety Packs',
  51121900: 'Energy/Stimulant Products',
  51130000: 'Home Diagnostics',
  51131500: 'Diagnostic Monitors',
  51131600: 'Diagnostic Tests',
  51131700: 'Home Diagnostics Variety Packs',
  51140000: 'Healthcare Variety Packs',
  51140100: 'Healthcare Variety Packs',
  51150000: 'Medical Devices',
  51150100: 'Medical Devices',
  51160000: 'Pharmaceutical Drugs',
  51160100: 'Pharmaceutical Drugs',
  51170000: 'Veterinary Healthcare',
  51170100: 'Veterinary Pharmaceuticals',
  51170200: 'Veterinary Medical Devices',
  53000000: 'Beauty/Personal Care/Hygiene',
  53130000: 'Skin Products',
  53131100: 'Skin Care',
  53131200: 'Skin Tanning Products',
  53131300: 'Body Washing',
  53131400: 'Skin Products Variety Packs',
  53140000: 'Hair Products',
  53141000: 'Hair Removal/Masking Products',
  53141100: 'Hair Care Products',
  53141200: 'Hair Products Variety Packs',
  53160000: 'Cosmetics/Fragrances',
  53161000: 'Cosmetic Products',
  53161200: 'Nail Cosmetic/Care Products',
  53161300: 'Fragrances',
  53161400: 'Cosmetics/Fragrances Variety Packs',
  53161500: 'Aromatherapy',
  53180000: 'Personal Hygiene Products',
  53181100: 'General Personal Hygiene',
  53181200: 'Feminine/Nursing Hygiene',
  53181300: 'Adult Incontinence',
  53181500: 'Oral Hygiene',
  53181600: 'Personal Hygiene Products Variety Packs',
  53181700: 'Baby Diapers/Accessories',
  53200000: 'Body Products',
  53201000: 'Body Massage/Toning',
  53220000: 'Beauty/Personal Care/Hygiene Variety Packs',
  53220100: 'Beauty/Personal Care/Hygiene Variety Packs',
  53230000: 'Personal Intimacy',
  53230100: 'Sexual Toys/Aids',
  58000000: 'Cross Segment',
  58010000: 'Cross Segment',
  58010100: 'Cross Segment',
  60000000: 'Textual/Printed/Reference Materials',
  60010000: 'Textual/Printed/Reference Materials',
  60010100: 'Textual/Printed/Reference Materials Variety Packs',
  60010200: 'Books',
  60010300: 'Periodicals',
  60010400: 'Maps',
  61000000: 'Music',
  61010000: 'Musical Instruments/Accessories',
  61010200: 'Musical Instruments (Non Powered)',
  61010300: 'Musical Instruments (Powered)',
  61010400: 'Musical Instrument Accessories',
  61010500: 'Musical Instruments/Accessories Variety Packs',
  62000000: 'Stationery/Office Machinery/Occasion Supplies',
  62050000: 'Greeting Cards/Gift Wrap/Occasion Supplies',
  62050100: 'Gift Wrap/Accessories',
  62050200: 'Greeting Cards/Gift Wrap/Occasion Supplies Variety Packs',
  62050300: 'Greeting Cards/Invitations',
  62050400: 'Occasion Supplies',
  62060000: 'Stationery/Office Machinery',
  62060100: 'Writing/Design Implements/Aids',
  62060300: 'Office Machinery',
  62060400: 'Organizational Planning Stationery',
  62060500: 'Postal/Packaging Equipment/Aids/Accessories',
  62060600: 'Presentation Equipment',
  62060700: 'Stationery Adhesives/Binders/Fasteners',
  62060800: 'Stationery Cutters/Trimmers',
  62060900: 'Stationery Storage/Filing',
  62061000: 'Stationery/Office Machinery Variety Packs',
  62061100: 'Stationery Paper/Card/Film',
  62061200: 'Stationery/Office Machinery - Other',
  62070000: 'Stationery/Office Machinery/Occasion Supplies Variety Packs',
  62070100: 'Stationery/Office Machinery/Occasion Supplies Variety Packs',
  63000000: 'Footwear',
  63010000: 'Footwear',
  63010100: 'Athletic Footwear',
  63010200: 'Footwear Accessories',
  63010300: 'General Purpose Footwear',
  63010400: 'Indoor Footwear',
  63010500: 'Safety/Protective Footwear',
  64000000: 'Personal Accessories',
  64010000: 'Personal Accessories',
  64010100: 'Jewellery',
  64010200: 'Personal Carriers/Accessories',
  64010300: 'Watches',
  64010400: 'Personal Accessories Variety Packs',
  65000000: 'Computing',
  65010000: 'Computers/Video Games',
  65010100: 'Computer/Video Game Accessories',
  65010200: 'Computer Components',
  65010300: 'Computer Drives',
  65010400: 'Computer/Video Game Software',
  65010500: 'Computers',
  65010600: 'Computer/Video Game Control/Input Devices',
  65010700: 'Computer/Video Game Peripherals',
  65010800: 'Computer Networking Equipment',
  65010900: 'Computers/Video Games Variety Packs',
  65011000: 'Video Game Consoles',
  66000000: 'Communications',
  66010000: 'Communications',
  66010100: 'Communication Accessories',
  66010200: 'Fixed Communication Devices',
  66010300: 'Mobile Communication Devices/Services',
  66010400: 'Communication Variety Packs',
  66010500: 'Signage',
  67000000: 'Clothing',
  67010000: 'Clothing',
  67010100: 'Clothing Accessories',
  67010200: 'Full Body Wear',
  67010300: 'Lower Body Wear/Bottoms',
  67010800: 'Upper Body Wear/Tops',
  67011100: 'Clothing Variety Packs',
  67020000: 'Sleepwear',
  67020100: 'Sleepwear',
  67030000: 'Activewear',
  67030100: 'Activewear',
  67040000: 'Underwear',
  67040100: 'Underwear',
  67050000: 'Protective Wear',
  67050100: 'Protective Wear',
  67060000: 'Swimwear',
  67060100: 'Swimwear',
  68000000: 'Audio Visual/Photography',
  68010000: 'Audio Visual Equipment',
  68010100: 'Televisions',
  68010200: 'Video Recording/Playback',
  68010300: 'Portable Audio/Video',
  68010400: 'Home Audio Equipment',
  68010700: 'Audio Visual Accessories',
  68010800: 'Audio Visual Equipment Variety Packs',
  68010900: 'Video Receiving/Installation',
  68020000: 'Photography/Optics',
  68020100: 'Photography',
  68020200: 'Optics',
  68020300: 'Photography Printing/Dark Room Equipment',
  68020400: 'Photography/Optics Variety Packs',
  68030000: 'In-car Electronics',
  68030100: 'Car Video/Navigation',
  68030200: 'Car Audio',
  68030300: 'In-car Electronics Variety Packs',
  68040000: 'Audio Visual Media',
  68040100: 'Pre-Recorded or Digital Content Media',
  68040200: 'Recordable Media',
  68050000: 'Audio Visual/Photography Variety Packs',
  68050100: 'Audio Visual/Photography Variety Packs',
  70000000: 'Arts/Crafts/Needlework',
  70010000: 'Arts/Crafts/Needlework Supplies',
  70010100: 'Artists Painting/Drawing Supplies',
  70010200: 'Airbrushing Supplies',
  70010300: 'Sculptors/Pottery Craft Supplies',
  70010400: 'Needlework/Toy Making Craft Supplies',
  70010500: 'Jewellery Craft Supplies',
  70010600: 'Basketry Craft Supplies',
  70010700: 'Paper/Card Making Craft Supplies',
  70010800: 'Glasswork/Enamelling/Marquetry Craft Supplies',
  70010900: 'Candle/Soap Craft Supplies',
  70011000: 'Wood Burning/Engraving Craft Supplies',
  70011100: 'Printing Craft Supplies',
  70011200: 'Spinning/Weaving Craft Supplies',
  70011300: 'Arts/Crafts Variety Packs',
  71000000: 'Sports Equipment',
  71010000: 'Sports Equipment',
  71010100: 'Track/Field Sports Equipment',
  71010200: 'Sports Balls/Pucks/Shuttlecocks/Frisbees/Boomerangs',
  71010300: 'Racquet Sports Equipment',
  71010400: 'Sports Bats/Sticks/Clubs/Cues/Mallets',
  71010500: 'Snow/Ice Sports Equipment',
  71010600: 'Trekking/Mountaineering Sports Equipment',
  71010700: 'Combat Sports Equipment',
  71010800: 'Cycle Sports Equipment',
  71010900: 'Personal Fitness Sports Equipment',
  71011000: 'Gymnastics Sports Equipment',
  71011100: 'Kiting/Parachuting Sports Equipment',
  71011200: 'Scooter/Skateboard Sports Equipment',
  71011300: 'Swimming/Surfing/Diving Sports Equipment',
  71011400: 'Sports Tables',
  71011500: 'Target Sports Equipment',
  71011600: 'Sporting Firearms Equipment',
  71011700: 'Hunting Sports Aids',
  71011800: 'Watercraft Sports Equipment',
  71011900: 'Sports Equipment Accessories',
  71012000: 'Sports Personal Protective Equipment',
  71012100: 'Fishing/Angling Sports Equipment',
  71012300: 'Sports Equipment Variety Packs',
  71020000: 'Baby Exercisers/Transportation',
  71020100: 'Baby Exercisers/Transportation',
  72000000: 'Home Appliances',
  72010000: 'Major Domestic Appliances',
  72010100: 'Waste Disposing/Compacting Appliances',
  72010200: 'Refrigerating/Freezing Appliances',
  72010300: 'Major Cooking Appliances',
  72010400: 'Warming Appliances',
  72010500: 'Major Laundry Appliances',
  72010600: 'Kitchen Washing Appliances',
  72010700: 'Major Water Dispensers',
  72020000: 'Small Domestic Appliances',
  72020100: 'Small Cooking/Heating Appliances',
  72020200: 'Food/Beverage Preparation Appliances',
  72020300: 'Laundry Care Appliances',
  72020400: 'Cleaning Appliances',
  72020500: 'Small Water Dispensers',
  72020600: 'Portable Air Control Appliances',
  72020700: 'Small Domestic Appliances - Other',
  72020800: 'Smart Home/Home Automation Equipment',
  73000000: 'Kitchenware and Tableware',
  73040000: 'Kitchenware',
  73040100: 'Kitchen Storage',
  73040200: 'Water/Beverage Equipment',
  73040300: 'Food Measuring Equipment',
  73040400: 'Cookware/Bakeware',
  73040600: 'Food Preparation Equipment',
  73040800: 'Kitchen Merchandise Variety Packs',
  73040900: 'Food/Beverage Presentation Accessories',
  73041000: 'Disposable Food Containers',
  73050000: 'Tableware',
  73050100: 'Baby Tableware',
  73050200: 'Dinnerware (Non Disposable)',
  73050300: 'Drinkware (Non Disposable)',
  73050500: 'Barware (Non Disposable)',
  73050600: 'Serveware (Non Disposable)',
  73050700: 'Tableware (Disposable)',
  73050800: 'Tableware Variety Packs',
  73050900: 'Tableware Accessories',
  73051000: 'Flatware (Non Disposable)',
  74000000: 'Camping',
  74010000: 'Camping',
  74010100: 'Tents/Weather Structures',
  74010200: 'Camping Heating/Lighting Equipment',
  74010300: 'Camping Furniture/Furnishings',
  74010400: 'Camping Cooking/Drinking/Eating Equipment',
  74010500: 'Camping Washing/Sanitary Equipment',
  74010600: 'Camping Variety Packs',
  75000000: 'Household/Office Furniture/Furnishings',
  75010000: 'Household/Office Furniture',
  75010100: 'Household/Office Storage/Display Furniture/Screens',
  75010200: 'Household/Office Seating',
  75010300: 'Household/Office Tables/Desks',
  75010400: 'Household Beds/Mattresses',
  75010500: 'Household/Office Furniture Variety Packs',
  75010600: 'Household/Office Furniture Accessories',
  75010700: 'Display Stands',
  75020000: 'Fabric/Textile Furnishings',
  75020100: 'Household/Office Fabric/Textile Furnishings',
  75020200: 'Bedding',
  75020300: 'Fabric/Textile Furnishings Variety Packs',
  75030000: 'Ornamental Furnishings',
  75030100: 'Ornaments',
  75030200: 'Pictures/Mirrors/Frames',
  75030400: 'Clocks',
  75030600: 'Ornamental Furnishings Variety Packs',
  75030700: 'Decorative Banners/Flags',
  75030800: 'Decorative Banners/Flags - Accessories',
  75050000: 'Baby Furnishings',
  75050100: 'Baby Sanitary Furnishings',
  75050200: 'Household Baby Beds/Mattresses',
  75050300: 'Household Baby Seating',
  77000000: 'Automotive',
  77010000: 'Automotive Accessories and Maintenance',
  77010200: 'Automotive Body Repair',
  77010300: 'Automotive Cargo Management',
  77010400: 'Automotive Appearance Chemicals',
  77010500: 'Automotive Performance Chemicals',
  77010900: 'Automotive Transmission Fluid',
  77011200: 'Automotive Maintenance/Repair',
  77011300: 'Automotive Safety',
  77011400: 'Automotive Interior Accessories – Seats',
  77011500: 'Automotive Interior Accessories – Organisation',
  77011600: 'Automotive Interior Accessories – Convenience',
  77011700: 'Automotive Interior Accessories – Sun Protection',
  77011800: 'Automotive Interior Accessories – Steering',
  77011900: 'Automotive Interior Accessories – Interior Flooring',
  77012000: 'Automotive Interior Accessories – Interior Dash',
  77012100: 'Automotive Interior Accessories – Decorative',
  77012200: 'Automotive Exterior Accessories – Running Boards/Steps',
  77012300: 'Automotive Exterior Accessories – Grills/Bumpers',
  77012400: 'Automotive Exterior Accessories – Shields/Deflectors',
  77012500: 'Automotive Exterior Accessories – Coverings/Protection',
  77012600: 'Automotive Exterior Appearance Accessories',
  77012700: 'Automotive Tyres/Wheels',
  77012800: 'Automotive Tyres/Wheels Accessories',
  77012900: 'Automotive Appearance/Fragrance Accessories',
  77013100: 'Automotive Towing/Hitch',
  77013200: 'Automotive Towing/Hitch – Electrical',
  77013300: 'Automotive Trailers/Trailer Accessories',
  77013400: 'Automotive Winches/Winch Accessories',
  77013500: 'Automotive Anti-theft Products',
  77013600: 'Automotive Wipers/Wiper Parts',
  77013700: 'Automotive Spark Plugs/Glow Plugs/ Injectors',
  77013800: 'Automotive Filters',
  77013900: 'Automotive Lights/Bulbs',
  77014000: 'Automotive Light Assemblies',
  77014100: 'Automotive Decorative Lighting',
  77014300: 'Automotive Electrical',
  77014500: 'Automotive Fluid Management Accessories',
  77014700: 'Automotive Fluid Change Items',
  77014900: 'Automotive Window Washer Fluid',
  77015000: 'Automotive Batteries',
  77015100: 'Automotive Antifreeze',
  77015300: 'Automotive Brakes',
  77030000: 'Cars and Motorcycles',
  77030100: 'Cars',
  77030200: 'Motorcycles/ All Terrain Vehicles/ Utility Task Vehicles',
  78000000: 'Electrical Supplies',
  78020000: 'Electrical Connection/Distribution',
  78020500: 'Electrical Connection',
  78020600: 'Electrical Distribution',
  78021100: 'Batteries/Chargers',
  78030000: 'Electrical Lighting',
  78030100: 'Electric Lighting Control Components',
  78030200: 'Electric Lighting Accessories',
  78030300: 'Electric Lamps/Light Bulbs/Lighting',
  78030400: 'Portable Electric Lighting',
  78030500: 'Electrical Lighting - Other',
  78040000: 'Electrical Cabling/Wiring',
  78040100: 'Cabling/Wiring Management/Control',
  78040300: 'Electrical Cables',
  78040400: 'Electrical Wiring',
  78050000: 'Electronic Communication Components',
  78050100: 'Electronic Communication Components',
  78060000: 'General Electrical Hardware',
  78060100: 'General Electrical Hardware',
  79000000: 'Plumbing/Heating/Ventilation/Air Conditioning',
  79010000: 'Plumbing/Heating/Ventilation/Air Conditioning',
  79010100: 'Sanitary Ware',
  79010300: 'Bathroom Fittings',
  79010400: 'Water Storage/Treatment',
  79010500: 'Heating Equipment',
  79010600: 'Air Conditioning/Cooling/Ventilation Equipment',
  79010700: 'Plumbing/Heating Ventilation/Air Conditioning Variety Packs',
  79010800: 'Water/Gas Supply',
  79010900: 'Waste/Sewage Equipment',
  79011000: 'Backflow Prevention Devices',
  79011300: 'Plumbing/ Heating/ Ventilation/ Air Conditioning',
  79011400: 'Health and Wellness',
  80000000: 'Tools/Equipment – Hand',
  80010000: 'Tools/Equipment – Hand',
  80010100: 'Measuring/Levelling/Marking Tools',
  80010200: 'Drywall Tools',
  80010300: 'Masonry/Glass/Tile Tools',
  80010400: 'Carrying/Lifting/Climbing Equipment',
  80010500: 'Demolition/Removal',
  80010600: 'Nailers/Staplers/Riveting Tools',
  80010700: 'Screwdrivers',
  80010800: 'Pliers/Pincers/Metal Cutting Tools',
  80010900: 'Vises/Clamps',
  80011000: 'Grinders/Sharpeners/Scrapers',
  80011100: 'Drills – Non Powered',
  80011300: 'Awls/Punches/Nailsets',
  80011400: 'Knives – Non Powered',
  80011500: 'Chisels/Gouges',
  80011600: 'Hammers/Mallets/Hatchets/Anvils',
  80011700: 'Wrenches/Spanners/Keys',
  80011800: 'Saws – Non Powered',
  80011900: 'Planes/Shapers/Files/Rasps',
  80012000: 'Pipe/Tube Tools',
  80012200: 'Threading Taps/Dies – Non Powered',
  80012300: 'Tools/Equipment – Hand Variety Packs',
  80012400: 'Funnels',
  80012600: 'Pneumatic Tools',
  80012700: 'Gas Burners/Torches',
  80012800: 'Tools/Equipment - Hand Other',
  81000000: 'Lawn/Garden Supplies',
  81010000: 'Lawn/Garden Supplies',
  81010100: 'Lawn/Garden Pools/Ponds/Water Features and Ornaments',
  81010200: 'Lawn/Garden Chemicals/Treatments',
  81010300: 'Lawn/Garden Furniture/Furnishings',
  81010400: 'Lawn/Garden Watering Equipment',
  81010500: 'Lawn/Garden Fencing',
  81010700: 'Lawn/Garden Waste Disposal',
  81010800: 'Lawn/Garden Cooking/Heating Appliances',
  81011000: 'Lawn/Garden Outdoor Structures',
  81011100: 'Lawn/Garden Weather Monitoring/Observation',
  81011200: 'Lawn/Garden Equipment and Tools',
  81011400: 'Lawn/Garden Testing Diagnostic Equipment',
  81011500: 'Lawn/Garden Soil/Soil Amendments',
  81011600: 'Lawn/Garden Lighting',
  81011700: 'Lawn/Garden Animal Repellents/Deterrents',
  81011800: 'Lawn/Garden Floral/Plant Accessories',
  81011900: 'Lawn/Garden Tiles',
  82000000: 'Tools/Equipment – Power',
  82010000: 'Tools/Equipment – Power',
  82010100: 'Power Tools – Lifting/Handling Equipment',
  82010200: 'Power Tools Variety Packs',
  82010300: 'Power Tools – Stationary/Bench-top',
  82010400: 'Power Tools – Hand-held Portable',
  83000000: 'Building Products',
  83010000: 'Building Products',
  83010100: 'Wall/Ceiling Coverings',
  83010200: 'Flooring',
  83010300: 'Insulation',
  83010400: 'Painting',
  83010500: 'Building Products Variety Packs',
  83010600: 'Asphalt/Concrete/Masonry',
  83010700: 'Structural Components/Assemblies',
  83010800: 'Lumber/Wood Panel/Gypsum',
  83010900: 'Window Parts/Accessories',
  83011000: 'Mouldings/Millwork/Stair Parts',
  83011100: 'Doors',
  83011200: 'Door Hardware',
  83011300: 'Glass',
  83011400: 'Guttering/Drainage',
  83011500: 'Decking/Railing',
  83011700: 'Roofing',
  83011800: 'Abrasives',
  83011900: 'Fixings/Fasteners Hardware',
  83012000: 'Curtain Parts/Accessories',
  83012100: 'Sealants/Fillers/Adhesives/Defect Agents',
  83012200: 'Windows',
  83012300: 'Siding/Exterior Trim',
  83012400: 'Building Products - Other',
  83012500: 'Access Covers/Panels',
  83012600: 'Outdoor Roof/Shelter Structures',
  84000000: 'Tool Storage/Workshop Aids',
  84010000: 'Tool Storage/Workshop Aids',
  84010100: 'Tool Storage',
  84010200: 'Workshop Aids',
  85000000: 'Safety/Protection – DIY',
  85010000: 'Safety/Protection – DIY',
  85010100: 'Protective Personal Aids – DIY',
  85010200: 'Protective Collective Aids – DIY',
  86000000: 'Toys/Games',
  86010000: 'Toys/Games',
  86010100: 'Board Games/Cards/Puzzles',
  86010200: 'Dolls/Puppets/Action Figures/Soft Toys',
  86010300: 'Dolls/Puppets/Action Figures/Soft Toys Accessories',
  86010400: 'Developmental/Educational Toys',
  86010500: 'Fancy Dress Costumes/Accessories',
  86010600: 'Musical Toys',
  86010700: 'Indoor/Outdoor Games/Play Structures',
  86010800: 'Table Games',
  86010900: 'Toys/Games Variety Packs',
  86011000: 'Toys – Ride-on',
  86011100: 'Toy Vehicles – Non-ride',
  86011200: 'Role Play Toys',
  86011300: 'Toys/Games - Other',
  86020000: 'Service Provided Gambling Products',
  86020100: 'Service Provided Gambling Products',
  87000000: 'Fuels/Gases',
  87010000: 'Fuels/Fuel Additives',
  87010100: 'Fuels/Ignition Aids',
  87010200: 'Fuel Additives',
  87010500: 'Fuels/Fuel Additives Variety Packs',
  87020000: 'Fuel Storage/Transfer',
  87020100: 'Fuel Pumps',
  87020200: 'Fuel Storage',
  87030000: 'Gases Not Used As Fuels',
  87030100: 'Technical Gases',
  88000000: 'Lubricants',
  88010000: 'Lubricants/Protective Compounds',
  88010100: 'Lubricating Products',
  88010200: 'Protective Compounds',
  88010500: 'Lubricants/Protective Compounds Variety Packs',
  88020000: 'Lubricants/Protective Compounds Storage/Transfer',
  88020100: 'Lubricating Oil/Fluid Pumps',
  88020200: 'Lubricants/Protective Compounds Storage',
  88030000: 'Lubricants Variety Packs',
  88030100: 'Lubricants Variety Packs',
  89000000: 'Live Animals',
  89020000: 'Live Animals',
  89020100: 'Invertebrates',
  89020200: 'Vertebrates',
  91000000: 'Safety/Security/Surveillance',
  91010000: 'Personal Safety/Security',
  91010100: 'Personal Safety Devices',
  91020000: 'Environmental Safety/Security',
  91020100: 'Environmental Fire/Chemical Safety Products',
  91020200: 'Weather/Natural Disaster Safety Products',
  91030000: 'Home/Business Safety/Security/Surveillance',
  91030100: 'Alarm Systems',
  91030200: 'Door/Window/Perimeter Security Products',
  91030300: 'Home/Business Fire Extinguishers',
  91030400: 'Home/Business Surveillance Equipment',
  91030500: 'Safes',
  91030600: 'Home/Business Safety/Security/Surveillance Variety Packs',
  91030700: 'Crowd Control',
  91030800: 'Barriers',
  91040000: 'Safety/Security/Surveillance Variety Packs',
  91040100: 'Safety/Security/Surveillance Variety Packs',
  91050000: 'Baby Safety/Security/Surveillance',
  91050100: 'Baby Safety/Security/Surveillance',
  92000000: 'Storage/Haulage Containers',
  92010000: 'Storage Bottles/Cylinders/Barrels (Empty)',
  92010100: 'Storage Bottles/Cylinders (Empty)',
  92010300: 'Storage Barrels/Drums (Empty)',
  92020000: 'Storage/Haulage Boxes/Crates/Trays (Empty)',
  92020100: 'Storage/Haulage Boxes/Crates/Trays (Empty)',
  92030000: 'Storage/Haulage Freight Containers (Empty)',
  92030100: 'Bulk Freight Containers (Empty)',
  92040000: 'Storage/Haulage Aids',
  92040100: 'Platform Handling Supports/Converters',
  93000000: 'Horticulture Plants',
  93010000: 'Cut Flowers',
  93010100: 'Agapanthus – Cut Flowers',
  93010200: 'Alchemilla – Cut Flowers',
  93010300: 'Alstroemeria  – Cut Flowers',
  93010400: 'Anemone  – Cut Flowers',
  93010500: 'Anthurium  – Cut Flowers',
  93010600: 'Antirrhinum  – Cut Flowers',
  93010700: 'Aster – Cut Flowers',
  93010800: 'Bouvardia – Cut Flowers',
  93010900: 'Celosia  – Cut Flowers',
  93011000: 'Chamelaucium  – Cut Flowers',
  93011100: 'Chrysanthemum – Cut Flowers',
  93011200: 'Cymbidium – Cut Flowers',
  93011400: 'Dahlia – Cut Flowers',
  93011500: 'Delphinium – Cut Flowers',
  93011600: 'Dianthus – Cut Flowers',
  93011700: 'Eryngium – Cut Flowers',
  93011800: 'Eustoma – Cut Flowers',
  93011900: 'Freesia – Cut Flowers',
  93012000: 'Gerbera – Cut Flowers',
  93012100: 'Gladiolus – Cut Flowers',
  93012200: 'Gypsophila – Cut Flowers',
  93012300: 'Helianthus – Cut Flowers',
  93012400: 'Hippeastrum – Cut Flowers',
  93012500: 'Hyacinthus – Cut Flowers',
  93012600: 'Hydrangea – Cut Flowers',
  93012700: 'Hypericum – Cut Flowers',
  93012800: 'Ilex – Cut Flowers',
  93012900: 'Iris – Cut Flowers',
  93013000: 'Lilium – Cut Flowers',
  93013100: 'Limonium – Cut Flowers',
  93013200: 'Matthiola – Cut Flowers',
  93013300: 'Narcissus – Cut Flowers',
  93013400: 'Ornithogalum – Cut Flowers',
  93013500: 'Cut Flowers Other',
  93013600: 'Paeonia – Cut Flowers',
  93013700: 'Phalaenopsis – Cut Flowers',
  93013800: 'Phlox – Cut Flowers',
  93013900: 'Pittosporum – Cut Flowers',
  93014000: 'Ranunculus – Cut Flowers',
  93014100: 'Rosa – Cut Flowers',
  93014200: 'Solidago – Cut Flowers',
  93014300: 'Strelitzia – Cut Flowers',
  93014400: 'Syringa – Cut Flowers',
  93014500: 'Tanacetum – Cut Flowers',
  93014600: 'Trachelium – Cut Flowers',
  93014700: 'Tulipa – Cut Flowers',
  93014800: 'Vanda – Cut Flowers',
  93014900: 'Veronica – Cut Flowers',
  93015000: 'Viburnum – Cut Flowers',
  93015100: 'Zantedeschia – Cut Flowers',
  93020000: 'Cut Greens',
  93020100: 'Agapanthus – Cut Greens',
  93020200: 'Anthurium – Cut Greens',
  93020300: 'Asparagus – Cut Greens',
  93020400: 'Aspidistra – Cut Greens',
  93020500: 'Astilbe – Cut Greens',
  93020600: 'Brassica – Cut Greens',
  93020700: 'Carthamus – Cut Greens',
  93020800: 'Corylus – Cut Greens',
  93020900: 'Crocosmia – Cut Greens',
  93021000: 'Cucumis – Cut Greens',
  93021100: 'Cucurbita – Cut Greens',
  93021200: 'Cut Greens Variety Packs',
  93021300: 'Dracaena – Cut Greens',
  93021400: 'Eucalyptus – Cut Greens',
  93021500: 'Eupatorium – Cut Greens',
  93021600: 'Fatsia – Cut Greens',
  93021700: 'Gomphocarpus – Cut Greens',
  93021800: 'Hydrangea – Cut Greens',
  93021900: 'Ilex – Cut Greens',
  93022000: 'Leucadendron – Cut Greens',
  93022100: 'Lilium – Cut Greens',
  93022200: 'Matthiola – Cut Greens',
  93022300: 'Monstera – Cut Greens',
  93022400: 'Cut Greens Other',
  93022500: 'Panicum – Cut Greens',
  93022600: 'Physalis – Cut Greens',
  93022700: 'Pittosporum – Cut Greens',
  93022800: 'Quercus – Cut Greens',
  93022900: 'Rosa – Cut Greens',
  93023000: 'Ruscus – Cut Greens',
  93023100: 'Salix – Cut Greens',
  93023200: 'Setaria – Cut Greens',
  93023300: 'Strelitzia – Cut Greens',
  93023400: 'Symphoricarpos – Cut Greens',
  93023500: 'Syringa – Cut Greens',
  93023600: 'Thlaspi – Cut Greens',
  93023700: 'Viburnum – Cut Greens',
  93023800: 'Zantedeschia – Cut Greens',
  93030000: 'Live Plants (Genus A thru G)',
  93030100: 'Aechmea – Live Plants',
  93030200: 'Aeonium – Live Plants',
  93030300: 'Agapanthus – Live Plants',
  93030400: 'Alocasia – Live Plants',
  93030500: 'Aloe – Live Plants',
  93030600: 'Alstroemeria – Live Plants',
  93030700: 'Anemone – Live Plants',
  93030800: 'Angelonia – Live Plants',
  93030900: 'Anisodontea – Live Plants',
  93031000: 'Anthurium – Live Plants',
  93031100: 'Antirrhinum – Live Plants',
  93031200: 'Argyranthemum – Live Plants',
  93031300: 'Armeria – Live Plants',
  93031400: 'Aster – Live Plants',
  93031500: 'Astilbe – Live Plants',
  93031600: 'Aubrieta – Live Plants',
  93031700: 'Begonia – Live Plants',
  93031800: 'Bellis – Live Plants',
  93031900: 'Bidens – Live Plants',
  93032000: 'Bougainvillea – Live Plants',
  93032100: 'Brachyscome – Live Plants',
  93032200: 'Brassica – Live Plants',
  93032300: 'Bromelia – Live Plants',
  93032400: 'Brugmansia – Live Plants',
  93032500: 'Calathea – Live Plants',
  93032600: 'Calibrachoa – Live Plants',
  93032700: 'Calocephalus – Live Plants',
  93032800: 'Campanula – Live Plants',
  93032900: 'Canna – Live Plants',
  93033000: 'Celosia – Live Plants',
  93033100: 'Chamaedorea – Live Plants',
  93033200: 'Chlorophytum – Live Plants',
  93033300: 'Chrysanthemum – Live Plants',
  93033400: 'Clivia – Live Plants',
  93033500: 'Cocos – Live Plants',
  93033600: 'Codiaeum – Live Plants',
  93033700: 'Cordyline – Live Plants',
  93033800: 'Coreopsis – Live Plants',
  93033900: 'Cortaderia – Live Plants',
  93034000: 'Cosmos – Live Plants',
  93034100: 'Cuphea – Live Plants',
  93034200: 'Cupressus – Live Plants',
  93034300: 'Curcuma – Live Plants',
  93034400: 'Cycas – Live Plants',
  93034500: 'Cyclamen – Live Plants',
  93034600: 'Cymbidium – Live Plants',
  93034700: 'Cyperus – Live Plants',
  93034800: 'Dahlia – Live Plants',
  93034900: 'Delphinium – Live Plants',
  93035000: 'Dendrobium – Live Plants',
  93035100: 'Dianthus – Live Plants',
  93035200: 'Dicentra – Live Plants',
  93035300: 'Dieffenbachia – Live Plants',
  93035400: 'Dorotheanthus – Live Plants',
  93035500: 'Dracaena – Live Plants',
  93035600: 'Dypsis – Live Plants',
  93035700: 'Echeveria – Live Plants',
  93035800: 'Echinacea – Live Plants',
  93035900: 'Epipremnum – Live Plants',
  93036000: 'Euphorbia – Live Plants',
  93036100: 'Euryops – Live Plants',
  93036200: 'Fargesia – Live Plants',
  93036300: 'Felicia – Live Plants',
  93036400: 'Festuca – Live Plants',
  93036500: 'Fittonia – Live Plants',
  93036600: 'Fuchsia – Live Plants',
  93036700: 'Gardenia – Live Plants',
  93036800: 'Gaura – Live Plants',
  93036900: 'Gazania – Live Plants',
  93037000: 'Gentiana – Live Plants',
  93037100: 'Gerbera – Live Plants',
  93037200: 'Guzmania – Live Plants',
  93037300: 'Gypsophila – Live Plants',
  93037400: 'Ficus – Live Plants',
  93037600: 'Castanospermum - Live Plants',
  93037700: 'Coffea - Live Plants',
  93037800: 'Dionaea - Live Plants',
  93040000: 'Live Plants (Genus H thru Z)',
  93040100: 'Hedera – Live Plants',
  93040200: 'Helianthus – Live Plants',
  93040300: 'Helichrysum – Live Plants',
  93040400: 'Heliotropium – Live Plants',
  93040500: 'Helleborus – Live Plants',
  93040600: 'Heuchera – Live Plants',
  93040700: 'Hibiscus – Live Plants',
  93040800: 'Hippeastrum – Live Plants',
  93040900: 'Hordeum – Live Plants',
  93041000: 'Hosta – Live Plants',
  93041100: 'Howea – Live Plants',
  93041200: 'Hyacinthus – Live Plants',
  93041300: 'Hydrangea – Live Plants',
  93041400: 'Impatiens – Live Plants',
  93041500: 'Jasminum – Live Plants',
  93041600: 'Kalanchoe – Live Plants',
  93041700: 'Lantana – Live Plants',
  93041800: 'Leucanthemum – Live Plants',
  93041900: 'Lewisia – Live Plants',
  93042000: 'Lilium – Live Plants',
  93042100: 'Lithodora – Live Plants',
  93042200: 'Live Plant Variety Packs',
  93042300: 'Livistona – Live Plants',
  93042400: 'Lobelia – Live Plants',
  93042500: 'Lotus – Live Plants',
  93042600: 'Lupinus – Live Plants',
  93042700: 'Mandevilla – Live Plants',
  93042800: 'Medinilla – Live Plants',
  93042900: 'Miltonia – Live Plants',
  93043000: 'Muscari – Live Plants',
  93043100: 'Myosotis – Live Plants',
  93043200: 'Narcissus – Live Plants',
  93043300: 'Nephrolepis – Live Plants',
  93043400: 'Nolina – Live Plants',
  93043500: 'Nymphaea – Live Plants',
  93043600: 'Oncidium – Live Plants',
  93043700: 'Orchis – Live Plants',
  93043800: 'Ornithogalum – Live Plants',
  93043900: 'Osteospermum – Live Plants',
  93044000: 'Live Plants Other',
  93044100: 'Pachira – Live Plants',
  93044200: 'Paeonia – Live Plants',
  93044300: 'Papaver – Live Plants',
  93044400: 'Paphiopedilum – Live Plants',
  93044500: 'Pelargonium – Live Plants',
  93044600: 'Pennisetum – Live Plants',
  93044700: 'Petunia – Live Plants',
  93044800: 'Phalaenopsis – Live Plants',
  93044900: 'Phlox – Live Plants',
  93045000: 'Phoenix – Live Plants',
  93045100: 'Platycodon – Live Plants',
  93045200: 'Plectranthus – Live Plants',
  93045300: 'Portulaca – Live Plants',
  93045400: 'Primula – Live Plants',
  93045500: 'Ranunculus – Live Plants',
  93045600: 'Rhipsalidopsis – Live Plants',
  93045700: 'Rhododendron – Live Plants',
  93045800: 'Rosa – Live Plants',
  93045900: 'Saintpaulia – Live Plants',
  93046000: 'Salvia – Live Plants',
  93046100: 'Sansevieria – Live Plants',
  93046200: 'Sanvitalia – Live Plants',
  93046400: 'Saxifraga – Live Plants',
  93046500: 'Schefflera – Live Plants',
  93046600: 'Schlumbergera – Live Plants',
  93046700: 'Sedum – Live Plants',
  93046800: 'Sempervivum – Live Plants',
  93046900: 'Senecio – Live Plants',
  93047000: 'Sinningia – Live Plants',
  93047100: 'Solanum – Live Plants',
  93047200: 'Spathiphyllum – Live Plants',
  93047300: 'Stephanotis – Live Plants',
  93047400: 'Sutera – Live Plants',
  93047500: 'Tagetes – Live Plants',
  93047600: 'Tillandsia – Live Plants',
  93047700: 'Tulipa – Live Plants',
  93047800: 'Vanda – Live Plants',
  93047900: 'Verbena – Live Plants',
  93048000: 'Viola – Live Plants',
  93048100: 'Vriesea – Live Plants',
  93048200: 'XBurrageara – Live Plants',
  93048300: 'XCitrofortunella – Live Plants',
  93048400: 'Yucca – Live Plants',
  93048500: 'Zamioculcas – Live Plants',
  93048600: 'Zantedeschia – Live Plants',
  93048700: 'Ludwigia - Live Plants',
  93048800: 'Musa - Live Plants',
  93048900: 'Peperomia - Live Plants',
  93049000: 'Pilea - Live Plants',
  93049100: 'Philodendron - Live Plants',
  93049200: 'Polyscias - Live Plants',
  93049300: 'Rhapis - Live Plants',
  93050000: 'Bulbs/Corms/Rhizomes/Tubers',
  93050100: 'Bulbs/Corms/Rhizomes/Tubers',
  93060000: 'Plants Variety Packs',
  93060100: 'Plants Variety Packs',
  93070000: 'Seeds/Spores',
  93070100: 'Seeds/Spores',
  93080000: 'Shrubs/Trees',
  93080100: 'Shrubs/Trees',
  93090000: 'Vegetables/Fungi Plants',
  93090100: 'Vegetables/Fungi Plants',
  93100000: 'Bouquets',
  93100100: 'Bouquets',
  93110000: 'Seedlings - Ready to Grow',
  93110100: 'Seedlings - Ready to Grow',
  94000000: 'Crops',
  94010000: 'Crops not for food or feed (animal and fish)',
  94010100: 'Crops for natural fibre and resins production (Fibre crops)',
  94010200: 'Crops for latex production (Latex crops)',
  94010300: 'Crops for production of natural pigments, resins and waxes',
  94010700: 'Non-toxic Plants for Medicines and Essential Oils',
  94010800: 'Toxic Plant for Medicines',
  94020000: 'Crops for Food Production',
  94020100: 'Crops for Production of Annonafruit',
  94020200: 'Crops for Production of Banana Fruit',
  94020300: 'Edible Pomefruit Crops',
  94020400: 'Edible Bulb Crops',
  94020500: 'Crops for Production of Berries and Small Fruit',
  94020600: 'Crops for Production of Citrus and Other Rutaceae Fruits',
  94020700: 'Crops for Production of Stonefruits',
  94020800: 'Crops for Production of Edible Cactusfruits',
  94020900: 'Crops for Production of Edible Fruit from Palmtrees',
  94021000: 'Crops for Production of Edible Myrtletree Fruits',
  94021100: 'Crops for Production of Edible Sumacfruits',
  94021200: 'Crops for Production of Edible Fruits from Soapberrytrees',
  94021300: 'Crops for Production of Edible Fruit from Sapote trees',
  94021400: 'Crops for Production of Edible Fruit from Phyllantaceae trees',
  94021500: 'Crops for Production of Edible Fruit from Other Trees and Plants',
  94021600: 'Crops for Production of Edible Nuts',
  94021700: 'Crops for Production of Edible Groundnuts',
  94021800: 'Crops for Beverages',
  94021900: 'Cereals and Grains Crops',
  94022000: 'Sugar Crops',
  94022100: 'Vegetable Oil-seed Crops',
  94022200: 'Brassica Vegetables (Cabbage Type)',
  94022300: 'Edible Legume Crops',
  94022400: 'Stem Vegetables',
  94022500: 'Vegetable Crops - Edible roots, Tubers and Rhizomes',
  94022600: 'Edible Funghi',
  94022700: 'Fruiting Vegetable Crops - Solanaceae',
  94022800: 'Fruiting Vegetable Crops - Squash And Gourds',
  94022900: 'Fruiting  Vegetables - Other',
  94023000: 'Leaf Vegetable Crops - Cichoryplants',
  94023100: 'Leaf Vegetable Crops - Lettuceplants',
  94023200: 'Leaf Vegetable Crops - Brassicaceae',
  94023300: 'Leaf Vegetable Crops - Spinachtype',
  94023400: 'Leaf Vegetable Crops - Other',
  94023500: 'Edible Herbs',
  94023600: 'Edible Spices',
  94030000: 'Grass and Other Crops for Animal Feed or for Soil Improvement',
  94030100: 'Graminoids (Grasses)',
  94030200: 'Crucifeira Feed Crops',
  94030300: 'Legume Feed Crops',
  94030400: 'Other Feed Crops',
  95000000: 'Services',
  95010000: 'Business and Commercial Services',
  95010100: 'Accounting Services',
  95010200: 'Advertising Services',
  95010300: 'Architectural and Engineering Service',
  95010400: 'Business Management & Consulting Services',
  95010500: 'Computer and Technology Service',
  95010600: 'Legal Services',
  95020000: 'Building Construction & Related Services',
  95020100: 'Building Construction & Related Services',
  95030000: 'Cleaning Services',
  95030100: 'Cleaning Services',
  95040000: 'Communication Services',
  95040100: 'Audio-Visual Services',
  95040200: 'Telecommunications Services',
  95050000: 'Educational & Entertainment Services',
  95050100: 'Educational Services',
  95050200: 'Entertainment Services',
  95060000: 'Energy and Environmental Services',
  95060100: 'Energy Services',
  95060200: 'Environmental Services',
  95070000: 'Financial Services',
  95070100: 'Financial Services',
  95080000: 'Packaging/Storage Services',
  95080100: 'Packaging/Storage Services',
  95090000: 'Postal Services',
  95090100: 'Postal Services',
  95100000: 'Scientific and Technological  Services',
  95100100: 'Scientific and Technological  Services',
  95110000: 'Food/Drink and Accommodation Services',
  95110300: 'Food and Drink Services',
  95110400: 'Temporary Accommodation Services',
  95120000: 'Maintenance/Repair and Installation Services',
  95120100: 'Maintenance/Repair Services',
  95120200: 'Installation Services',
  95130000: 'Medical and Beauty Care Services',
  95130100: 'Hygienic and Beauty Care Services',
  95130200: 'Medical Services',
  95130300: 'Veterinary Services',
  95140000: 'Transportation Services',
  95140100: 'Transportation Services',
  95150000: 'Travel Services',
  95150100: 'Travel Services',
  99999999: 'Temporary Classification'
}



// WEBPACK FOOTER //
// ./src/i18n/en/gpc.js